export const Descriptions = [
    {
        id: "0",
        title: "",
        text: ""
        },
    {
    id: "1",
    title: "Мындаа",
    text: "туох эмэ саамай үрдэ, арҕаһа (самая возвышенная, высокая часть чего-л.)."
    },
    {
    id: "2",
    title: "Уорҕа",
    text: "кыыл-сүөл көҕүс, иэн өттө, көхсө (спина, спинной хребет)."
    },
    {
    id: "3",
    title: "Сири иһит",
    text: "тирииттэн тигиллибит үүт аһылыкка аналлаах иһит (сосуд из выделанной кожи)."
    },
    {
    id: "4",
    title: "Сиксик",
    text: "кытыыта диэн суолтаҕа (край чего-либо)."
    },
    {
    id: "5",
    title: "Ураанай кыыл",
    text: "өлбөөркөй хара дьүһүннээх, тумсун үрдүнэн сүүһүгэр сырдык туоһахталаах кус (водяная курица, лысуха)."
    },
    {
    id: "6",
    title: "Халбалдьый",
    text: "өттүккүнэн, самыыгынан хамсанан хаамп (ходить, двигая бедрами, покачиваясь)."
    },
    {
    id: "7",
    title: "Сылаанньыйбат",
    text: "көспүт суолтаҕа: сымнаабат (в перенос. знач. не становится мягче)."
    },
    {
    id: "8",
    title: "Ньыгыл",
    text: "биир кэлим тыйыс, кытаанах оҥоһуулаах (твердый, крепкий, плотный)."
    },
    {
    id: "9",
    title: "Тэлгэлдьийбэт",
    text: "тэлгэммэт, тэнийбэт, ыһыллыбат (не растилается, не может быть разложен)."
    },
    {
    id: "10",
    title: "Сиэмэлэс мас",
    text: "талах мас арааһа (жимолость)."
    },
    {
    id: "11",
    title: "Сиибиктэ",
    text: "ойуур саҕатыгар күлүк сиргэ үүнэр, хойуу соҕус лабаалардаах, сүөһү сөбүлээн сиир намчы боруута (ветвистый нежный вид хвоща, растущий по опуш-кам леса в тени и отличающийся питательностью для скота, хвощ пёстрый)."
    },
    {
    id: "12",
    title: "Түһүлгэ",
    text: "ыһыахтыыр түһүлгэ курдук төгүрүк (круглый, как место для проведения ысыаха)."
    },
    {
    id: "13",
    title: "Олбох",
    text: "олорор сиргэ уурар, тэлгиир  сымнаҕас  тэллэх  (подстилка для сиденья)."
    },
    {
    id: "14",
    title: "Ситии",
    text: "сылгы сиэлинэн хатыллыбыт синньигэс быа (тонкая веревка, витая из конского грива)."
    },
    {
    id: "15",
    title: "Иилээх-саҕалаах",
    text: "Орто дойдуну хоһуйарга туттуллар кубулуйбат эпитет (эпитет, используемый при описании Срединной земли). "
    },
    {
    id: "16",
    title: "Атааннаах-мөҥүөннээх",
    text: "охсуһуулаах, түрбүөннээх, иирээннээх, аймалҕаннаах (беспокойный, тревожный, полный раздоров, борьбы)."
    },
    {
    id: "17",
    title: "Алы-намык",
    text: "сымнаҕас майгылаах, амарах (с мягким характером, милостливый)."
    },
    {
    id: "18",
    title: "Айгыр силик",
    text: "сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)."
    },
    {
    id: "19",
    title: "Очуос",
    text: "утёс.   "
    },
    {
    id: "20",
    title: "Олоор-молоор",
    text: "ол-бу диэки эргиччи көр (смотреть по сторонам туда-сюда). "
    },
    {
    id: "21",
    title: "Арылхай",
    text: "киэҥ, ыраас, сырдык (харах туһунан) (большие, ясные светлые (о глазах)."
    },
    {
    id: "22",
    title: "Кэнэҕэски",
    text: "кэлин, хойут кэлиэхтээх, баар буолухтаах (будущий, грядущий)."
    },
    {
    id: "23",
    title: "Мэтэлдьий",
    text: "түөскүн мөтөтөн хаамп (ходить, выпятив грудь)."
    },
    {
    id: "24",
    title: "Бэрдьигэс мас",
    text: "саҥа үүнэн эрэр мас (низкорослое деревце, лес)."
    },
    {
    id: "25",
    title: "Кылбаҕар",
    text: "мап-маҕан, ып-ыраас (сияющий белезной, без единого пятнышка)."
    },
    {
    id: "26",
    title: "Кынталлыбыт",
    text: "төбөтүн чоноччу туттан, моонньутун уһатан, үрдээн чынайан көстөр (быть стройным, с высоко, горделиво поднятой головой)."
    },
    {
    id: "27",
    title: "Кылдьыылаах",
    text: "хараҕар биилээх (складки на верхних веках)."
    },
    {
    id: "28",
    title: "Кырыымпа",
    text: "саха национальнай смычковай музыкальнай тэрилэ (якутский национальный музыкальный смычковой инструмент, по форме напоминающий скрипку)."
    },
    {
    id: "29",
    title: "Кытаахтаа",
    text: "тугу эмэ кыраны тутан ыл (хватать, захватывать что-либо мелкое). "
    },
    {
    id: "30",
    title: "Кырпа",
    text: "кылгас, бытархай уонна убаҕас үүнүүлээх от (короткая, мелкая и редкая трава)."
    },
    {
    id: "31",
    title: "Кыйдам маҕан",
    text: "ыраас, мап-маҕан (чистый, белоснежный)."
    },
    {
    id: "32",
    title: "Кырдал",
    text: "дэхси, хотоол сиргэ үрдээн тахсыбыт сэдэх оттоох кураанах хонуу сир (ровная возвышенная сухая полоса на поле, на сенокосном угодье с небольшим травостоем)."
    },
    {
    id: "33",
    title: "Дуодалын",
    text: "ордук уһаан, үрдээн көһүн (быть, казаться чересчур вытянутым). "
    },
    {
    id: "34",
    title: "Дьоҥхоҕор",
    text: "уһун синньигэс, үрдүк көнө (высокий, стройный, долговязый)."
    },
    {
    id: "35",
    title: "Чоккуруос",
    text: "cырдык, туртаҕай (сылгы хараҕын туһунан) (светлый, беловатый (о глазах лошади))."
    },
    {
    id: "36",
    title: "Сомоҕо көмүс",
    text: "бүтүннүү үрүҥ көмүс (цельное серебро)."
    },
    {
    id: "37",
    title: "Хормуоньньа",
    text: "гармонь."
    },
    {
    id: "38",
    title: "Дуокарыс гын = токурус гын",
    text: "өҕүлүн, дугалыы быһыылаах буол (гнуться, сгибаться; изгибаться, кривиться)."
    },
    {
    id: "39",
    title: "Дьулаагыр маҕан",
    text: "биир күрүс маҕан (совсем белый, белоснежный). "
    },
    {
    id: "40",
    title: "Толоон",
    text: "киэҥ, нэлэмэн сир, сыһыы (равнинная долина, луг, поляна)."
    },
    {
    id: "41",
    title: "Босуом",
    text: "фасон"
    },
    {
    id: "42",
    title: "Буолунай",
    text: "полный."
    },
    {
    id: "43",
    title: "Быйаҥнаах",
    text: "өлгөм оттоох (обильный травостой)."
    },
    {
    id: "44",
    title: "Дьаарбаҥ",
    text: "дьиэ сүөһүтэ мэччийэр, аһыыр сирэ (место, где пасется скот, кормятся животные, пастбище)."
    },
    {
    id: "45",
    title: "Буолатынан",
    text: "волей."
    },
    {
    id: "46",
    title: "Илэ-бодо",
    text: "кистэммэккэ, саспакка, аһаҕастык (не таясь, не скрываясь, открыто)."
    },
    {
    id: "47",
    title: "Иэримэ",
    text: "төрөөбүт-үөскээбит (родной)."
    },
    {
    id: "48",
    title: "Ала-бааччы",
    text: "харахха быраҕыллар, көстөн турар (очевидно, в самом деле, действительно)."
    },
    {
    id: "49",
    title: "Ахталый",
    text: "атахтаргын аччаччы быраҕан дьоһумсуйбуттуу аа-дьуо ыараханнык хаамп (шагать тяжело, медленно на широко раставленных ногах, с претензией на собственную важность). "
    },
    {
    id: "50",
    title: "Тунаарыкта",
    text: "ыраахтан тунаарыйан, кылбайан көстөр диэн суолтаҕа туттуллубут сир аата (название местности, исходящее от его неясно белеющего цвета)."
    },
    {
    id: "51",
    title: "Кылбаарыкта",
    text: "ыраахтан кылбайан, күлүмүрдээн көстөр диэн суолтаҕа туттуллубут сир аата (название местности, исходящее от его блестающего, сверкающего цвета)."
    },
    {
    id: "52",
    title: "Кэрискэ",
    text: "кэккэлии эбэтэр субуруччу туруу; бииртэн-биир субурҕа, кэккэ буолан көстүү (выстраиваться в ряд, рядами, шеренгами; тянуться ровными  рядами)."
    },
    {
    id: "53",
    title: "Кулуба",
    text: "өрөбөлүүссүйэ иннинэ Саха сиригэр улуус быыбардаммыт баһылыга (до революции в Якутии улусный голова)."
    },
    {
    id: "54",
    title: "Куруҥ",
    text: "өрт уотугар умайбыт тыа (выжженный лес)."
    },
    {
    id: "55",
    title: "Хампа",
    text: "канфа (китайский шелк)."
    },
    {
    id: "56",
    title: "Баара",
    text: "пара."
    },
    {
    id: "57",
    title: "Лагладьдьый",
    text: "түргэнник хаамп (идти, двигаться быстро)."
    },
    {
    id: "58",
    title: "Алла тур",
    text: "өлгөмнүк, дэлэйдик өрө дэбэлийэ тур, бараммакка кутулла тур (появляться, как бы извергаться в изобилии, быть неиссекаемым и обильным)."
    },
    {
    id: "59",
    title: "Арыы чаллаах чараҥ",
    text: "алаас ортотугар үөскээбит кыччыгый хатыҥ чараҥ (лесок посреди поляны из низкорослых ветвистых берез)."
    },
    {
    id: "60",
    title: "Кэҥкэй",
    text: "киэҥ, аппаҕар буолан көһүн (быть широко открытым, зиять бездной)."
    },
    {
    id: "61",
    title: "Кэриҥнэнэн",
    text: "быһыылан, киэптэн (иметь какую-либо форму)."
    },
    {
    id: "62",
    title: "Мотуок уута",
    text: "улахан халаан уута (большой паводок)."
    },
    {
    id: "63",
    title: "Боҕуска",
    text: "туох эмэ оҥоһукка, саха таҥаһыгар тигиллэр, биитэр иҥиннэриллэр киэргэл (украшение, отделка якутского наряда или какого-либо изделия).  "
    },
    {
    id: "64",
    title: "Тарыҥ уута",
    text: "кыһын сир анныттан тахсан халыйар уу, ол уу тоҥон муус буолуута (вода, выступающая поверх льда, а также слой льда, образовавшаяся из этой воды, наледь)."
    },
    {
    id: "65",
    title: "Дьайыҥ",
    text: "туох эмэ ойоҕоһо, тас кытыыта, бүтэр уһуга (бок, боковая сторона, край, конец чего-либо)."
    },
    {
    id: "66",
    title: "Туут хайыһар",
    text: "таба илин тыһынан бүрүллэр кэтит хайыһар (старинные большие лыжи, подбитые шкурой с передних лап оленя)."
    },
    {
    id: "67",
    title: "Хабырыс",
    text: "сиирэ хапсан, таарыйсан аас (задевать друг друга вскользь, сталкиваться)."
    },
    {
    id: "68",
    title: "Чугуй",
    text: "инниҥ диэки баран иһэн төттөрү түс, кэннигинэн бар (пятиться, отступать, отходить назад)."
    },
    {
    id: "69",
    title: "Дуолан",
    text: "муҥутуур улахан, сүүнэ улахан (громадный, огромный). "
    },
    {
    id: "70",
    title: "Күрдьүөттээ",
    text: "харсаары эбэтэр кэйээри суоһурҕанан муостаргын тоһуй (принимать угрожающую позу, сердито коситься, выставляя рога). "
    },
    {
    id: "71",
    title: "Саар булгунньах",
    text: "үрдүгүнэн орто, гынан баран киэҥ, кэтит булгунньах (курган небольшой по высоте, но с широким основанием)."
    },
    {
    id: "72",
    title: "Суксурус",
    text: "инники-кэнники буолан субуруһан туруҥ (распологаться друг за другом)."
    },
    {
    id: "73",
    title: "Күннүк",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "74",
    title: "Көс",
    text: "сахалыы уста кээмэйэ, ортотунан 10 килэмиэтир ыраахха тэҥнэһэр (якутская мера длины, равная в среднем 10 км)."
    },
    {
    id: "75",
    title: "Дьулай",
    text: "туох эмэ үрдээн  көстөөччү саамай  төбөтө,  оройо (верхушка,  макушка  чего-л.)."
    },
    {
    id: "76",
    title: "Туораах",
    text: "бурдук сиэмэтэ, аһа (плод, семя хлебных злаков, зерно)."
    },
    {
    id: "77",
    title: "Дьапта көмүс",
    text: "чиҥ, араҥа үрүҥ көмүс (плотный, серебряный пласт)."
    },
    {
    id: "78",
    title: "Аалыы көмүс",
    text: "килбэҥнэс, чаҕылыҥнас сырдык үрүҥ көмүс (блестящее, сверкающее серебро)."
    },
    {
    id: "79",
    title: "Саатаа",
    text: "аралдьыйар курдук тугу эмэ гын, тугунан эмэ санааҕын аралдьыт (развлекаться, забавляться чем-либо)."
    },
    {
    id: "80",
    title: "Бочугурас",
    text: "кыра, эриэҥниҥи бороҥ дьүһүннээх мас көтөрө (рябчик)."
    },
    {
    id: "81",
    title: "Томторҕо",
    text: "сэргэ ойуута (утолщение между кольцеобразными зарубками коновязи). "
    },
    {
    id: "82",
    title: "Чороон ымыйа",
    text: "кэритэн иһэргэ аналлаах чороон (старинная круговая чаша для кумысопития)."
    },
    {
    id: "83",
    title: "Лоһуор көмүс",
    text: "туох эмэ ыарахан уус тэрилинэн кытаанахтык таптыллан оҥоһуллубут үрүҥ көмүс (Серебро, обработанное посредством битья и ударов тяжелым кузнечным орудием)."
    },
    {
    id: "84",
    title: "Араҥас илгэ",
    text: "былыргы өйдөбүлүнэн үөһээ айыылартан бэриллэр үрүҥ ас-үөл, үүт-арыы дэлэйиитэ (по старинному поверью, изобилие молочных продуктов, ниспосланное добрыми духами)."
    },
    {
    id: "85",
    title: "Чаллырҕаччы",
    text: "чаллыргыыр тыастаахтык (с хлюпающими, чавкающими звуками)."
    },
    {
    id: "86",
    title: "Сөҥ",
    text: "хойуу, иҥэмтэлээх (густой, питательный)."
    },
    {
    id: "87",
    title: "Чөллүргэччи",
    text: "хойуутук, дэлэйдик таммалыыр убаҕаһы этэргэ (о какой-либо жидкости, часто, густо и обильно капающем).  "
    },
    {
    id: "88",
    title: "Хаардаах бугул саҕа",
    text: "сахалар улахан, бөдөҥ көстүүлээх кими, тугу эмэ ойуулаан-дьүһүннээн этэллэригэр туттуллар халбаҥнаабат холбоһук (образное описание кого-чего либо крупных размеров). "
    },
    {
    id: "89",
    title: "Сииктэ",
    text: "төрдө-төбөтө (начало)."
    },
    {
    id: "90",
    title: "Болбукта",
    text: "намыһах умнастаах, хойуу мутукчалаах, киһи сиир эриэхэлээх бэс бииһэ үүнээйи (кедровый стланик)."
    },
    {
    id: "91",
    title: "Муҥутаа",
    text: "толору, тиһэҕэр тиийэ сит, улаат, сайын, тэний (достигать наивысшей точки развития, полного расцвета)."
    },
    {
    id: "92",
    title: "Үөр",
    text: "биир көрүҥнээх көтөр, сүүрэр элбэх буолан сылдьар бөлөҕө (группа животных, птиц одного вида: стая, стадо, табун, косяк)."
    },
    {
    id: "93",
    title: "Аартык",
    text: "олоҥхоҕо үс дойдуну ситимниир улахан айан суолларыттан биирдэстэрэ (в олонхо один из волшебных проходов, соединяющих три мира). "
    },
    {
    id: "94",
    title: "Өрөҕө",
    text: "хамсыыр харамай иһин тириитэ (брюшка, брюшина)."
    },
    {
    id: "95",
    title: "Өндөл маҕан халлаан",
    text: "үрдүк, сырдаан көстөр халлаан (высокое белое небо)."
    },
    {
    id: "96",
    title: "Үлүскэн",
    text: "үгүс, элбэх, сүүнэ улахан (многочисленный, большой, обильный)."
    },
    {
    id: "97",
    title: "Биис ууһа",
    text: "биир тыллаах-өстөөх, уопсай олохтоох-дьаһахтаах, олорор чопчу сирдээх уруулуу дьон холбоһуга (Племя)."
    },
    {
    id: "98",
    title: "Саньылҕа = санньылҕа",
    text: "санаарҕабыллаах, санаа түһүүлээх, курус; күүһэ-күүрээнэ суох, мунчаарыылаах, муҥкук (унылый, грустный, печальный, поникший)."
    },
    {
    id: "99",
    title: "Талаһа = далаһа",
    text: "ууга киирэргэ үктэл гынар мас (мостки у берега водоема, с которых черпают воду)."
    },
    {
    id: "100",
    title: "Күргэ",
    text: "далаһа (мост)."
    },
    {
    id: "101",
    title: "Хорообуска",
    text: "аллитерация көмөтүнэн үөскээбит хонуу аата (название поляны, подобранное согласно принципу аллитерации). "
    },
    {
    id: "102",
    title: "Үөрбэ долоҕодоһун",
    text: "боотур кыргыһыыга туттар уһун, улахан быһаҕа (богатырское боевое оружие: большой длинный нож)."
    },
    {
    id: "103",
    title: "Үҥүү",
    text: "уһун мас уктаах, икки өттүттэн биилээх кыргыһыыга туттуллар тимир сэрии сэбэ (копье, пика)."
    },
    {
    id: "104",
    title: "Батас",
    text: "көнө өнчөхтөөх, мөтөгөр биилээх былыргы сэрии сэбэ (древнее воинское оружие: пальма с прямой спинкой и дугообразной лезвией). "
    },
    {
    id: "105",
    title: "Саа-саадах",
    text: "былыргы саха ытар тэрилэ: ох саата, саатын хаата, ытар охторо, охторун хаата (старинный якутский лук со всеми принадлежностями: чехлом, колчаном со стрелами). "
    },
    {
    id: "106",
    title: "Иҥсэ төрдө",
    text: "олус сииргэ-аһыырга баҕардар куһаҕан тыын (злой дух, способствующий чрезмерной жадности, обжорству)."
    },
    {
    id: "107",
    title: "Обот иччитэ",
    text: "иҥсэ иччитэ (дух жадности)."
    },
    {
    id: "108",
    title: "Идэмэр",
    text: "иҥсэ, обот (жадность, алчность). "
    },
    {
    id: "109",
    title: "Сөмүйэ",
    text: " киһиэхэ илиитин эрбэҕиттэн иккис тарбаҕа (указательный палец)."
    },
    {
    id: "110",
    title: "Үөдэн-таһаан",
    text: "алдьаммыт-кээһэммит, ыһыллыбыт-тоҕуллубут, күөрэ-лаҥкы барбыт (превращаться в беспорядок, хаос).  "
    },
    {
    id: "111",
    title: "Кырыыс-таныар",
    text: "кимиэхэ эмэ куһаҕаны, өлүүнү-сүтүүнү баҕаран ыарахан тыллары этии (проклятие, заклятие)."
    },
    {
    id: "112",
    title: "Сиэр сылгы",
    text: "бэйэтэ кугастыҥы дьүһүннээх гынан баран, сиэлэ, кутуруга хара ардайдаах сылгы (саврасый конь). "
    },
    {
    id: "113",
    title: "Сиэл күрүҥ аартык",
    text: "сылгы сиэлэ ыйаммыт хараҥа кыһыллыҥы дьүһүннээх аартык (проход темно-красного цвета, где повешаны конские волосы).   "
    },
    {
    id: "114",
    title: "Эрэдэһин",
    text: "эриллэн оҥоһуллубут диэн суолтаҕа (крученый). "
    },
    {
    id: "115",
    title: "Дьуолка",
    text: "ханан барыллыахтааҕы бэлиэтиир, көрдөрөр сиргэ, хаарга анньыллыбыт мас (палка, воткнутая в землю, указывающая нужное направление пути; веха)."
    },
    {
    id: "116",
    title: "Далбар",
    text: "кими эмэ күндүлээн-маанылаан көрсүү (сердечный прием с обильным угощением).  "
    },
    {
    id: "117",
    title: "Дьөллүргэ",
    text: "туох эмэ мэһэй буолара (помеха, обуза)."
    },
    {
    id: "118",
    title: "Алаһа",
    text: "төрөөбүт-үөскээбит дьиэ-уот (родной дом, родная обитель, родной очаг)."
    },
    {
    id: "119",
    title: "Нуоҕай",
    text: "бэргэһэ оройуттан намылыйан дугалыы түспүт куорсун эбэтэр түү (перо, висящее дугой на верхушке, макушке шапки)."
    },
    {
    id: "120",
    title: "Кылаан",
    text: "туох эмэ үрдүкү чыпчаала, өрөгөйө (пик, вершина, острие)."
    },
    {
    id: "121",
    title: "Көхө",
    text: "саха балаҕаныгар таҥаһы, малы ыйыыр анал оҥоһуулаах бөҕө мас тоһоҕо (прочный деревянный гвоздь, на который вешается одежда и другие предметы домашнего обихода, вешалка).  "
    },
    {
    id: "122",
    title: "Түһүлгэ",
    text: "дьон тохтоон, түһүүлэммит, быстах олохсуйбут сирэ (место обитания, становище, стойбище)."
    },
    {
    id: "123",
    title: "Бирээмэ",
    text: "время."
    },
    {
    id: "124",
    title: "Байтаһын",
    text: "сайын устата көҥүл сылдьыбыт, төрөөбөтөх сүөһү (откормленный, нагулявший жир за лето скот)."
    },
    {
    id: "125",
    title: "Сахсаччы",
    text: "сахсайа сылдьар гына (так, чтобы взбилась пена)."
    },
    {
    id: "126",
    title: "Үрүмэтийбэт",
    text: "үрүмэнэн бүрүллүбэт (не затягивается пенкой). "
    },
    {
    id: "127",
    title: "Арылы чэлгиэ алаастар",
    text: "сырдык, ыраас, силигилии, муҥутуу көҕөрбүт алаастар (светлые, ясные, покрытые зеленью алаасы)."
    },
    {
    id: "128",
    title: "Тыы",
    text: "кыра, чэпчэки мас устар аал (маленькая, ленкая деревянная лодка)."
    },
    {
    id: "129",
    title: "Тылбыҥнаа",
    text: "ким эмэ диэки үчүгэмсийэн, үтүөмсүйэн хараххын кыаратан көрүтэлээ (кокетливо, игриво посматривать на кого-либо из-под опущенных век)."
    },
    {
    id: "130",
    title: "Илим",
    text: "кылтан тэҥ харахтардаах гына баайыллыбыт балыктыыр тэрил (рыболовная сеть)."
    },
    {
    id: "131",
    title: "Илбирээ = илибирээ",
    text: "чэпчэкитик, түргэн-түргэнник, төттөрү-таары охсуллан хамсаа (трепетать, подрагивать)."
    },
    {
    id: "132",
    title: "Туу",
    text: "маһы синньигэс гына тыыран (эбэтэр талаҕы) өрөн оҥоһуллар, күөлгэ, үрэххэ уган балыгы бултуур тэрил (рыболовная снасть, сплетенная из лыка, деревянных пластин и прутьев в виде узкой воронкообразной корзины, верша)."
    },
    {
    id: "133",
    title: "Чуоҕуй",
    text: "ханна эмэ муһун, элбэх буолан тоҕуоруй (собираться, сходиться, скучиваться где-либо)."
    },
    {
    id: "134",
    title: "Ардьаах",
    text: "сонос соҕус мастарынан өрүллүбүт собоҕо уонна атын бөдөҥ балыкка аналлаах туу (большая верша, морда для ловли карася и другой крупной рыбы)."
    },
    {
    id: "135",
    title: "Атырдьах туйахтаах",
    text: "ынах сүөһүнү бэлиэтиир кубулуйбат эпитет (постоянный эпитет для обозначения крупного рогатого скота)."
    },
    {
    id: "136",
    title: "Суҥ иһэгэй",
    text: "сүөһү түүлээбит түүтэ иирсибитэ, мөчөхтөспүтэ (свалявшийся, спутанный комок шерсти от линьки животных)."
    },
    {
    id: "137",
    title: "Анах сүөһү",
    text: "ынах сүөһү (крупный рогатый скот)."
    },
    {
    id: "138",
    title: "Сыспай сиэллээх",
    text: "сылгы сүөһү, сылгы сыыйыллаҕас уһун сиэллээҕин хоһуйан этии (лошадь, табун лошадей, букв. животное с длинной, ниспадающей густой гривой)."
    },
    {
    id: "139",
    title: "Халаана суох",
    text: "аата-ахсаана суох, олус элбэх диэн суолтаҕа (бесчисленный, многочисленный)."
    },
    {
    id: "140",
    title: "Үс саха",
    text: "саха диэн ааттаах барыта (Якуты, якутский народ)."
    },
    {
    id: "141",
    title: "Ньохчой",
    text: "бөгдьөллөн, накыйан аччаан хаал (становиться сгорбленным, осевшим)."
    },
    {
    id: "142",
    title: "Ньөкөрүй = ньөкөй",
    text: "үөһээ өттүгүн төҥкөччү тутун (пригнуться, согнуться, наклониться)."
    },
    {
    id: "143",
    title: "Марай",
    text: "күүрэҥҥин түөскүн мөтөт, кэтит, киппэ түөстээх буолан көһүн (выпячивать грудь при ходьбе, беге)."
    },
    {
    id: "144",
    title: "Соххор-доҕолоҥ",
    text: "аҥаар харахтаах атах ыарыһах киһи (человек ослепший на один глаз и с больной ногой)."
    },
    {
    id: "145",
    title: "Чаабырҕаа",
    text: "тохтообокко элбэҕи саҥар (много говорить о чем-либо). "
    },
    {
    id: "146",
    title: "Чыккымай",
    text: "сиэрэй өҥнөөх, кынатыгар күөх куорсуннардаах кыра соҕус кус (чирок)."
    },
    {
    id: "147",
    title: "Маатырҕаа",
    text: "маат-маат диэн саҥар (крякать)."
    },
    {
    id: "148",
    title: "Көҕөн",
    text: "саас эрдэ кэлэр бөдөҥ кураанах кус (кряква)."
    },
    {
    id: "149",
    title: "Кыыбырҕаа",
    text: "аһыҥа, көтөр кынатын тыаһыгар маарынныыр тыаһы таһаар (издавать мягкий, стрекочущий звук, стрекотать)."
    },
    {
    id: "150",
    title: "Чуубурҕаа",
    text: "“чууп-чууп” дииргэ маарынныыр синньигэс саҥаны таһаар (издавать высокие пищащие звуки, пищать. попискивать)."
    },
    {
    id: "151",
    title: "Сарт",
    text: "элиэҕэ майгынныыр эрээри арыый кыра, тыҥырахтаах сиэмэх көтөр (хищная птица из семейства ястребиных, похожая на коршуна, но меньшая по размерам, канюк, сарыч)."
    },
    {
    id: "152",
    title: "Элиэ",
    text: "күрэҥ дьүһүннээх, кыра кыыл-сүөл аһылыктаах, үөһэнэн эргийэ сылдьан элиэтиир идэлээх, тыҥырахтаах сиэмэх көтөр (коршун)."
    },
    {
    id: "153",
    title: "Бараах",
    text: "уһун синньигэс атахтаах, уһун тумустаах, сиэнэр эттээх кыра хонуу көтөрө (кулик полевой)."
    },
    {
    id: "154",
    title: "Көнчөх",
    text: "сайын устата уойбут кус (жирная утка, упитанная на воле за лето)."
    },
    {
    id: "155",
    title: "Үрүҥ илгэ",
    text: "былыргы саха өйдөбүлүнэн: күүс-уох киллэрэр, уйгу-быйаҥ төрдө булдар таҥара биэрэр аптаах сөлөгөйө (дар богов, дающее силу и богатство, божественная благодать, божественный сок)."
    },
    {
    id: "156",
    title: "Дьуоҕа",
    text: "түгэҕэ биллибэт оборчо бадараан (глубокое топкое болото)."
    },
    {
    id: "157",
    title: "Биттэх",
    text: "тугу эмэ туттарар туора мас, туорай, ии (перекладина, скрепа, прочно соединяющая части чего-либо)."
    },
    {
    id: "158",
    title: "Кэйбэлдьийбэт кэй бараан",
    text: "барыларыттан эрэ чыҥха, саамай үчүгэй, хамсаабат дойду (самая лучшая, выделяющаяся неподвижная страна). "
    },
    {
    id: "159",
    title: "Тоноҕос эриэн",
    text: "тоноҕоско майгылыыр саха оһуорун көрүҥэ (вид якутского орнамента, напоминающий позвонки)."
    },
    {
    id: "160",
    title: "Элэҥнээ",
    text: "түргэнник төттөрү-таары бар-кэл, элэгэлдьий (носиться, двигаться снова туда-сюда)."
    },
    {
    id: "161",
    title: "Барыҥнаа",
    text: "борук-сорукка, хараҥаҕа омооно эрэ буолан, чуолкайа суохтук көһүн (двигаться, едва виднеясь в темноте)."
    },
    {
    id: "162",
    title: "Сүөдэҥнээ",
    text: "аа-дьуо икки өттүгэр иэҕэҥнээн, бытааннык хаамп (идти, двигаться медленно, неторопливо, слегка переваливаясь с боку на бок)."
    },
    {
    id: "163",
    title: "Үөлэс",
    text: "саха көмүлүөк оһоҕун буруо, төлөн тахсар турбата (дымовая труба камелька – якутской печи)."
    },
    {
    id: "164",
    title: "Арбаҕас",
    text: "түүтэ элэйбит, холто буолан эрэр саҕынньах (облезлая ветхая доха с полинявшим мехом)."
    },
    {
    id: "165",
    title: "Адаҕа",
    text: "ыар буруйдаахтарга кэтэрдэр ыарахан мас боҕуу (арестантские колодки; кандалы)."
    },
    {
    id: "166",
    title: "Дьүлэй",
    text: "сатаан истибэт буолбут киһи (глухой)."
    },
    {
    id: "167",
    title: "Сыҥсаар",
    text: "сыыҥка эбэтэр сындалҕаннаах дьарҕа ыарыы, арҕах (цинга или изнуряющая хроническая болезнь)."
    },
    {
    id: "168",
    title: "Күн улууһа",
    text: "айыы аймахтара олорор сирдэрэ, Орто дойду (место где живут люди племени айыы, Срединный мир)."
    },
    {
    id: "169",
    title: "Айыы ууһа",
    text: "айыы хаан аймахтара (племя людей айыы)."
    },
    {
    id: "170",
    title: "Буус",
    text: "муус (лед)."
    },
    {
    id: "171",
    title: "Аҕа ууһа",
    text: "биир өбүгэлэртэн төрүттээх, хас да ийэ ууһун холбуур улахан уус (род, происходящий из нескольких ийэ ууһа, большая семья: основная единица якутского самоуправления)."
    },
    {
    id: "172",
    title: "Айаҕымсах",
    text: "иҥсэлээх, олус аһас диэн суолтаҕа (жадный, обжора)."
    },
    {
    id: "173",
    title: "Ийэ ууһа",
    text: "аҕа ууһун сороҕо: биир удьуор аймахтыы дьон (материнский род)."
    },
    {
    id: "174",
    title: "Иҥсэ",
    text: "аһыахха-сиэххэ наһаа баҕарыы (чрезмерное стремление, желание есть, жадность, обжорство)."
    },
    {
    id: "175",
    title: "Обот",
    text: "иҥсэ көбүүтэ, аһара иҥсэрии (обжорство, ненасытность, чрезмерное желание есть)."
    },
    {
    id: "176",
    title: "Сэт-сэлээн",
    text: "сахаларга былыргы өйдөбүлүнэн, туох эмэ айыыны, улахан алҕаһы, куһаҕаны оҥордоххо, мүччүрүйбэт, төлөрүйбэт иэстэбил (расплата за неблаговидные деяния, возмездие, кара). "
    },
    {
    id: "177",
    title: "Сэмэ-суҥха",
    text: "сыыһа быһыыланыыны буруйга, эппиэккэ тардыы, хомуруйуу (порицание, выговор, осуждение)."
    },
    {
    id: "178",
    title: "Күрдьүк",
    text: "хаар күрдьүллэн мунньуллубута (куча снега, сугроб)."
    },
    {
    id: "179",
    title: "Далла",
    text: "кыра кээмэйдээх ураһа (малая ураса)."
    },
    {
    id: "180",
    title: "Бырта",
    text: "сүөһү иһин сыата (паховый жир скота)."
    },
    {
    id: "181",
    title: "Быраан",
    text: "мыраан (земляная гора)"
    },
    {
    id: "182",
    title: "Харта",
    text: "сылгы суон оһоҕоһун буһаран астаныллыбыта (блюдо приготовленное из конской толстой кишки)."
    },
    {
    id: "183",
    title: "Иэдьэгэй",
    text: "үүт ас көрүҥэ (творог) "
    },
    {
    id: "184",
    title: "Эрбэһин",
    text: "сыыс от (сорная трава)."
    },
    {
    id: "185",
    title: "Сүүмэх",
    text: "туох эмэ утах курдук  уһун,  синньигэс,  бэйэ-бэйэтин кытта  холбоспута,  холбуу  тутуллубута (пучок)."
    },
    {
    id: "186",
    title: "Тураҥ",
    text: "буор арааһа (солончак)."
    },
    {
    id: "187",
    title: "Үргүнньэх",
    text: "сүрэх, сүөһү сүрэҕин суута, бүрүөтэ (околосердечная сумка, перикард). "
    },
    {
    id: "188",
    title: "Киргил",
    text: "хара дьүһүннээх, төбөтүгэр кыһыллаах, мас үөнүн тоҥусуйан аһыыр көтөр (черный дятел, желна)."
    },
    {
    id: "189",
    title: "Тоҥсоҕой",
    text: "эриэн эбэтэр саадьаҕай дьүһүннээх, оройугар кыһыллаах, маһы тоҥсуйан үөнүнэн аһылыктанар кыра көтөр (дятел)."
    },
    {
    id: "190",
    title: "Кукаакы",
    text: "бэйэтэ бороҥ дьүһүннээх, күрэҥ бастаах, кугас кынаттаах, кутуруктаах дьоҕус, ойуур көтөрө (кукша, вид сойки). "
    },
    {
    id: "191",
    title: "Соноҕос сылгы",
    text: "үстээх-түөртээх атыыр эбэтэр аттаммыт сылгы (молодой жеребец трех-четырех лет или выхолощенный конь)."
    },
    {
    id: "192",
    title: "Кытыт сылгы",
    text: "иккилээх-үстээх биэ (молодая кобылица двух-трех лет)."
    },
    {
    id: "193",
    title: "Кунан",
    text: "үстээх-түөртээх оҕус (молодой бык трех-четырех лет)."
    },
    {
    id: "194",
    title: "Бүлгүн",
    text: "окумал уҥуоҕа сарын хаптаҕайын уонна хомурҕан уҥуоҕун кытта холбоһор сирэ, сарын кырыыта (плечевое соединение). "
    },
    {
    id: "195",
    title: "Хоҥоруу = хоҥуруу",
    text: "мурун  кырыыта, сиһэ (переносица). "
    },
    {
    id: "196",
    title: "Маҕана",
    text: "баҕана (столб)."
    },
    {
    id: "197",
    title: "Сатанах",
    text: "былыр дьиэҕэ, дьиэ таһыгар туруорар ону-маны иилэ быраҕан ыйыырга аналлаах үөһээ өттүгэр сараҕар мутуктардаах баҕана (в старину: столб в якутской юрте или во дворе перед домом из бревна, на котором в верхней части оставлены обрезанные сучья для вешания грубых вещей, старинная вешалка). "
    },
    {
    id: "198",
    title: "Төлкө",
    text: "инники анал, дьылҕа, кэскил (судьба, участь, предназначение)."
    },
    {
    id: "199",
    title: "Сайылык",
    text: "сайын олорор сир, дьиэ-уот (летнее жилище, летник)."
    },
    {
    id: "200",
    title: "Титиик",
    text: "сайын ынаҕы ыырга аналлаах тутуу (летний хлев)."
    },
    {
    id: "201",
    title: "Элэмэс сылгы",
    text: "эриэн дьүһүннээх сылгы (пегий, пятнистый, пестрый конь)."
    },
    {
    id: "202",
    title: "Эбир-дуоссун",
    text: "биир кэлим буолбатах, сорох өттүнэн хараҥатыйан, сороҕор сырдаан көстөр быһыттаҕас былыттар бөлөхтөрө (перисто-кучевые облака)."
    },
    {
    id: "203",
    title: "Ииччимэр = ииччигэн",
    text: "күөхтүҥү тэтэркэй сибэккилээх, ииччэх-бааччах курдук хойуу, эриллэн үүнэр сыыс от (вьюнок)."
    },
    {
    id: "204",
    title: "Таалыйа = таала",
    text: "кытаанах сирдээх кураанах дэхси киэҥ хонуу (равнина с твердой сухой поверхностью)."
    },
    {
    id: "205",
    title: "Оҕоруктаах",
    text: "кубулҕаттаах, угаайылаах (хитрый, коварный)."
    },
    {
    id: "206",
    title: "Баабыр",
    text: "күүстээх, модун, сүҥкэн (сильный, могучий, огромный."
    },
    {
    id: "207",
    title: "Бачыгырай",
    text: "кылгас-кылгастык хабырыта барар, тыһыргыыр тыаһы таһаар (издавать короткий трескучий звук, производить короткий треск)."
    },
    {
    id: "208",
    title: "Күөкэс = күөкэй",
    text: "уһун синньигэс моонньугун өрө, күөрэччи тутун (изящно, грациозно держать вытянутую тонкую шею)."
    },
    {
    id: "209",
    title: "Хаҥхас = хаҥхаччы",
    text: "үөһээ өттүҥ улуутун, саллайан көстөрүн курдук (расширяясь кверху так, чтобы выглядеть в верхней части объемнее, чем в нижней). "
    },
    {
    id: "210",
    title: "Чаампы",
    text: "балаҕан аанын үрдүнэн баар үтэн тахсар тутуу (нависающий выступ, козырек перед дверью в юрту-балаган)."
    },
    {
    id: "211",
    title: "Кутур",
    text: "ис-искиттэн долгуйан, эҥсэлитэн, улаханнык ыллаа (петь громко, исступленно)."
    },
    {
    id: "212",
    title: "Ыҥыыр",
    text: "аты миинэргэ аналлаах олорор тэрил (седло)."
    },
    {
    id: "213",
    title: "Иир-мэнэрий",
    text: "кэмиттэн-кэмигэр тиһиктэнэн, ииригирэн кэл (биться в нервном припадке, бесноваться)."
    },
    {
    id: "214",
    title: "Амынньыар",
    text: "мас синньигэс хаппыт лабаата, мутуга (сухие сучья, хворост)."
    },
    {
    id: "215",
    title: "Адарай көмүс",
    text: "тапталлан оҥоһуллубут көмүс (серебро, сделанное в виде пластин)."
    },
    {
    id: "216",
    title: "Холлорук",
    text: "холорук (смерчь)."
    },
    {
    id: "217",
    title: "Көҥүтэ = көҥү",
    text: "тоҕо-хоро (в большом количестве, обильно, много раз)."
    },
    {
    id: "218",
    title: "Үргүөр",
    text: "күүстээх тымныы тыал (сильный, пронизывающий холодный ветер)."
    },
    {
    id: "219",
    title: "Харай",
    text: "кими, тугу эмэ кыһаллан көр, бүөбэйдээ (окружать заботой кого-либо, заботиться о чем либо).  "
    },
    {
    id: "220",
    title: "Кэтэҕэриин",
    text: "саха балаҕаныгар киирэр аан уонна оһох утары өттө (передняя  сторона  или часть якутской юрты напротив камина и входа)."
    },
    {
    id: "221",
    title: "Биллэрик",
    text: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)."
    },
    {
    id: "222",
    title: "Суол аана",
    text: "дьиэ иһинэн аан атта, аан аттын чэрчитэ; аан модьоҕото (место у порога в доме)."
    },
    {
    id: "223",
    title: "Үгэх",
    text: "балаҕаҥҥа ол бу малы уурар кыра сир (чуланчик, клодовка).   "
    },
    {
    id: "224",
    title: "Айдаан таас",
    text: "тыастаах таас (шумное стекло)."
    },
    {
    id: "225",
    title: "Сүлүүдэ",
    text: "сиртэн хостонор дьэҥкир араҥа таас (слюда)."
    },
    {
    id: "226",
    title: "Тиһэх эһэ",
    text: "биир-икки саастаах эһэ оҕото (медвежонок одного года – двух лет)."
    },
    {
    id: "227",
    title: "Лип-хаан",
    text: "улахан, сүүнэ (громадный, огромного размера)."
    },
    {
    id: "228",
    title: "Халҕан",
    text: "аан (дверь)."
    },
    {
    id: "229",
    title: "Буолунай",
    text: "вольный. "
    },
    {
    id: "230",
    title: "Суос",
    text: "оһохтон итии салгын кэлиитэ (жар, исходящий от печи)."
    },
    {
    id: "231",
    title: "Хамыйах",
    text: "хатыҥтан оҥоһуллубут аһы баһар тэрил (деревянный черпак, половник, деревянная поварешка). "
    },
    {
    id: "232",
    title: "Кытыйа",
    text: "миискэ курдук дьоҕус мас иһит (деревянная долбленная чаша средней величины)."
    },
    {
    id: "233",
    title: "Лааппы",
    text: "лавка."
    },
    {
    id: "234",
    title: "Сэбиргэл = сэбэргэнэ",
    text: "саха балаҕаныгар икки кытыы өһүө бастарын холбуу туора ууруллар хаптаҕай бэрэбинэ (в якутской юрте: потолочное плоское бревно, кладущееся поперек на крайние матицы)."
    },
    {
    id: "235",
    title: "Сөбүргэнэ",
    text: "сэбэргэнэ."
    },
    {
    id: "236",
    title: "Көкөөнөй",
    text: "дорҕоон дьүөрэлэһиитинэн үөскээбит аат, көкөй (умса түс) диэнтэн үөскээбит буолуон сөп (слово, образованное при сочетании звуков, вероятно образован от көкөй (наклоняться вперед))."
    },
    {
    id: "237",
    title: "Бабаарыма = аарыма",
    text: "олус улахан (очень большой)."
    },
    {
    id: "238",
    title: "Бэчээтинэй",
    text: "саһаан устата (2,13 м) (печатная (казенная, мерная) сажень (2,13 м))."
    },
    {
    id: "239",
    title: "Боруобалаах",
    text: "проба."
    },
    {
    id: "240",
    title: "Модьу",
    text: "киппэ көрүҥнээх, күүстээх-уохтаах киһи (крепкий, сильный человек)."
    },
    {
    id: "241",
    title: "Мөссүөн",
    text: "ким, туох эмэ тас көстүүтэ, быһыыта-таһаата, дьүһүнэ (кнешний вид, облик, очертания). "
    },
    {
    id: "242",
    title: "Былас",
    text: " уста кээмэйэ: туора уунуллубут илиилэр тарбахтарын төбөтүттэн нөҥүө тарбахтар төбөлөрүгэр диэри (маховая сажень, размах равный 1,76 м.)."
    },
    {
    id: "243",
    title: "Үөкэй",
    text: "көнө уонна үрдүк буол (быть прямым и высоким)."
    },
    {
    id: "244",
    title: "Биэкэй",
    text: "биилгинэн синньээн көһүн (быть очень тонким в талии, тонкостанным)."
    },
    {
    id: "245",
    title: "Биил",
    text: "киһи курданарынан синньиир өттө, курданара (талия)."
    },
    {
    id: "246",
    title: "Дарай",
    text: "кэтит, улахан сарыннаах буол, оннук буолан көһүн (иметь широкие плечи; быть, казаться широкоплечим)."
    },
    {
    id: "247",
    title: "Суллаабыт тиит",
    text: "хатырыктаммыт тиит (очищенная от коры лиственница)."
    },
    {
    id: "248",
    title: "Уолах мас",
    text: "орто улахан тиит (молодая лиственница средней величины)."
    },
    {
    id: "249",
    title: "Хастаабыт мас",
    text: "хаҕыттан ыраастаммыт мас (дерево, очищенное от наружного слоя, коры)."
    },
    {
    id: "250",
    title: "Балтарык",
    text: "сыарҕаҕа тиэллэн иһэр оту туттарар, баттатар уһун ураҕас (шест, которым при перевозке стягиваются снопы сена на возу)."
    },
    {
    id: "251",
    title: "Малаҕар",
    text: "кэтит, этиргэн сирэйдээх (широколицый, с открытым лицом)."
    },
    {
    id: "252",
    title: "Мөссүөн",
    text: "ким, туох эмэ тас көстүүтэ, быһыыта-таһаата, дьүһүнэ (внешний вид, облик, очертания)."
    },
    {
    id: "253",
    title: "Уоттаах саһыл",
    text: "кыһыл саһыл (лиса-краснобурка)."
    },
    {
    id: "254",
    title: "Толбон",
    text: "күүскэ сырдаан көстөр (ярко светиться, излучать свет)."
    },
    {
    id: "255",
    title: "Ньуур",
    text: "сирэй (лицо, лик)."
    },
    {
    id: "256",
    title: "Кэрэмэс саһыл",
    text: "кыһыллыҥы бороҥ өҥнөөх саһыл (лиса-сиводушка)."
    },
    {
    id: "257",
    title: "Ньилбэк",
    text: "киһи буутун илин өттө; кыыл-сүөл илин атахтарын тобугуттан үөһээ өттө (передняя часть бедра (у человека); верхняя часть передней конечности (у животных))."
    },
    {
    id: "258",
    title: "Тиирэ",
    text: "тэнитэр, кэҥэтэр курдук таттарыы (растягивать, расширять).  "
    },
    {
    id: "259",
    title: "Аллаах ат",
    text: "улгум уонна түргэн сырыылаах, эрчимнээх айаннаах ат (быстрый, ходкий)."
    },
    {
    id: "260",
    title: "Хаҥсаар = хаҥсаҕар",
    text: "киэҥ таныылаах(муруну этэргэ)(с широкими ноздрями (о носе)).  "
    },
    {
    id: "261",
    title: "Эрэдэһиннээх үүн тиэрбэһэ",
    text: "эриллэн-хатыллан оҥоһуллубут былыргы бөҕө үүн төгүрүк тимирэ (железное кольцо старинной узды из крепкого крученого ремня)."
    },
    {
    id: "262",
    title: "Эрилкэй = арылхай",
    text: "киэҥ, ыраас уонна сырдык (харах туһунан) (большие, ясные и светлые (о глазах)) "
    },
    {
    id: "263",
    title: "Куртуйах улар",
    text: "мас көтөрүн көрүҥэ (тетерев)."
    },
    {
    id: "264",
    title: "Эрдэҕэс улар",
    text: "улар тыһыта (самка глухаря, глухарка)."
    },
    {
    id: "265",
    title: "Аалыскай иҥнэ",
    text: "английская иголка."
    },
    {
    id: "266",
    title: "Баҕыы көмүс = бабыа көмүс",
    text: "олоҥхоҕо тарбаҕы хоһуйарга туттуллар кубулуйбат эпитет (устойчивый эпитет олонхо, описывающий пальцы)."
    },
    {
    id: "267",
    title: "Сарыы",
    text: "тиби тириитэ анаан олус сымнаҕас гына таҥастаммыта (специально выделанная мягкая кожа из оленьей шкуры, замша)."
    },
    {
    id: "268",
    title: "Түнэ",
    text: "түүтэ суох таҥастаммыт таба, тайах тириитэ (замша, ровдуга). "
    },
    {
    id: "269",
    title: "Бүүппүк = бүүппэх",
    text: "тыс этэрбэс (торбоса из оленьих, конских камысов)."
    },
    {
    id: "270",
    title: "Үүс-киис киргиллээҕэ",
    text: "мааны түүлээх бастыҥа (лучшие, ценные меха)."
    },
    {
    id: "271",
    title: "Саҥыйах = саҕынньах",
    text: "тымныыга истээх сон таһынан кэтиллэр түүлээх киэҥ, ичигэс сон (дорожная меховая доха или шуба мехом наружу). "
    },
    {
    id: "272",
    title: "Нэллэгэйдии = нэлэгэйдэн",
    text: "сонун тимэхтэрин сүөрэн, аһаҕас сырыт (широко распахивать шубу, доху). "
    },
    {
    id: "273",
    title: "Кырыыбылыы",
    text: "криво."
    },
    {
    id: "274",
    title: "Имнээх хаан",
    text: "иэдэстэн тахсыбыт хааҥҥа (в крови, полученном из щек). "
    },
    {
    id: "275",
    title: "Кылаан",
    text: "уһуга, биитэ (лезвие, острие). "
    },
    {
    id: "276",
    title: "Хара дьиэрэҥкэй",
    text: "сытыы, сиэмэх (оноҕос, үҥүү туһунан)( бойкий, проворный (о стреле, копье). "
    },
    {
    id: "277",
    title: "Олодуй = олоодуй",
    text: "моойу уһатан хоноччу тутун (всматриваться вдаль, вытягивая шею)."
    },
    {
    id: "278",
    title: "Буут",
    text: "урукку ыйааһын кээмэйэ: 16 киилэ 380 кыраам (старая русская мера массы, пуд)."
    },
    {
    id: "279",
    title: "Дэлэбиир = дэлбээр",
    text: "салгыҥҥа уйдаран үөһээнэн тэлээрэ көт (медленно, плавно парить в воздухе)."
    },
    {
    id: "280",
    title: "Чомпу сүлүгэс = чомпо сүллүгэс",
    text: "болтоҕор төбөлөөх, кылгас уктаах, былыр кыргыһыыга туттуллар мас тэрил. "
    },
    {
    id: "281",
    title: "Киил",
    text: "киль, кильевой."
    },
    {
    id: "282",
    title: "Өксөкү кыыл",
    text: "фольклор айымньыларыгар ойууланар икки эбэтэр үс бастаах хотойдуҥу көтөр (дву- или трехглавая мифическая птица)."
    },
    {
    id: "283",
    title: "Умунуох = оҕунуох",
    text: "сыстаҥнас, сыалаах хойуу соҕус масса (липкая, жирная, довольно густая масса для втирания). "
    },
    {
    id: "284",
    title: "Хатыыс балык",
    text: "өҥүргэс уҥуохтаах, кыһыл эттээх, уһуктаах тумустаах искэҕинэн уонна этинэн сыаналанар өрүс балыга (промысловая рыба семейства осетровых без костного скелета, ценная своим мясом и икрой, осетр)."
    },
    {
    id: "285",
    title: "Силим",
    text: "ону-маны сыһыарарга аналлаах сыстыгас убаҕас (клей)."
    },
    {
    id: "286",
    title: "Бүрэдэһин = бүрүдэһин",
    text: "тугу эмэ үрдүнэн бүрүйүү, сабыы (покрытие чего-либо чем-либо)."
    },
    {
    id: "287",
    title: "Өлүү дьирибинэ балык",
    text: "олоҥхоҕо баар Уот Кудулу байҕалҕа, өлүү уутугар да сылдьар кыахтаах балык (мифическая рыба, имеющая способность плавать в Гибельном огненном море или в мертвой воде)."
    },
    {
    id: "288",
    title: "Иҥэрэ = иҥэрчэ",
    text: "чаачар кирсэ охсор сирин эбэтэр икки уһугун тостубатын диэн иҥиир сабынан эрэдэһиннээн баайыы (сухожильная обмотка лука и стрелы)."
    },
    {
    id: "289",
    title: "Өлүү даарда балык",
    text: "Аллараа дойду балыга (рыба Нижнего мира).	"
    },
    {
    id: "290",
    title: "Кирис",
    text: "чаачары тардар хатыллыбыт тирии быа (тетива)."
    },
    {
    id: "291",
    title: "Тоҕойдуу",
    text: "токуруйан, өҕүллэн (подобно изгибу, излучине)."
    },
    {
    id: "292",
    title: "Чаачар",
    text: "ох саа (лук)."
    },
    {
    id: "293",
    title: "Кулун кымыһа",
    text: "саамай эрдэтээҕи кымыс (ыам ыйын бүтүүтүгэр эбэтэр бэс ыйын саҥатыгар оҥоһуллар, кыра ыһыахха иһиллэр (самый ранний кумыс, распиваемый на малом Ысыахе в конце мая или в начале июня)."
    },
    {
    id: "294",
    title: "Бойом киһи",
    text: "үскэл, улахан киһи (полный, плотный человек)."
    },
    {
    id: "295",
    title: "Кулан-дьорҕоон",
    text: "модун, дорҕоонноох (мощный, громогласный)."
    },
    {
    id: "296",
    title: "Саамал кымыс",
    text: "саамыламмыт, көөнньүбүтүн кэннэ атын улахан иһиккэ мунньан, сөрүүҥҥэ туруоран, астытан иһэргэ бэлэмнэммит кымыс (уже дошедший до кондиции, постепенно сливаемый в большой сосуд для смешивания и охлаждения, лучшего качества кумыс)."
    },
    {
    id: "297",
    title: "Тииньньит",
    text: "тииҥньит – тииҥи бултааччы (охотник на белку)."
    },
    {
    id: "298",
    title: "Тэмэлгэн = тэмэлдьигэн",
    text: "тоноҕосчут (стрекоза)."
    },
    {
    id: "299",
    title: "Маалтааныка оноҕос = маалтаар оноҕос",
    text: "мүлтүгүр төбөлөөх оноҕос (стрела с тупым наконечником, не повреждающая шкуры)."
    },
    {
    id: "300",
    title: "Сөгөлөөн",
    text: "сиргэ эбэтэр тордоххо утуйарга халыҥ гына тэлгэтиллибит мас мутукчата; манна «тэллэхтээх, олбохтоох» диэн суолтаҕа туттуллубут (многослойный настил из хвои, используемый в качестве подстилки для сна)."
    },
    {
    id: "301",
    title: "Тимир тиҥсирики (оноҕос)",
    text: "чопчу сыалга түһэр тимир оноҕос (железная стрела, хорошо попадающая в цель)."
    },
    {
    id: "302",
    title: "Оот-татай",
    text: "соһуйууну, сөҕүүнү бэлиэтиир саҥа аллайыы (междометие, выражающее сильное удивление, изумление)."
    },
    {
    id: "303",
    title: "Кирдик",
    text: "кырдьык."
    },
    {
    id: "304",
    title: "Иэйээхсит",
    text: "Иэйиэхсит."
    },
    {
    id: "305",
    title: "Бараалаах",
    text: "тугунан эмэ тэҥ, маарынныыр (равный другому, равноценный)."
    },
    {
    id: "306",
    title: "Ахталый",
    text: "атахтаргын аччаччы быраҕан дьоһумсуйбуттуу аа-дьуо ыараханнык хаамп (шагать тяжело, медленно на широко раставленных ногах, с претензией на собственную важность)."
    },
    {
    id: "307",
    title: "Дьаарбаҥ",
    text: "дьиэ сүөһүтэ мэччийэр, аһыыр сирэ (место, где пасется скот, кормятся животные, пастбище)."
    },
    {
    id: "308",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "309",
    title: "Толоонноох",
    text: "бөдөҥ, талыы (крупный, лучший)."
    },
    {
    id: "310",
    title: "Торумтуйбут",
    text: "кыратык хараарбыт эбэтэр олус биллэр гына үүммүт (слегка почерневший, едва пробивающийся)."
    },
    {
    id: "311",
    title: "Хабайакаан = хабыйахаан",
    text: "хабдьы (куропатка белая)."
    },
    {
    id: "312",
    title: "Халы-мааргы",
    text: "куһаҕан көрүҥнээх, томороон (невзрачный, некрасивый)."
    },
    {
    id: "313",
    title: "Хабараан",
    text: "олус хатан (раскатистый, далеко разносящийся)."
    },
    {
    id: "314",
    title: "Халаастаа",
    text: "хаадьылаа, күлүү-элэк гын (шутить, насмехаться)."
    },
    {
    id: "315",
    title: "Онньой",
    text: "аллараа өттүгүнэн ханньаччы үктэн, тэпсилин (быть стоптанным набок)."
    },
    {
    id: "316",
    title: "Онолун",
    text: "айаххын оҥоччу атан, сирэйиҥ уһаан, инниҥ диэки бөкчөччү түс (горбиться с растянутым лицом и приоткрытым ртом)."
    },
    {
    id: "317",
    title: "Оруодьа",
    text: "рота."
    },
    {
    id: "318",
    title: "Оруолдьут = арыалдьыт",
    text: "бииргэ сылдьыһан, сорудаҕы толорор, көмөлөһөр киһи (сопровождающее лицо, прислужник)."
    },
    {
    id: "319",
    title: "Субан",
    text: "ханыыта, оҕото суох, соҕотох (одинокий, без пары)."
    },
    {
    id: "320",
    title: "Хоойҥо (хоойго) сытар",
    text: "бииргэ сытар, утуйар (лечь в постель, спать вместе)."
    },
    {
    id: "321",
    title: "Хамчаакы",
    text: "Камчатка."
    },
    {
    id: "322",
    title: "Хабырыс",
    text: "сиирэ хапсан, таарыйсан аас (задевать друг друга вскользь, сталкиваться)."
    },
    {
    id: "323",
    title: "Тиил",
    text: "биир, уопсай (общий, совместный)."
    },
    {
    id: "324",
    title: "Санаа тарҕат",
    text: "санааҥ түспүтүн тугунан эмэ аралдьытан аһар (отвлекаться от неприятных мыслей, снимать напряжение)."
    },
    {
    id: "325",
    title: "Көҕүөр",
    text: "кымыһы көөнньөрөргө аналлаах сылгы тириититтэн оҥоһуллубут иһит (сосуд из конской кожи, в которой готовят кумыс)."
    },
    {
    id: "326",
    title: "Көхсүнү көнньүөрт",
    text: "астын-дуоһуй, санааҥ табылын (быть удовлетворенным, утешаться, успокаиваться)."
    },
    {
    id: "327",
    title: "Суомас",
    text: "дуобат."
    },
    {
    id: "328",
    title: "Мүһэ",
    text: "сүөһү, кыыл сүһүөхтэринэн араартаан быһыллыбыта (одна из частей расчлененных конечностей скота или зверя)."
    },
    {
    id: "329",
    title: "Мохсуо",
    text: "анал бэрээдэгинэн ууруллубут кэрчик мастары таба быраҕаттаан, сурааһын таһыгар таһаарар күрэх оонньуу (спортивная игра «городки»)."
    },
    {
    id: "330",
    title: "Хордоҕой",
    text: "сыһыыга уһун ньолбуһах кураанах кыра кирбии (небольшой сухой вытянутый пригорок на поляне, бугор)."
    },
    {
    id: "331",
    title: "Мөрүөҥ = нөрүөн",
    text: "киһи курданарыттан үөһээ өттө: түөһэ, сиһэ уо.д.а. (верхняя часть туловища)."
    },
    {
    id: "332",
    title: "Албан-дьаҕан = албан-дьаһах",
    text: "аатырбыт, үрдүк хайҕалынан киэҥник биллибит (широко известный)."
    },
    {
    id: "333",
    title: "Чарапчылан",
    text: "сырдыктан мэһэйдэтэн эбэтэр ырааҕы көрөөрү, ытыһыҥ кырыытынан хараҕыҥ үрдүнэн сүүскэр хаххалыы тут (заслонять глаза рукой, приложив её ко лбу козырьком, от света или чтобы смотреть вдаль)."
    },
    {
    id: "334",
    title: "Туут хайыһар",
    text: "таба илин тыһынан бүрүллэр кэтит хайыһар (старинные большие лыжи, подбитые шкурой с передних лап оленя)."
    },
    {
    id: "335",
    title: "Эргэнэ хара тыа",
    text: "бөдөҥ мастаах халыҥ ойуур, сис тыа (густой лес с крупными деревьями)."
    },
    {
    id: "336",
    title: "Илибирэччи",
    text: "илибирии хамсыыр гына, эйэҥэлэтэн (так, чтобы дрожало, трепетало)."
    },
    {
    id: "337",
    title: "Талыбыраччы",
    text: "тыастаахтык, түргэн-түргэнник күүскэ мөҕүһүннэрэн (встряхивая, издавая частые шумные хлопки)."
    },
    {
    id: "338",
    title: "Буур",
    text: "улахан тайах, таба атыыра (матерый самец лося или оленя). "
    },
    {
    id: "339",
    title: "Бичик",
    text: "оһуор, ойуу (роспись, узор)."
    },
    {
    id: "340",
    title: "Чыҥырҕастаах сыттык",
    text: "кырыыларыгар хатан тыаһы таһаарар үрүҥ көмүстэрдээх сыттык (подушка с металлическими погремушками из серебряных пластинок по краям)."
    },
    {
    id: "341",
    title: "Баччыгынаа",
    text: "муннугун улаханнык хаһыҥыраччы тыаһат (сильно, шумно сопеть)."
    },
    {
    id: "342",
    title: "Тыҥ",
    text: "сарсыарда күн тахсарын саҕана халлааҥҥа үөскүүр синньигэс сырдык балаһа (рассвет, утренняя заря)."
    },
    {
    id: "343",
    title: "Толомон",
    text: "ордук бөдөҥ, талыы, дьоһун (крупный, лучший, отборный)."
    },
    {
    id: "344",
    title: "Амынньыар",
    text: "мас синньигэс хаппыт лабаата, мутуга (сухие сучья, хворост)."
    },
    {
    id: "345",
    title: "Халааныскай ыстаан",
    text: "голландские штаны, сделанные из бычьей черевязи (брюшка)."
    },
    {
    id: "346",
    title: "Эҥиһит",
    text: "ыраахха диэри дорҕоонноохтук тыаһаа, ньириһит (издавать гулкий, громкий раскатистый звук)."
    },
    {
    id: "347",
    title: "Сүргүччү",
    text: "сүүһүн аннынан (исподлобья)."
    },
    {
    id: "348",
    title: "Сурулаччы",
    text: "быстыбакка сытыытык биир кэм «сур» гына тыаһаан (производя непрерывный свистящий, шуршащий шум). "
    },
    {
    id: "349",
    title: "Улахатыттан = улаҕаатыттан",
    text: "уһугуттан, кытыы, ыраах сиртэн (с окраины, с крайней стороны)."
    },
    {
    id: "350",
    title: "Элэмэс",
    text: "бөдөҥ маҥан ойуулардаах, эриэн дьүһүннээх (пегий)."
    },
    {
    id: "351",
    title: "Чугурус",
    text: "инниҥ диэки баран иһэн эмискэ төттөрү түс, кэннигинэн бар (пятиться, отступать)."
    },
    {
    id: "352",
    title: "Иҥиир тараһалаа, этирик түөстээ",
    text: "довести до край¬него истощения, изнурить; этирик – тирии ис субатын кыһыйарга аналлаах токур тимир (довести до край¬него истощения, изнурить; этирик – железный дугообразный скобель для обработки кожи)."
    },
    {
    id: "353",
    title: "Сөһүргэстээ",
    text: "аҥаар атаххын тобуктаан, аҥаарын бокутан олор (становиться на одно колено)."
    },
    {
    id: "354",
    title: "Нөрүөннээх",
    text: "кэтит түөстээх модун киһи (с широкой грудью, сильный, могучий)."
    },
    {
    id: "355",
    title: "Топпуруостаа",
    text: "доппуруоһу ыыт (допроси)."
    },
    {
    id: "356",
    title: "Чиэски",
    text: "уһук сиргэ баар, ыраах, туора турар (находящийся вдали от центра, окраинный, глухой)."
    },
    {
    id: "357",
    title: "Суодуй",
    text: "чиҥээн, дьиппинийэн аллара түс (падать сверху, низвергаться)."
    },
    {
    id: "358",
    title: "Өндөл",
    text: "үрдүк (высокий)."
    },
    {
    id: "359",
    title: "Кэлии",
    text: "бурдук куолаһын, табах отун уо.д.а. соҕоҕунан үлтү сынньарга аналлаах хаһан оҥоһуллубут дириҥ истээх мас иһит (деревянная ступа из обрубка бревна)."
    },
    {
    id: "360",
    title: "Кыдьымахтан",
    text: "манна: кыстан, дьаарыстан, үрүт-үрдүгэр уурулун (здесь: складывать друг на друга, укладывать слоями)."
    },
    {
    id: "361",
    title: "Көмүскэ",
    text: "харах олоҕо (глазница)."
    },
    {
    id: "362",
    title: "Күөрт",
    text: "бөрө курдук дьүһүннээх, араҕастыҥы бороҥ (похожий на волка, желтовато-серый)."
    },
    {
    id: "363",
    title: "Дьохсооттоо",
    text: "кыыһыран, суоһурҕанан дьарыйыахтыы, кэһэтиэхтии тутун (вести себя агрессивно, будто готов сейчас же напасть)."
    },
    {
    id: "364",
    title: "Ураанньык",
    text: "сырдык сурааһын (светлая полоска)."
    },
    {
    id: "365",
    title: "Дэллэкэччит = тэлэкэчит",
    text: "соһуччу күүс өттүнэн тардыалаан, соһуолаан илт (не давая опомниться, с силой тянуть за собой)."
    },
    {
    id: "366",
    title: "Дьөгдьөрүс гын",
    text: "арҕаскын бөгдьөтөн тиэтэллээхтик инниҥ диэки аллара түс (согнувшись, быстро податься вперед, свалиться)."
    },
    {
    id: "367",
    title: "Өрөкүс = өрүкүс гын",
    text: "эмискэ өрө бурҕайан, түллэн үтэн таҕыс (вздыматься, развеваться, моментально подняться)."
    },
    {
    id: "368",
    title: "Дапсылҕа",
    text: "охсор, дайбыыр сэп-сэбиргэл (орудие или оружие, которым можно размахнуться, ударить)."
    },
    {
    id: "369",
    title: "Суодай",
    text: "үрдүк, күлүктээх көрүҥнээх буол (быть крупным, иметь внушительный рост)."
    },
    {
    id: "370",
    title: "Ходьой",
    text: "көбүс-көнөтүк туттан, чэпчэкитик ыстаҥалыы сырыт, ойуолуу сүүр (бегать с прискоком, вытягиваясь в длину)."
    },
    {
    id: "371",
    title: "Содуом",
    text: "туохтан эмэ сылтаан дьону  уонна  атын  малы  даҕаны  харса суох  кырбаан,  үлтү  сынньан  барыы (дебош,  погром)."
    },
    {
    id: "372",
    title: "Тоҕус хараҕалаах",
    text: "тоҕус кииннээх (с девятью стержнями)."
    },
    {
    id: "373",
    title: "Хотоҕой",
    text: "көтөр кыната, дабыдала (крыло птицы)."
    },
    {
    id: "374",
    title: "Чаан олгуй",
    text: "күөстэнэр улахан иһит (большой сосуд для варки, котел)."
    },
    {
    id: "375",
    title: "Быһычча",
    text: "кыра быһах (ножик)."
    },
    {
    id: "376",
    title: "Чыллырыыт",
    text: "балык хатырыга (чешуя)."
    },
    {
    id: "377",
    title: "Лааҕыра",
    text: "куйуур куойатын туорайа (поперечина на ободке рыболовного сака, в ко¬торую упирается конец рукоятки)."
    },
    {
    id: "378",
    title: "Эрэлик-турулук көр",
    text: "уоттаммыт хараххынан сытыытык көр (пучить глаза, ясно, четко видеть)."
    },
    {
    id: "379",
    title: "Иэҕэлдьий",
    text: "икки өттүгэр иҥнэҥнээн ыл (пошатываться)."
    },
    {
    id: "380",
    title: "Кыппыайка = кыппаайка",
    text: "сып-сырдык, көнө ньуурдаах (светлый, яркий, ровный)."
    },
    {
    id: "381",
    title: "Хоро тойуга",
    text: "өйдөммөт, атын тыллаах ырыа-тойук (песня на непонятном языке)."
    },
    {
    id: "382",
    title: "Суккуллун",
    text: "барамматы сүөкүүр курдук өлгөмнүк кутулун, тоҕун, түс (литься нескончаемым потоком)."
    },
    {
    id: "383",
    title: "Чэлгэх",
    text: "ириҥэ, хаан булкаастаах чалахайдыҥы симэһин (слизистая жидкость, содержащая кровянистый гной)."
    },
    {
    id: "384",
    title: "Оҥкумал = окумал",
    text: "көтөр дьардьаматыттан тахсар кынатын бастакы сүһүөх уҥуоҕа (верхняя часть крыла у птиц)."
    },
    {
    id: "385",
    title: "Киэли",
    text: "туох эмэ киэҥ нэлэмэн иэнэ (широкое пространство)."
    },
    {
    id: "386",
    title: "Идэмэр",
    text: "иҥсэ, обот (жадность, алчность)."
    },
    {
    id: "387",
    title: "Адьынат",
    text: "куһаҕан быһыы, түктэри кэмэлдьи (дурная привычка). "
    },
    {
    id: "388",
    title: "Адаҕа",
    text: "ыар буруйдаахтарга кэтэрдэр ыарахан мас боҕуу (арестантские колодки; кандалы)."
    },
    {
    id: "389",
    title: "Кулуба",
    text: "өрөбөлүүссүйэ иннинэ Саха сиригэр улуус быыбардаммыт баһылыга (до революции в Якутии улусный голова)."
    },
    {
    id: "390",
    title: "Таала",
    text: "кытаанах сирдээх кураанах дэхси киэҥ хонуу (равнина с твердой сухой поверхностью)."
    },
    {
    id: "391",
    title: "Дьиэк",
    text: "кэбирэх сир, мөлтөх өрүт, итэҕэс-быһаҕас (изъян, дефект, повреждение, слабое место)."
    },
    {
    id: "392",
    title: "Сылластыгас",
    text: "олус халыҥ уонна тиэрэ сыҕаллан тахсыбыт (очень толстый, некрасиво вывернутый наружу)."
    },
    {
    id: "393",
    title: "Былластыгас",
    text: "улаханнык тэллэйэ сылдьар халыҥ (толстый и отвислый)."
    },
    {
    id: "394",
    title: "Ханньастыгас",
    text: "иҥнэри барбыт, ханньайбыт (кривой, искривленный)."
    },
    {
    id: "395",
    title: "Арбыйа",
    text: "дүлүҥү хаһан тыыны, мас иһити оҥорорго аналлаах былыргы туттар сэп (инструмент древних якутов для долбления лодок, деревянной посуды)."
    },
    {
    id: "396",
    title: "Оҥой",
    text: "төгүрүктүҥү дьөлөҕөстөөх буол (зиять)."
    },
    {
    id: "397",
    title: "Дэриэтинньик",
    text: "илэ сылдьар абааһы, киһини сиэччи (зомби, нечисть, чудовище)."
    },
    {
    id: "398",
    title: "Дьэс",
    text: "кыһыл алтантан оҥоһуллубут (отлитый из красной меди)."
    },
    {
    id: "399",
    title: "Эт бэргэ харах",
    text: "кытарбыт, уулаах-хаардаах, чэмэлкэйэ суох харах (красноватые, воспаленные глаза)."
    },
    {
    id: "400",
    title: "Абына-табына",
    text: "онон-манан, сэдэхтик (редко, негусто)."
    },
    {
    id: "401",
    title: "Амынах = аманах",
    text: "кыыл-сүөл өрөҕөтүгэр быттыктарын диэкинэн үөскүүр сыа; манна: кирдээх сыалаах-арыылаах (наружный слой жира около вымени или в пахах животного; здесь: жирный, потный)."
    },
    {
    id: "402",
    title: "Көлбөх",
    text: "туох эмэ куһаҕана, кир, дьай (что-л. нечистое, гадкое, отвратительное)."
    },
    {
    id: "403",
    title: "Таһаа",
    text: "киһи уҥуоҕун, этин-сиинин быһыыта (фигура, стан человека)."
    },
    {
    id: "404",
    title: "Ньуур",
    text: "сирэй, сэбэрэ (лицо)."
    },
    {
    id: "405",
    title: "Урааҥхай",
    text: "сахалар бэйэлэрин ааттанар иккис ааттара (самоназвание якутов)."
    },
    {
    id: "406",
    title: "Халымыайка",
    text: "каламейка (вид ткани)."
    },
    {
    id: "407",
    title: "Хороҥноо",
    text: "өрө тахсыталаа, чорбоҥноо (торчать, выступать)."
    },
    {
    id: "408",
    title: "Томтолдьуй",
    text: "томтоҕор быһыылан, үрдээн көһүн (стать выпуклым, возвышаться)."
    },
    {
    id: "409",
    title: "Хатат",
    text: "чокууру охсон, саҕан уот ыларга уонна биилээҕи сытыылыырга туттуллар хатарыылаах тимир (огниво)."
    },
    {
    id: "410",
    title: "Солоҕой",
    text: "сүөргү, солуута суох, сэлээр (несерьезный, ветреный)."
    },
    {
    id: "411",
    title: "Дьалаҕай",
    text: "көтүмэх, болҕомтото суох (небрежный, неаккуратный, халатный)."
    },
    {
    id: "412",
    title: "Иэримэ",
    text: "төрөөбүт-үөскээбит (родной)."
    },
    {
    id: "413",
    title: "Чиччик",
    text: "дьиккэр, абааһы (тварь, выродок)."
    },
    {
    id: "414",
    title: "Күдүө",
    text: "буруо-тараа, быыл; киэр күдүө бара тат – түргэнник буору бурҕатан бар, сүт (күдүө – пыль, мгла; киэр күдүө бара тат – уйди быстро, поднимая пыль на дороге, исчезни)."
    },
    {
    id: "415",
    title: "Чалаҕай",
    text: "айахтан, мурунтан тахсар сынньылхай, хойуу убаҕас, салыҥ (тягучая слизь)."
    },
    {
    id: "416",
    title: "Халдьыгыраччы",
    text: "биир күдьүс чылыгырыыр тыастаахтык (с монотонным журчанием)."
    },
    {
    id: "417",
    title: "Сэймэктээ",
    text: "быһыта-хайыта, тырыта тыыт, үлтү кырбаа (терзать, разрывать на части)."
    },
    {
    id: "418",
    title: "Өлүөр",
    text: "чэгиэн, доруобай (здоровый)."
    },
    {
    id: "419",
    title: "Үөрэҕэстээ",
    text: "тугу эмэ туора бысталаа, кырбаа (руби поперёк, разделывай)."
    },
    {
    id: "420",
    title: "Өргөс кылаан",
    text: "көспүт суолтаҕа: күүстээх санаа, үрдүк дьулуур, эрчим (в переносном знач.: сильный дух, стремление, энергия)."
    },
    {
    id: "421",
    title: "Сарбый",
    text: "уһунун быс, кылгат, аҕыйат (укоротить, подрезать, уменьшить)."
    },
    {
    id: "422",
    title: "Нэлбэй",
    text: "аллара өттүнэн кэтирээ, намылыйан түс (ниспадать, расширяясь книзу)."
    },
    {
    id: "423",
    title: "Кырадаһыннаа",
    text: "кыра гына кырыйтаа, бысталаа, алдьат (разрезать, искромсать)."
    },
    {
    id: "424",
    title: "Кэбэлит",
    text: "киэр гын, суох оҥор (убрать прочь, загубить)."
    },
    {
    id: "425",
    title: "Дураан = дураар, дураан",
    text: "бытаан, холку (медлительный; медленный, косный)."
    },
    {
    id: "426",
    title: "Чубучу = чугучу",
    text: "дьиикэй, дьиккэр (подлец, сволочь, дрянь, негодяй)."
    },
    {
    id: "427",
    title: "Маҥай аллаах",
    text: "ким эрэ тугу эмэ оҥорбутуттан соһуйан сөҕөн-махтайан эбэтэр абаран-сатаран саҥа аллайыы (восклицание, восхищенное или возмущенное, по поводу чьего-л. неожиданного поступка, поведения)."
    },
    {
    id: "428",
    title: "Иһэх",
    text: "атах таҥаһыгар эбэтэр сүөһү туйаҕар сыстыбыт буор (приставшая грязь на подошве обуви человека или к копыте лошади)."
    },
    {
    id: "429",
    title: "Кэһэх",
    text: "ох хаата; хаа (колчан: вместилище чего-л.)."
    },
    {
    id: "430",
    title: "Болточчу тут",
    text: "үллэччи, бөлтөччү (надуто, вздуто)."
    },
    {
    id: "431",
    title: "Кылбай",
    text: "сырдыктык, чаҕылыччы тык; арылыйан, сырдаан көһүн (светиться ярко; быть, казаться ярким, светлым)."
    },
    {
    id: "432",
    title: "Дьиэрэҥкэй үҥүү",
    text: "эргичийбит-урбачыйбыт үҥүү (вертлявое, проворное, подвижное копье)."
    },
    {
    id: "433",
    title: "Олодуй",
    text: "ол-бу диэки хоноччу туттан көрбөхтөө, хайыспахтаа (оглядываться в стороны, держа голову высоко)."
    },
    {
    id: "434",
    title: "Болот",
    text: "икки өттүнэн биилээх токур соҕус уһун тимирдээх, кылгас уктаах сэрии сэбэ (обоюдоострый выгнутый меч с короткой рукояткой)."
    },
    {
    id: "435",
    title: "Куһурҕаа",
    text: "салгыны тыыран иһиирэр курдук тыастары таһаар (издавать свистящие звуки, рассекая воздух)."
    },
    {
    id: "436",
    title: "Чомпо сүллүгэс",
    text: "болтоҕор төбөлөөх, кылгас уктаах, былыр кыргыһыыга туттуллар мас тэрил (короткая палка с утолщением на конце, служившая в старину боевым оружием)."
    },
    {
    id: "437",
    title: "Дьулай",
    text: "туох эмэ үрдээн  көстөөччү саамай  төбөтө,  оройо (верхушка,  макушка  чего-л.)."
    },
    {
    id: "438",
    title: "Сынтарый",
    text: "ньыҕалын, ньыҕаллан сыппаа (тупиться, притупляться)."
    },
    {
    id: "439",
    title: "Боппууда",
    text: "урукку ыйааһын кээмэйэ, аҕыс киилэ кэриҥэ (старая мера веса, равная примерно 8 кг, полпуда)."
    },
    {
    id: "440",
    title: "Битигирэй",
    text: "биир тэҥ чаастатык тоҥсуйан, лигийэн эрэ курдук тыаһаа (издавать интенсивный дробный звук)."
    },
    {
    id: "441",
    title: "Дьаллас гын",
    text: "сөбө суохтук кэҥээ, олус кэҥээ, киэҥ буол (расширяться, стать шире, быть широким)."
    },
    {
    id: "442",
    title: "Дьаргыл",
    text: "үрүт-үрдүгэр кыстаммыт, даркыламмыт (сложенный друг на друга слоями)."
    },
    {
    id: "443",
    title: "Бэрикичис гын",
    text: "олус түргэнник, эрчимнээхтик хаамп эбэтэр сүүр (шагать или бегать очень быстро, энергично)."
    },
    {
    id: "444",
    title: "Харсыылаах",
    text: "муос муоска түсүһэн киирсэр, кэйсэр (бьеться рогами, бодается)."
    },
    {
    id: "445",
    title: "Дирбиэн тииһик",
    text: "ньиргиэрдээх тыас-уус бэргээһинэ, күүһүрүүтэ (высшая степень усиления шума, грохота)."
    },
    {
    id: "446",
    title: "Кыпыайка = кыппаайка",
    text: "сып-сырдык, көнө ньуурдаах (светлый, яркий, ровный)"
    },
    {
    id: "447",
    title: "Таалыйа = таала",
    text: "кытаанах сирдээх кураанах дэхси киэҥ хонуу (равнина с твердой сухой поверхностью)."
    },
    {
    id: "448",
    title: "Күөгэлдьиччи",
    text: "биир тэҥник, бытааннык хамнанан (медленно, спокойно, плавно)."
    },
    {
    id: "449",
    title: "Улаабыр = улабыр",
    text: "ыраах, ырааҕы, ыраахха (вдаль)"
    },
    {
    id: "450",
    title: "Тордуйа",
    text: "туостан оҥоһуллубут иһит (берестяной сосуд)."
    },
    {
    id: "451",
    title: "Арылы хара далай күөл",
    text: "ыраас, түгэҕэ биллибэт дириҥ уулаах киэҥ күөл (чистое, чрезвычайно глубокое и широкое озеро)."
    },
    {
    id: "452",
    title: "Атыйах",
    text: "уу кутарга эбэтэр балыкка аналлаах намыһах туос иһит (берестяное лукошко, предназначенное для воды или хранения рыбы)."
    },
    {
    id: "453",
    title: "Ньалбалдьыччы",
    text: "тыыран, хаптатан, тэлэ быһан (распластанно, растянуто, разнято)."
    },
    {
    id: "454",
    title: "Күдэн",
    text: "тунааран көстүү, туманнырыы; буор-сыыс, буруо хойуутук көтүүтэ (легкий туман, мгла, марево)."
    },
    {
    id: "455",
    title: "Аччай = ахчай",
    text: "атахтаргын киэҥник үктээ уонна бокуй (широко раставлять и сгибать ноги).	"
    },
    {
    id: "456",
    title: "Тардыылаах оҕус",
    text: "тиэйиллибит таһаҕастаах оҕус (бык с возом)."
    },
    {
    id: "457",
    title: "Буулаҕа",
    text: "оҕуһу сыарҕаҕа көлүйэргэ аналлаах мастартан үөһээҥҥитэ (ярмо, бычий хомут)."
    },
    {
    id: "458",
    title: "Маадьай",
    text: "тобуктарын икки ардынан ордук арыттаах, токур буолан көһүн (стать кривоногим)."
    },
    {
    id: "459",
    title: "Хатат",
    text: "чокууру охсон, саҕан уот ыларга уонна биилээҕи сытыылыырга туттуллар хатарыылаах тимир (огниво)."
    },
    {
    id: "460",
    title: "Сардырҕаччы",
    text: "күүскэ ыһыллан тахсан (рассыпаясь, брызжа)."
    },
    {
    id: "461",
    title: "Логлорута",
    text: "аллараа өттүттэн ыла арааран, улаханык түөрэ (до основания, с корнями, глубоко и большим куском)."
    },
    {
    id: "462",
    title: "Кэйбэччи",
    text: "кэтирээн, үллэн көстөр гына, үллэччи (как бы расплывшись книзу)."
    },
    {
    id: "463",
    title: "Тэбиэһир",
    text: "эбии тэптэн, күүһүрэн биэр (раззадориваться, усиливаться)."
    },
    {
    id: "464",
    title: "Тэлэкэчий",
    text: "түргэнник, сытыытык-хотуутук хамсан (двигаться быстро, энергично, крутиться-вертеться)."
    },
    {
    id: "465",
    title: "Бэчээтинэй",
    text: "саһаан устата (2,13 м) (печатная (казенная, мерная) сажень (2,13 м))."
    },
    {
    id: "466",
    title: "Кыын",
    text: "биилээх, уһуктаах сэп тимир өттө угуллар хаата (ножны)."
    },
    {
    id: "467",
    title: "Кытах",
    text: "суунар таас саҕа мас иһит, улахан кытыйа (большая деревянная чаша)."
    },
    {
    id: "468",
    title: "Байтаһын",
    text: "сайын устата көҥүл сылдьыбыт, төрөөбөтөх сүөһү (откормленный, нагулявший жир за лето скот)."
    },
    {
    id: "469",
    title: "Болгуо",
    text: "былыргы саха уустара уруудаттан уһааран ылар тимирдэрин сомоҕото (железные болванки, получаемые путем сплава руды древними якутскими кузнецами)."
    },
    {
    id: "470",
    title: "Чээрэлээ",
    text: "туох эмэ ордугуттан, тобоҕуттан хомуй (собрать из остатков чего-л.)."
    },
    {
    id: "471",
    title: "Оргунньуктаа",
    text: "кытардыллыбыт тимири балталыырга ыһыллар сириэһини хомуй (собрать окалину)."
    },
    {
    id: "472",
    title: "Ылыр-чылыр быһыйа",
    text: "аччыгый быһах (маленький ножик)."
    },
    {
    id: "473",
    title: "Сүүдүй",
    text: "күүскэ умсугуй, баҕар (чувствовать сильное влечение)."
    },
    {
    id: "474",
    title: "Өҥүргэс",
    text: "уҥуохха маарынныыр эрээри, имигэс уонна чиҥ эттик (хрящ)."
    },
    {
    id: "475",
    title: "Чинэлдьит",
    text: "төбөҕүн, көхсүгүн көнөтүк кэнниҥ диэки өрө тут (держать спину прямо, чуть откинув голову)."
    },
    {
    id: "476",
    title: "Харыс",
    text: "былыргы уста кээмэйэ: ууннары тутуллубут эрбэх төбөтүн уонна ортоку тарбах төбөтүн икки ардын саҕа уста (мера длины: большая пядь, равная расстоянию между концами расстянутых большого и среднего пальцев)."
    },
    {
    id: "477",
    title: "Сиэлий",
    text: "муоскунан эбэтэр төбөҕүнэн туора садьый (отталкивать в сторону рогами или головой)."
    },
    {
    id: "478",
    title: "Лиһиргэт",
    text: "арыттаан “лиһир-лиһир” гынан тыаһаа (издавать размеренный глухой тяжелый стук)."
    },
    {
    id: "479",
    title: "Соҥуй",
    text: "туох эмэ куһаҕантан улаханнык соһуйбут, хом түспүт дьүһүннэн (иметь скорбный, опечаленный, горестный вид, печалиться, скорбеть, грустить)."
    },
    {
    id: "480",
    title: "Лөһүргэччи",
    text: "арыттаан “лөһүр-лөһүр” гынан тыаһаан (издавая мерный тупой стук)."
    },
    {
    id: "481",
    title: "Махчаччы",
    text: "такыппыт эбэтэр маадьа5ар атаххын аччатан (широко расставив согнутые в коленях или кривые ноги)."
    },
    {
    id: "482",
    title: "Иэгэлдьий = иэҕэлдьий",
    text: "икки өттүгэр иҥнэҥнээн ыл (пошатываться)."
    },
    {
    id: "483",
    title: "Көкөөнөй",
    text: "дорҕоон дьүөрэлэһиитинэн үөскээбит аат, көкөй (умса түс) диэнтэн үөскээбит буолуон сөп (слово, образованное при сочетании звуков, вероятно образован от көкөй (наклоняться вперед))."
    },
    {
    id: "484",
    title: "Көкөлдьүй",
    text: "эргичий, кулахачый, чобуо, сымса, хоһуун буол (изворачиваться, быть удалым, бойким, проворным)."
    },
    {
    id: "485",
    title: "Хаан-бадах",
    text: "хааҥҥа майгылыы (похожая на кровь)."
    },
    {
    id: "486",
    title: "Өһөх-бадах",
    text: "хойдубут хаан кэриэтэ (похожее на сгустки крови)."
    },
    {
    id: "487",
    title: "Бэкир",
    text: "уһун, хатыҥыр көрүҥнээх (высокий, худощавый)."
    },
    {
    id: "488",
    title: "Таллан куоҕас",
    text: "улахан куоҕас, көхсө үрүҥ эбирдээх (чернозобая гагара)."
    },
    {
    id: "489",
    title: "Өндөй бөтүүк = өҥөй бөтүүк",
    text: "этин иһин иитиллэр фазан бииһэ бөдөҥ көтөр атыыра (индюк). "
    },
    {
    id: "490",
    title: "Лаглаҕар",
    text: "тупсаҕай, суон көстүүлээх (плотный, равноверно широкий)."
    },
    {
    id: "491",
    title: "Ап-чарахай = ап-чарай",
    text: "аптаах чалахайдыҥы хабах (волшебный плодный пузырь)."
    },
    {
    id: "492",
    title: "Силиргэх",
    text: "мас үүнээйи модьу-таҕа силиһэ (главный корень дерева)."
    },
    {
    id: "493",
    title: "Лис гыннар",
    text: "үөһэттэн тугу эмэ кытаанахха түһэрэн тыаһат (производить глухой звук тяжелого, крепкого удара)."
    },
    {
    id: "494",
    title: "Сабарай",
    text: "кэтит-киэҥ сабардааһыннаах (необъятное, огромных размеров)."
    },
    {
    id: "495",
    title: "Симэлий",
    text: "сүтэн-иҥэн хаал, суох буол (иссякать, исчезать бесследно, пропадать)."
    },
    {
    id: "496",
    title: "Тунуй",
    text: "элбээн, дэлэйэн, киэҥник тарҕан (распространяться, разносится; увеличиваться в числе, заполнять собой что-л.)."
    },
    {
    id: "497",
    title: "Ыараҥнат",
    text: "тугу эмэ илиигэр ыйаан көрөн ыараханын билгэлээ, быһаар (взвешивать, прикидывать вес чего-л.)."
    },
    {
    id: "498",
    title: "Элэмэс",
    text: "бөдөҥ маҥан ойуулардаах, эриэн дьүһүннээх (пегий)."
    },
    {
    id: "499",
    title: "Элэкис гын",
    text: "эмискэ хараххар көстөн ыл (промелькнуть перед глазами, показаться на мгновение)."
    },
    {
    id: "500",
    title: "Сап гын",
    text: "киһи тугу эмэ уобар тыаһыныы тыаһаа (произвести шум, похожий на шлепок губами)."
    },
    {
    id: "501",
    title: "Кэнэҕэһин-кэнэҕэс",
    text: "өр кэмнэр ааспыттарын кэннэ, хойутун-хойут (в далеком будущем)."
    },
    {
    id: "502",
    title: "Быралый",
    text: "дойдугуттан тэй, атын сиргэ бар (оставить родину, скитаться по разным местам)."
    },
    {
    id: "503",
    title: "Сар гын",
    text: "саккырат (лить)."
    },
    {
    id: "504",
    title: "Күрүлэччи",
    text: "дохсуннук (с громким фырканьем)."
    },
    {
    id: "505",
    title: "Хоҥкуй",
    text: "төбөҕүн төҥкөт (склонять голову)."
    },
    {
    id: "506",
    title: "Хоолдьук",
    text: "моой (шея в области первого позвонка)."
    },
    {
    id: "507",
    title: "Балай маҥаас",
    text: "бэйэтэ хара дьүһүннээх, муннуттан сүүһүгэр диэри маҥаннаах (черный с белой отметиной на лобной части)."
    },
    {
    id: "508",
    title: "Харгыйа",
    text: "суор (ворон)."
    },
    {
    id: "509",
    title: "Чылып-чалып",
    text: "чыычаах саҥатын үтүктээһин (подражание крику птички)."
    },
    {
    id: "510",
    title: "Кыыкырдаа-хаахырдаа",
    text: "биир тэҥ бытааннык кыыкыр-кыыкыр тыаһаа (издавать протяжный скрип)."
    },
    {
    id: "511",
    title: "Бэйикэй",
    text: "сэрэтэр, саанар сыһыаны көрдөрөр тыл (слово, выражающее угрозу, предупреждение)."
    },
    {
    id: "512",
    title: "Нокой",
    text: "уолаттарга, эр дьоҥҥо атастыы туһулуу (выражение дружеского обращения к мальчикам, парням, молодым мужчинам)."
    },
    {
    id: "513",
    title: "Тэгиэ = тэгил",
    text: "ыраах, тэйиччи (далекий, отдаленный)."
    },
    {
    id: "514",
    title: "Элэй-балай",
    text: "туора-маары, тэлиэс-былаас (нескладно, неуклюже)."
    },
    {
    id: "515",
    title: "Дайбаа",
    text: "илиилэргин хардары-таары иннин-кэннин диэки биэрэҥнэт (размахивать руками)."
    },
    {
    id: "516",
    title: "Көҥү",
    text: "тоҕо-хоро (в большом количестве, обильно, много раз)."
    },
    {
    id: "517",
    title: "Сараһын",
    text: "абааһыга кубулҕаттаммыт туох эмэ (ставший абааһы)."
    },
    {
    id: "518",
    title: "Эндэл",
    text: "куттал (опасность).  "
    },
    {
    id: "519",
    title: "Дьохсооттоо",
    text: "кыыһыран, суоһурҕанан дьарыйыахтыы, кэһэтиэхтии тутун (вести себя агрессивно, будто готов сейчас же напасть)."
    },
    {
    id: "520",
    title: "Ураанньык",
    text: "сырдык сурааһын (светлая полоска). "
    },
    {
    id: "521",
    title: "Дуурай",
    text: "киэҥ, улахан (широкий)."
    },
    {
    id: "522",
    title: "Тобулу",
    text: "курдары, дьөлө (насквозь)."
    },
    {
    id: "523",
    title: "Көй киин",
    text: "ханнык эмэ сир саамай киинэ (сердцевина)."
    },
    {
    id: "524",
    title: "Ньээкэ",
    text: "ким-туох эмэ үөскүүр уйата (родной очаг, родное гнездо)."
    },
    {
    id: "525",
    title: "Арыаллаа",
    text: "кими эрэ кытта бииргэ, тэҥҥэ сылдьыс (сопровождать кого-л.)."
    },
    {
    id: "526",
    title: "Соргулаа",
    text: "үчүгэйи, дьоллооҕу түстээ, төлкөлөө (предопределять кому-л. благополучие, счастливое будущее)."
    },
    {
    id: "527",
    title: "Көйүү кымыс = көйө кымыс",
    text: "өр турбут, көөнньубут уохтаах кымыс (настоявшийся, перебродивший кумыс)."
    },
    {
    id: "528",
    title: "Көнньүөр",
    text: "дуоһуй, астын, санаан көтөҕүлүн (быть в приподнятом настроении, утешаться, успокаиваться)."
    },
    {
    id: "529",
    title: "Саамал кымыс",
    text: "саамыламмыт, көөнньүбүтүн кэннэ атын улахан иһиккэ мунньан, сөрүүҥҥэ туруоран, астытан иһэргэ бэлэмнэммит кымыс (уже дошедший до кондиции, постепенно сливаемый в большой сосуд для смешивания и охлаждения, лучшего качества кумыс)."
    },
    {
    id: "530",
    title: "Саал",
    text: "сылгы  моонньун үөһээ кырыытынан үөскүүр кытаанах сыа (жировое отложение на загривке лошади)."
    },
    {
    id: "531",
    title: "Мүһэ",
    text: "сүөһү, кыыл сүһүөхтэринэн араартаан быһыллыбыта (одна из частей расчлененных конечностей скота или зверя)."
    },
    {
    id: "532",
    title: "Мохсуо",
    text: "анал бэрээдэгинэн ууруллубут кэрчик мастары таба быраҕаттаан, сурааһын таһыгар таһаарар күрэх оонньуу (спортивная игра «городки»)."
    },
    {
    id: "533",
    title: "Сарыы",
    text: "тиби тириитэ анаан олус сымнаҕас гына таҥастаммыта (специально выделанная мягкая кожа из оленьей шкуры, замша)."
    },
    {
    id: "534",
    title: "Дьаах",
    text: "атахсыт ыарыы (копытница, гнойная опухоль на конечностях животных)."
    },
    {
    id: "535",
    title: "Түнэ",
    text: "түүтэ суох таҥастаммыт таба, тайах тириитэ (замша, ровдуга)."
    },
    {
    id: "536",
    title: "Бүүппэх",
    text: "тобугу арыый ааһар остоох тирии этэрбэс (кожаная обувь с голенищами чуть выше колен)."
    },
    {
    id: "537",
    title: "Дьүлүй",
    text: "дьаныс, тугу барытын умнан туран, олус үлүһүй (увлеченно, азартно, страстно, забыв обо всем)."
    },
    {
    id: "538",
    title: "Үүс",
    text: "бэдэр (рысь)."
    },
    {
    id: "539",
    title: "Киргил",
    text: "кырымах (мех с проседью)."
    },
    {
    id: "540",
    title: "Ини-бии",
    text: "бииргэ төрөөбүт убайдыы быраат (родные братья)."
    },
    {
    id: "541",
    title: "Урусхал",
    text: "тутуу, дьиэ-уот күөдэл-таһаа буолбута (развалины, руины)."
    },
    {
    id: "542",
    title: "Ууналас",
    text: "уһаан, тэнийэн биэр (вытягиваться, растягиваться)."
    },
    {
    id: "543",
    title: "Өндөл",
    text: "үрдүк (высокий)."
    },
    {
    id: "544",
    title: "Биллэрик",
    text: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)."
    },
    {
    id: "545",
    title: "Дьэрэкээн",
    text: "эгэлгэ, сиэдэрэй өҕнөөх, ойуулаах (ярко, пестро разукрашенный, узорчатый)."
    },
    {
    id: "546",
    title: "Чыҥырҕас",
    text: "кытаанах (плотный)."
    },
    {
    id: "547",
    title: "Дуобаттаах суорҕан",
    text: "дуобат хараҕын курдук араас өҥнөөх локуйдартан аттарвыллыбыт суорҕан (клетчатое одеяло, сшитое из равных по размеру разноцветных лоскутков, похожее рисунком на шашечную доску)."
    },
    {
    id: "548",
    title: "Былааннаах",
    text: "бадахтаах"
    },
    {
    id: "549",
    title: "Дьаарбаҥ",
    text: "дьиэ сүөһүтэ мэччийэр, аһыыр сирэ (место, где пасется скот, кормятся животные, пастбище)."
    },
    {
    id: "550",
    title: "Арҕах",
    text: "дьонтон-сэргэттэн күрэнэн, түҥ тыаҕа сири хаһан оҥоһуллубут балаҕан (землянка в глухом лесу, где люди скрываются от посторонних глаз)."
    },
    {
    id: "551",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "552",
    title: "Чөҥөчөк",
    text: "эрбэммит мас силиһин кытары хаалбыт алын чааһа, төҥүргэс (пень)."
    },
    {
    id: "553",
    title: "Чүөппэ = чүөмпэ",
    text: "кыра соҕус эрээри олус дириҥ көлүйэ (небольшое, но очень глубокое озерцо).   "
    },
    {
    id: "554",
    title: "Сүөк",
    text: "атыыр сүөһү ууһатар уоргана (половой член самца крупного рогатого скота)."
    },
    {
    id: "555",
    title: "Тарай",
    text: "илиигин-атаххын былас быраҕан тиэрэ түс, тиэрэ түһэн сыт (лежать или упасть навзничь, раскинув руки-ноги)."
    },
    {
    id: "556",
    title: "Көтөх",
    text: "ииммит-хаппыт, хатыҥыр (худощавый, сухощавый)."
    },
    {
    id: "557",
    title: "Бөкчөй",
    text: "бүк түһэн, төҥкөччү туттан сырыт (наклоняться, нагибаться)."
    },
    {
    id: "558",
    title: "Хардаҥ = хагдаҥ",
    text: "үүнэрэ тохтоон саһарбыт, күөҕүн сүтэрбит (увядший, поблекший, высохший). "
    },
    {
    id: "559",
    title: "Соппоҥ",
    text: "иҥэмтэтэ суох (непитательный, низкого качества)."
    },
    {
    id: "560",
    title: "Куҥ",
    text: "сүөһү, киһи көп этэ (мясо без костей, мякоть)."
    },
    {
    id: "561",
    title: "Хаһа",
    text: "ис сыата (брюшной жир)."
    },
    {
    id: "562",
    title: "Тараһа",
    text: "ис-үөс быччыҥнардаах тас бүрүөһүнэ (брюшина)."
    },
    {
    id: "563",
    title: "Этирик түөстээ",
    text: "уҥуох-тирии буолуор диэри көлөһүннээ (доводить до крайнего истощения, изнурять работой)."
    },
    {
    id: "564",
    title: "Адарай",
    text: "арыттаах гына хаптаһынан, маһынан тэлгэтиллибит (застланный жердями, неровными досками, дощатый)."
    },
    {
    id: "565",
    title: "Иирэ талах",
    text: "имигэс лабаалаах, синньигэс сэбирдэхтээх, дьылыгырас талах (ива)."
    },
    {
    id: "566",
    title: "Уорҕа",
    text: "кыыл-сүөл көҕүс, иэн өттө, көхсө (спина, спинной хребет)."
    },
    {
    id: "567",
    title: "Оруоска",
    text: "буруйдааҕы таһыйарга анаан эрдэ быһан ыаннарыллыбыт талах эбэтэр быа кымньыы (розга)."
    },
    {
    id: "568",
    title: "Балай",
    text: "хараҥа (темный)."
    },
    {
    id: "569",
    title: "Элэ-была тыл",
    text: "туох баар истиҥ-иһирэх тылынан кимтэн эмэ тугу эмэ көрдөһөр тыл (искренние, идущие от души слова, просьба)."
    },
    {
    id: "570",
    title: "Тиһик-таһык",
    text: "биир кэккэҕэ (в ряд, в одну линию)."
    },
    {
    id: "571",
    title: "Дьиэл",
    text: "тирии халҕан (дверь, обшитая кожей)."
    },
    {
    id: "572",
    title: "Сөрөө",
    text: "эрийэ тут (обвить, обмотать)."
    },
    {
    id: "573",
    title: "Эҥэлэй",
    text: "туох эмэ ойоҕос, кытыы өттө (край, сторона чего-л.)."
    },
    {
    id: "574",
    title: "Айгыр силик",
    text: "сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)."
    },
    {
    id: "575",
    title: "Амыл-намыл",
    text: "нарын-намчы (приятный)."
    },
    {
    id: "576",
    title: "Туут хайыһар",
    text: "таба илин тыһынан бүрүллэр кэтит хайыһар (старинные большие лыжи, подбитые шкурой с передних лап оленя)."
    },
    {
    id: "577",
    title: "Кубулҕат",
    text: "дьүһүн кубулуйан хаалыы (чудесное превращение, перевоплощение)."
    },
    {
    id: "578",
    title: "Амнах",
    text: "өллөххө кэтэр таҥас, өлүнньүк таҥас (посмертная одежда)."
    },
    {
    id: "579",
    title: "Илэ-бодо",
    text: "субу баар курдук (наяву, вполне наглядно)."
    },
    {
    id: "580",
    title: "Иэримэ",
    text: "төрөөбүт-үөскээбит (родной)."
    },
    {
    id: "581",
    title: "Ахталый",
    text: "атахтаргын аччаччы быраҕан дьоһумсуйбуттуу аа-дьуо ыараханнык хаамп (шагать тяжело, медленно на широко раставленных ногах, с претензией на собственную важность)."
    },
    {
    id: "582",
    title: "Арбахдьый = арбахачый",
    text: " буралла сылдьар баттаххын арбатан сүүр (бежать, бросаясь в глаза своими растрепанными, взлохмаченными волосами)."
    },
    {
    id: "583",
    title: "Дьөһүөл",
    text: "аргыс (спутник)."
    },
    {
    id: "584",
    title: "Силэй",
    text: "иннигин мэһэйдиир тугу эмэ туора анньан халбарыт эбэтэр икки аҥыы тутан арый (раздвигать в стороны что-л., рассекать)."
    },
    {
    id: "585",
    title: "Күрдьүгэс",
    text: "туора хараҥа дьураалардаах кугас (рыжий с темными полосами)."
    },
    {
    id: "586",
    title: "Кэриэн ымыйа",
    text: "улахан ыһыахтарга элбэх киһини кэритэн кымыс иһэрдэр сэттэ-аҕыс лиитирэ истээх ымыйа (чаша круговая вместительностью в семь-восемь литров, предназначенная для питья кумыса на празднике ысыах)."
    },
    {
    id: "587",
    title: "Дьуолка",
    text: "ханан барыллыахтааҕы бэлиэтиир, көрдөрөр сиргэ, хаарга анньыллыбыт мас (палка, воткнутая в землю, указывающая нужное направление пути; веха)."
    },
    {
    id: "588",
    title: "Биһиэйэх = бадьаа",
    text: "улахан мас хамыйах (большой деревянный ковш)."
    },
    {
    id: "589",
    title: "Матааччах = матаарчах",
    text: "кымыһы уонна да атын үрүҥ аһы кутарга аналлаах, үөһээ өттүнэн үмүрүк, аллараа өттө лаппаҕар, хаһан оҥоһуллубут мас иһит, ымыйа (деревянный кубок средней величины без ножек для хранения кумыса и других молочных продуктов)."
    },
    {
    id: "590",
    title: "Томторҕо",
    text: "сэргэ ойуута (утолщение между кольцеобразными зарубками коновязи)."
    },
    {
    id: "591",
    title: "Дьаралык",
    text: "туох эмэ сыдьаана, кэрэтэ, өрөгөйө (блеск, ореол, прелесть кого-чего-либо)."
    },
    {
    id: "592",
    title: "Сэйбэй",
    text: "аллараа өттүгүнэн кэтирээн көһүн (быть, казаться расширяющимся книзу).	"
    },
    {
    id: "593",
    title: "Күрэҥ",
    text: "кытарымтыйан көстөр бороҥ (бурый, красноватый; мышастый)."
    },
    {
    id: "594",
    title: "Дьаҕыл",
    text: "санныгар эбэтэр моонньугар сүрүн өҥүттэн туспа дьүһүннээх улахан ойуулаах (имеющий большое пятно на лопатках или на шее)."
    },
    {
    id: "595",
    title: "Саалыр",
    text: "харатыҥы сиэллээх, кутуруктаах, сиһэ туртаҕар, кытархайдыҥы саһархай бороҥ (светло-рыжий с черным хвостом и гривой, буланый)."
    },
    {
    id: "596",
    title: "Силигилээ",
    text: "тубус, туругур, күүһүр (расцвести, стать лучше, сильнее, мощнее)."
    },
    {
    id: "597",
    title: "Араҕас далбарҕа = араҕас далбар",
    text: "байылыат, уйгу-быйаҥ (изобилие, плодородие, богатство)."
    },
    {
    id: "598",
    title: "Токкоолоо",
    text: "арахпакка сураҕалас, ымпыктаан-чымпыктаан, төрдүн-төбөтүн түөрсэн туоһулас, ыйыталас (расспрашивать подробно, до мелочей кого-л. о чем-л.)."
    },
    {
    id: "599",
    title: "Күттүөннээх",
    text: "киһи ылынарын курдук ыллыктаах, көдьүүстээх (полезный, путный, достойный)."
    },
    {
    id: "600",
    title: "Көмнөх",
    text: "маска олорон хаалбыт хаар (снег, осевший на ветвях деревьев и на кустах)."
    },
    {
    id: "601",
    title: "Эбир-дуоссун",
    text: "биир кэлим буолбатах, сорох өттүнэн хараҥатыйан, сороҕор сырдаан көстөр быһыттаҕас былыттар бөлөхтөрө (перисто-кучевые облака)."
    },
    {
    id: "602",
    title: "Илигирэччи",
    text: "түргэн-түргэнник, тэтимнээхтик (вибрируя, мелко)."
    },
    {
    id: "603",
    title: "Илэҥ-халаҥ",
    text: "сэргэх (оживленный)."
    },
    {
    id: "604",
    title: "Түөрэм = түөрэҥ",
    text: "дьоҕус, түөрэҥэлэс (тонкий, шаткий)."
    },
    {
    id: "605",
    title: "Үмүрүс гын",
    text: "киэҥ буолан баран бүтэһигин диэки сыыйа эбэтэр тосту соҕус кыараа, төгүрүйэ суптуй (суживаться, стягиваться с краев к центру)."
    },
    {
    id: "606",
    title: "Көнтөс",
    text: " сиэлинэн хатыллыбыт хас да утаҕы холбуу тигэн оҥоһуллубут хаптаҕай быа (лошадиный повод из конского волоса)."
    },
    {
    id: "607",
    title: "Күлүмэх",
    text: "дохсун, наһаа түргэн (бурный, стремительный, молниеносный)."
    },
    {
    id: "608",
    title: "Тэһиин",
    text: "ыҥыыр акка икки өттүнэн үүнүгэр баайан салайар быа (повод, поводья)."
    },
    {
    id: "609",
    title: "Дьирим",
    text: "ыҥыырга холуну ыга тардар хаптаҕай кур курдук оҥоһуулаах тирии быа (плоский кожаный ремень для подтягивания подпруги седла)."
    },
    {
    id: "610",
    title: "Холун",
    text: "ыҥыыр, ат өрөҕөтүн курдуу баран, дьириминэн тардыллан бааллар, бирээскэлээх уһун быата (широкий ремень седла или седелки, затягиваемый под брюхом лошади, подпруга)."
    },
    {
    id: "611",
    title: "Көс",
    text: "сахалыы уста кээмэйэ, ортотунан 10 килэмиэтир ыраахха тэҥнэһэр (якутская мера длины, равная в среднем 10 км)."
    },
    {
    id: "612",
    title: "Кулуба",
    text: "өрөбөлүүссүйэ иннинэ Саха сиригэр улуус быыбардаммыт баһылыга (до революции в Якутии улусный голова)."
    },
    {
    id: "613",
    title: "Куоттук = куортук",
    text: "урут нэһилиэк кинээһэ дуоһунаһын бэлиэтэ оҥостон куругар иилинэр кынчаала (кортик). "
    },
    {
    id: "614",
    title: "Орох",
    text: "киһи сиһин тоноҕоһун батыһа барар куоһах (ложбинка)."
    },
    {
    id: "615",
    title: "Битий",
    text: "өрүтэ көтүөккэлээн, ьыастаахтык лигийэн ыстаҥалаа, үҥкүүлээ (прыгать, плясать, громко топая ногами)."
    },
    {
    id: "616",
    title: "Кирбии",
    text: "биир субурҕа буолан сытар (растянутые в одну линию)."
    },
    {
    id: "617",
    title: "Үргүөһүн = үргүөр",
    text: "күүстээх тымныы тыал (сильный пронизывающий холодный ветер)."
    },
    {
    id: "618",
    title: "Үөрбэ",
    text: "уһуктаах синньигэс мас эбэтэр тимир (заостренный кол, шест, рожон)."
    },
    {
    id: "619",
    title: "Көҕүл",
    text: "сылгы сүүһүн саба түһэр илин сиэлэ (прядь гривы, падающая на лоб лошади, челка)."
    },
    {
    id: "620",
    title: "Сээлбиир",
    text: "тэлээрэр (разлетающий)."
    },
    {
    id: "621",
    title: "Нуоҕай",
    text: "бэргэһэ оройуттан намылыйан дугалыы түспүт куорсун эбэтэр түү (перо, висящее дугой на верхушке, макушке шапки)."
    },
    {
    id: "622",
    title: "Көмөгөй",
    text: "хабарҕа болчуога (кадык, адамово яблоко)."
    },
    {
    id: "623",
    title: "Көччөх",
    text: "күһүҥҥү көтөн эрэр кус оҕото (молодая осенняя утка)."
    },
    {
    id: "624",
    title: "Көбөҥкү = көбөҥкө",
    text: "күүһэ, сэниэтэ суох, түргэнник сылайар (невыносливый, слабосильный)."
    },
    {
    id: "625",
    title: "Алыһар",
    text: "күөхтүҥү өҥнөөх, курдуу барар хара дьураалардаах, үрүҥ эттээх балык (окунь озерный)."
    },
    {
    id: "626",
    title: "Ардьаһыт",
    text: "ардьа туунан бултуур киһи (тот, кто рыбачит вершой)."
    },
    {
    id: "627",
    title: "Аллааҥкы",
    text: "күөл аата (название озера)."
    },
    {
    id: "628",
    title: "Баргый",
    text: "ырдьыгынас хойуу саҥата таһаар (издавать лающее звуки низкого тона)."
    },
    {
    id: "629",
    title: "Мунду",
    text: "күөлгэ үөскүүр сырдык өрөҕөлөөх хараҥа систээх кыра балык (гольян озерный)."
    },
    {
    id: "630",
    title: "Борбуй",
    text: "киһи-сүөһү такымын үөһээ өттө (начало толстых бедренных мышц с обратной стороны колена у человека и животных)."
    },
    {
    id: "631",
    title: "Боруу",
    text: "уулаах сиргэ үүнэр кэбирэх умнастаах от (травянистое растение, произрастающее в водоемах)."
    },
    {
    id: "632",
    title: "Таныы",
    text: "мурун үүтэ, көҥдөйө, аллараа кырыыта (ноздря, ноздри)."
    },
    {
    id: "633",
    title: "Татыйык",
    text: "барабыайдар этэрээттэригэр киирсэр эриэн дьүһүннээх кыра ырыаһыт чыычаах (синица)."
    },
    {
    id: "634",
    title: "Кураҕаччы",
    text: "уһун атахтаах, элбэх саҥалаах чөкчөҥө бииһэ, көтөр (большой веретенник)."
    },
    {
    id: "635",
    title: "Быттык",
    text: "кыыл, сүөһү, киһи атаҕын уонна иһин икки арда (пах)."
    },
    {
    id: "636",
    title: "Быллырыыт = былдьырыыт",
    text: "күрэҥниҥи бороҥ дьүһүннээх, синньигэс тумустаах, араҕас атахтаах чөкчөҥө көрүҥэ (кулик, бекас сибирский)."
    },
    {
    id: "637",
    title: "Липпэ",
    text: "күөл торфата (озерный торф)."
    },
    {
    id: "638",
    title: "Мөгүөн = мөҥүөн",
    text: "туох эмэ саамай үрдүк сирэ, оройо, чыпчаала (самый верх, верхняя часть, верхушка, макушка чего-л.)."
    },
    {
    id: "639",
    title: "Кычым",
    text: "ыҥыыр икки өттүнэн ат ойоҕоһун саба түһэр тирии кэлим лоскуйа (тебенок, тебеньки седельные)."
    },
    {
    id: "640",
    title: "Чаппараак = чаппараах",
    text: "ыҥыыр кэннинэн ат самыытыгар саба уурар, бүрүйэр, ойуулаах-оһуордаах, киэргэллээх таҥас (убранство коня: расшитая, урашенная чем-л. ткань, покрывающая крестец, чепрак, попона)."
    },
    {
    id: "641",
    title: "Хоҥсуоччут",
    text: "ыҥыыр бүргэһигэр тимир күрүчүөк (железный крюк на луке седла)."
    },
    {
    id: "642",
    title: "Хаҥырҕас",
    text: "халыгырас-кылыгырас тыастаах тиэрбэс киэргэл, аарык (предмет украшения в виде металлических колечек, побрякивающий, позвякивающий при встряхивании)."
    },
    {
    id: "643",
    title: "Тиэрбэс",
    text: "туох эмэ кытаанах синньигэс матырыйаалтан оҥоһуллубут төгүрүк (предмет из твердого материала в форме окружности, обода, кольцо)."
    },
    {
    id: "644",
    title: "Сапсылҕан",
    text: "өрө-таҥнары хамсаан чыпчылыйбахтыыр (моргающий, подвижный)."
    },
    {
    id: "645",
    title: "Сандырыыс = сындырыыс",
    text: "сытыы, эриллэҥнии сылдьар (хлесткий, извивающийся)."
    },
    {
    id: "646",
    title: "Халдьаайы",
    text: "үрдүк сыыр, томтор (косогор, пригорок, холм)."
    },
    {
    id: "647",
    title: "Куула",
    text: "соҕуруу күлүктээх, күн аанньа көрбөт өттө (южная тенистая, малоосвещаемая солнцем сторона местности)."
    },
    {
    id: "648",
    title: "Куртуйах",
    text: "мас көтөрүн көрүҥэ: атыыра хара өҥнөөх, тыһыта болооркой (тетерев)."
    },
    {
    id: "649",
    title: "Эниэ",
    text: "хайа, сыыр иҥнэри түһэр ньуура (наклонная поверхность, покатость, склон горы, холма)."
    },
    {
    id: "650",
    title: "Эрдэҕэс",
    text: "улар тыһыта (самка глухаря, глухарка)."
    },
    {
    id: "651",
    title: "Мындаа",
    text: "туох эмэ саамай үрдэ, арҕаһа (самая возвышенная, высокая часть чего-л.)."
    },
    {
    id: "652",
    title: "Чөмчөрүс гын",
    text: "хоп-дьип, дьыпса буолан көһүн (быть, казаться аккуратным, опрятным)."
    },
    {
    id: "653",
    title: "Айгырас",
    text: "дэлэйдик, сиэдэрэйдик намылыйан түспүт (свясающий, ниспадающий)."
    },
    {
    id: "654",
    title: "Аан дапсыыр",
    text: "туох эмэ улаханнык охсор, силлиэрэр тыаһа-ууһа (сильный, раскатистый грохот)."
    },
    {
    id: "655",
    title: "Элгээн",
    text: "сир хайа барыытыгар үөскээбит, туруору кытыылаах кыракый дириҥ күөл (небольшое глубокое озеро с высокими обрывистыми берегами, образовавшееся в результате глубоких трещин в земле)."
    },
    {
    id: "656",
    title: "Эмти",
    text: "туох эмэ кытыыта эмтэрийэн, ойдон түһэрин курдук (так, чтобы образовалась выщербинка в виде полукруглого углубления)."
    },
    {
    id: "657",
    title: "Тыымпы",
    text: "тыа ортотугар сытар, кытылыгыар сыһыыта-хонуута суох күөл (озеро в лесу)."
    },
    {
    id: "658",
    title: "Уолах",
    text: "орто улахан (средней величины)."
    },
    {
    id: "659",
    title: "Улуһа-кэлиһэ",
    text: "улаханнык уонна уһуннук үрэр курдук саҥаны таһаара (воя, скуля)."
    },
    {
    id: "660",
    title: "Эмэх",
    text: "сытыйан, бытарыйа сылдьар буолбут мас (сгнившее, гнилое трухлявое дерево)."
    },
    {
    id: "661",
    title: "Имииһит",
    text: "тириини имитиинэн таптаан дьарыктанааччы, тириини сатаан имитэр киһи (тот, кто занимается выделкой кожи, кожевник)."
    },
    {
    id: "662",
    title: "Иэгэй-куоҕай",
    text: "умса-тиэрэ, босхо барыах курдук, араастаан иэҕиллэҥнээ (сгибаться, изгибаться, нагибаться)."
    },
    {
    id: "663",
    title: "Энэлий",
    text: "улахан ыарыыттан, аһыыттан суланар курдук уһуннук саҥа таһаара-таһаара ынчыктаа, ытаа (громко, протяжно стонать, плакать, причитать, стенать)."
    },
    {
    id: "664",
    title: "Торҕон",
    text: "быстаран сылдьар, наһаа аччык (голодный)."
    },
    {
    id: "665",
    title: "Сыгынах",
    text: "силистэри түөрүллэн охтубут улахан мас (корень дерева, вывороченный с землей)."
    },
    {
    id: "666",
    title: "Сырҕан",
    text: "эһэ (медведь)."
    },
    {
    id: "667",
    title: "Тэлэһий",
    text: "ыраат, тэй (отдаляться от места проживания, скитаться)."
    },
    {
    id: "668",
    title: "Быыпаһын",
    text: "туох баар күүскүн барытын түмэн ыл, бааргын-суоххун барытын түмүнэн түс (сильно напрягаться)."
    },
    {
    id: "669",
    title: "Хоһуҥураа",
    text: "тыастаахтык тыын (храпеть)."
    },
    {
    id: "670",
    title: "Аллаах",
    text: "түргэн сырыылаах, эрчимнээх (быстрый, ходкий)."
    },
    {
    id: "671",
    title: "Ахсым",
    text: "наһаа дохсун, уһуу (очень горячий, ретивый, резвый)."
    },
    {
    id: "672",
    title: "Амнах",
    text: "өллөххө кэтэр таҥас, өлүнньүк таҥас (посмертная одежда)."
    },
    {
    id: "673",
    title: "Көмнөх",
    text: "маска олорон хаалбыт хаар (снег, осевший на ветвях деревьев и на кустах)."
    },
    {
    id: "674",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "675",
    title: "Көнньүөс торҕо курдук",
    text: "күөх солко курдук (как китайский шелк зеленого цвета)."
    },
    {
    id: "676",
    title: "Дьабака",
    text: "дьахтар бэргэһэтэ (женская шапка)."
    },
    {
    id: "677",
    title: "Киил",
    text: "олус кытаанах (очень крепкий)."
    },
    {
    id: "678",
    title: "Үөһүн сүмэтэ",
    text: "үөстэн тахсар убаҕас (жёлчь)."
    },
    {
    id: "679",
    title: "Өлүү дьирибинэ балык",
    text: "Аллараа дойду балыга (рыба Нижнего мира)."
    },
    {
    id: "680",
    title: "Иҥэрчэ",
    text: "ох сааны эрийбит иҥиир (сухильная обмотка лука и стрелы)."
    },
    {
    id: "681",
    title: "Уорҕатын тириитэ",
    text: "көхсүн тириитэ (шкура вдоль хребта)."
    },
    {
    id: "682",
    title: "Өлүү даарда балык",
    text: "Аллараа дойду балыга (рыба Нижнего мира)."
    },
    {
    id: "683",
    title: "Кирис",
    text: "айа кирсэ (тетива лука)."
    },
    {
    id: "684",
    title: "Чаачар",
    text: "ох саа (лук)."
    },
    {
    id: "685",
    title: "Сандаала көмүс оноҕос",
    text: "тимирдэрдээх оноҕос (стрела с нашитыми железными пластинками)."
    },
    {
    id: "686",
    title: "Харыс",
    text: "былыргы уста кээмэйэ: ууннары тутуллубут эрбэх төбөтүн уонна ортоку тарбах төбөтүн икки ардын саҕа уста (мера длины: большая пядь, равная расстоянию между концами расстянутых большого и среднего пальцев)."
    },
    {
    id: "687",
    title: "Модьоҕо",
    text: "аан боруога (порог)."
    },
    {
    id: "688",
    title: "Саҕаһа",
    text: "оһох уотун уматарга туттуллар тымтык (лучина для разведения огня)."
    },
    {
    id: "689",
    title: "Тый",
    text: "иккилээх убаһа (двухгодовалый жеребенок)."
    },
    {
    id: "690",
    title: "Дьаллык",
    text: "куһаҕан дьарык, кэмэлдьи (порок, дурная привычка)."
    },
    {
    id: "691",
    title: "Дьаллык, сотуун, кыдьык, хамсыык өлүү кыргыттара",
    text: "абааһы кыргыттара (девки-чудовища, враждебные человечеству)."
    },
    {
    id: "692",
    title: "Сотуун",
    text: "сыстыганнаах бааһырар ыарыы (сибирская язва)."
    },
    {
    id: "693",
    title: "Үөт түрэх",
    text: "уоту булкуйар мас (кочерга)."
    },
    {
    id: "694",
    title: "Аал Луук Мас",
    text: "Орто дойдуну араҥаччылыыр мас (священное древо страны олонхо)."
    },
    {
    id: "695",
    title: "Хоруом",
    text: "хоруол."
    },
    {
    id: "696",
    title: "Аан эскэл",
    text: "толору эттээх-сииннээх, эмис (об очень полном, плотном человеке)."
    },
    {
    id: "697",
    title: "Чаллах хатыҥ",
    text: "хойуу сэбирдэхтээх кыра хатыҥ (низкорослая ветвистая береза)."
    },
    {
    id: "698",
    title: "Кымньыы",
    text: "аты түргэтэтээри охсор анал талах (кнут, плеть)."
    },
    {
    id: "699",
    title: "Дьалаҕай",
    text: "тугу да хоҥоруутугар хоҥнорбот (небрежный, неаккуратный)."
    },
    {
    id: "700",
    title: "Холоҥсо",
    text: "куһаҕан сыт (специфический дурной запах)."
    },
    {
    id: "701",
    title: "Сүллүгэс",
    text: "охсуһарга аналлаах баалкы (палка, используемая в сражении)."
    },
    {
    id: "702",
    title: "Эбир былыт",
    text: "быһыттаҕас былыт (перистые облака)."
    },
    {
    id: "703",
    title: "Иэнигий",
    text: "ыараханнык дуораһый, ииригир (издается тяжелый, плохо действующий на нервы звук)."
    },
    {
    id: "704",
    title: "Үөмэх былыт",
    text: "хойуу былыт (куча туч)."
    },
    {
    id: "705",
    title: "Сата былыт",
    text: "ап күүһүнэн мустубут былыт (туча, вызываемая колдовством)."
    },
    {
    id: "706",
    title: "Чуурукта",
    text: "хоту үүнэр болбукта (кедровый стланик)."
    },
    {
    id: "707",
    title: "Симилэх",
    text: "хойуутук үүммүт талахтаах сир (местность с густыми тальниками)."
    },
    {
    id: "708",
    title: "Оҥхолоот",
    text: "хотоол, хаспах (ложбина, низина)."
    },
    {
    id: "709",
    title: "Барыкы-сарыкы",
    text: "хараҥа (темно)."
    },
    {
    id: "710",
    title: "Бадаарынай = бадаар",
    text: "бөдөҥ-садаҥ, уһулуччу ойон тахсыбыт курдук адаархай (громоздкий, торчащий острыми концами)."
    },
    {
    id: "711",
    title: "Баҕадьы = баҕайы",
    text: "сөбүлээбэт, абааһы көрөр, кэлэйэр, сэниир сыһыаны көрдөрөр тыл (выражает неодобрение, осуждение, сильное разочарование, пренебрежение, отвращение)."
    },
    {
    id: "712",
    title: "Өҕүмэр",
    text: "үс-түөрт саастаах сүөһү (рогатый скот в возрасте 3-4 лет)."
    },
    {
    id: "713",
    title: "Күлгэри",
    text: "үөн (ящерица)."
    },
    {
    id: "714",
    title: "Байтаһын",
    text: "өлөрөн сииргэ анаммыт төрөөбөтөх сүөһү (нагульный скот)."
    },
    {
    id: "715",
    title: "Иирээн-мэнэрик",
    text: "ииригирбит (истеричный)."
    },
    {
    id: "716",
    title: "Бэчир = бэчирик",
    text: "иһирик, симилэх (лесная чаща)."
    },
    {
    id: "717",
    title: "Дэриэтинньик",
    text: "илэ сылдьар абааһы, киһини сиэччи (зомби, нечисть, чудовище)."
    },
    {
    id: "718",
    title: "Куойа",
    text: "куйуур иэҕэн оҥоһуллубут мас иитэ (ободок рыболовного сака)."
    },
    {
    id: "719",
    title: "Маҥкы",
    text: "куйуур ураҕаһа, эргитэр маһа (рукоятка рыболовного сака)."
    },
    {
    id: "720",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "721",
    title: "Идэмэр",
    text: "иҥсэ, обот (жадность, алчность)."
    },
    {
    id: "722",
    title: "Кута-намылҕа",
    text: "дириҥ уулаах дьэбэрэ (колыхающаяся трясина)."
    },
    {
    id: "723",
    title: "Үтэһэ",
    text: "эт үөлэр мас (рожон для шашлыка)."
    },
    {
    id: "724",
    title: "Арыҥах",
    text: "силиһэ түөрүллэн иҥнэри түспүт мас (вывороченное с корнем дерево)."
    },
    {
    id: "725",
    title: "Түнэ",
    text: "түүтэ суох таҥастаммыт таба, тайах тириитэ (замша, ровдуга)."
    },
    {
    id: "726",
    title: "Марба",
    text: "улахан ис (большой живот, пузо)."
    },
    {
    id: "727",
    title: "Куруҥ",
    text: "өрт уотугар умайбыт тыа (выжженный лес)."
    },
    {
    id: "728",
    title: "Көтөллөөх",
    text: "батыһыылаах (здесь: водит за собой много белок)."
    },
    {
    id: "729",
    title: "Хаппар",
    text: "курга иилинэр кыра суумка (сумка, которую носят сбоку не ремне)."
    },
    {
    id: "730",
    title: "Туоһахта",
    text: "сүөһү сүүһүгэр баар маҥан бээтинэ (святлое пятно на лбу)."
    },
    {
    id: "731",
    title: "Бочугурас",
    text: "мас көтөрө (рябчик)."
    },
    {
    id: "732",
    title: "Куоттук = куортук",
    text: "урут нэһилиэк кинээһэ дуоһунаһын бэлиэтэ оҥостон куругар иилинэр кынчаала (кортик)."
    },
    {
    id: "733",
    title: "Сарбынньахтаах",
    text: "кытыыта биир тэҥник кэрдиистэнэ бысталанан киэргэтиллибитэ (украшенный зубчатой резьбой, зубчатым украшением)."
    },
    {
    id: "734",
    title: "Илбиргэс",
    text: "туохха эмэ ыйанан эйэҥэлии сылдьар киэргэл (небольшое подвесное украшение, подвеска)."
    },
    {
    id: "735",
    title: "Дьөллүргэ",
    text: "туох эмэ мэһэй буолара (помеха, обуза)."
    },
    {
    id: "736",
    title: "Бытырыыстаах",
    text: "кытыыта кэккэлэччи намылыйа сылдьар быалардаах (украшенный бахромой)."
    },
    {
    id: "737",
    title: "Солоҥдо",
    text: "ойуур кыыла (хорёк)."
    },
    {
    id: "738",
    title: "Осхор",
    text: "атырдьах курдук төбөлөөх оноҕос (стрела с вилообразным наконечником)."
    },
    {
    id: "739",
    title: "Тыҥкырай",
    text: "оноҕос көрүҥэ (определенный вид стрелы)."
    },
    {
    id: "740",
    title: "Элбэрээччик",
    text: "саанан ытар эбэтэр айаны эһэр киһи (стрелок из лука или самострела)."
    },
    {
    id: "741",
    title: "Баладыт",
    text: "хараарт, киртит (очернить)."
    },
    {
    id: "742",
    title: "Тунуй",
    text: "элбээн, дэлэйэн, киэҥник тарҕан (распространяться, разносится; увеличиваться в числе, заполнять собой что-л.)."
    },
    {
    id: "743",
    title: "Үөрбэк-чүөрбэк",
    text: "сэрэммитии, дьаархаммыттыы (тревожно)."
    },
    {
    id: "744",
    title: "Токкоолоо",
    text: "арахпакка сураҕалас, ымпыктаан-чымпыктаан, төрдүн-төбөтүн түөрсэн туоһулас, ыйыталас (расспрашивать подробно, до мелочей кого-л. о чем-л.)."
    },
    {
    id: "745",
    title: "Майдаан",
    text: "муҥха балыгын мунньар миэстэ (место, где вливают добытую неводом рыбу)."
    },
    {
    id: "746",
    title: "Сымара таас",
    text: "көһөҥө таас (каменная глыба)."
    },
    {
    id: "747",
    title: "Кыдама",
    text: "от кээһэргэ туттуллар атырдьах (вилы для стогометания)."
    },
    {
    id: "748",
    title: "Өрүөллээх",
    text: "хотой ойуулаах (с изображением орла)."
    },
    {
    id: "749",
    title: "Бирисээгэлээх",
    text: "уларыйбат кытаанах дьаһаллаах (с жестким приказом, распоряжением)."
    },
    {
    id: "750",
    title: "Өтөҕөлөөх",
    text: "ураһа быһыылаах бэргэһэлээх (с остроконечной шапкой)."
    },
    {
    id: "751",
    title: "Барысыай",
    text: "төлкө, дьылҕа (судьба, участь)."
    },
    {
    id: "752",
    title: "Сэрэбиэй",
    text: " туох эрэ биллибэти,  киһиэхэ  туох  эмэ  төһө  табыллыаҕын хаартынан таайан көрүү (жребий,  гадание  (на  картах))."
    },
    {
    id: "753",
    title: "Томторҕо",
    text: "сэргэ ойуута (утолщение между кольцеобразными зарубками коновязи)."
    },
    {
    id: "754",
    title: "Чороон ымыйа",
    text: "кэритэн иһэргэ аналлаах чороон (старинная круговая чаша для кумысопития)."
    },
    {
    id: "755",
    title: "Көлүөтүнэн",
    text: "толору (полный)."
    },
    {
    id: "756",
    title: "Тараһа",
    text: "ис-үөс быччыҥнардаах тас бүрүөһүнэ (брюшина)."
    },
    {
    id: "757",
    title: "Ымай киэлитэ",
    text: "ийэ иһигэр оҕо хаата (матка, утроба матери)."
    },
    {
    id: "758",
    title: "Хапчаҕай",
    text: "дьахтар төрүүр-ууһуур этэ-сиинэ (родовые пути роженицы)."
    },
    {
    id: "759",
    title: "Суорума",
    text: "быстах өлүүгэ өлүү (преждевременная смерть)."
    },
    {
    id: "760",
    title: "Кэний-кэмнээ",
    text: "манна: олохтоохтук толкуйдаа (хорошо продумать).  "
    },
    {
    id: "761",
    title: "Сиэллэр",
    text: "ойуолаппакка, түргэн соҕустук айаннат (ехать рысью)."
    },
    {
    id: "762",
    title: "Дьигиһит",
    text: "ибигирээн айаннаа (трястись при езде)."
    },
    {
    id: "763",
    title: "Кубулҕат",
    text: "киитэрэй, албын (хитрый)."
    },
    {
    id: "764",
    title: "Хоолдьук",
    text: "моой (шея в области первого позвонка)."
    },
    {
    id: "765",
    title: "Маҕаас",
    text: "маҥан төбөлөөх (белоголовый, беломордный)."
    },
    {
    id: "766",
    title: "Көллүбүт",
    text: "токуйа сылдьан баран көммүт (выпрямленный)."
    },
    {
    id: "767",
    title: "Барыкыс гын",
    text: "хараҥаҕа эмискэ баар буола түс (внезапно появиться в сумерках)."
    },
    {
    id: "768",
    title: "Ыарҕа",
    text: "талах ойуур (мелкий кустарник тальника)."
    },
    {
    id: "769",
    title: "Соппулуот",
    text: "олбуор (забор)."
    },
    {
    id: "770",
    title: "Сири иһит",
    text: "тирииттэн тигиллибит үүт аһылыкка аналлаах иһит (сосуд из выделанной кожи)."
    },
    {
    id: "771",
    title: "Кэриэн айах",
    text: "кэритэн кымыс иһэр иһит (круговая чаша для кумысопития)."
    },
    {
    id: "772",
    title: "Матаарчах",
    text: "үүт аска аналлаах маһы хаһан оҥоһуллубут иһит (деревянный сосуд в виде усеченного конуса для хранения молочных продуктов)."
    },
    {
    id: "773",
    title: "Көр дьаҕыл",
    text: "манна: көр-нар төрүттэммит түһүлгэтэ диэн суолтаҕа туттуллубут (веселье, развлечения)."
    },
    {
    id: "774",
    title: "Салаҥ",
    text: "сатаан туттубат (неумелый)."
    },
    {
    id: "775",
    title: "Ньуур",
    text: "сирэй (лицо)."
    },
    {
    id: "776",
    title: "Чиргэл",
    text: "тирэхтээх, кыахтаах (крепкий, здоровый)."
    },
    {
    id: "777",
    title: "Ачастааттаах",
    text: "үөрэхтээх (образованный; от рус.: аттестат)."
    },
    {
    id: "778",
    title: "Тэримньи",
    text: "тэрээһин (мероприятие)."
    },
    {
    id: "779",
    title: "Этэттээ",
    text: "ыам кэннэ үүт хаалбатын диэн кулунчукка өссө эмнэр (припускать после удоя жеребенка к кобыле)."
    },
    {
    id: "780",
    title: "Кытыылыыр",
    text: "үстээх-түөртээх эдэр сылгы (конский молодняк до 2–3 лет)."
    },
    {
    id: "781",
    title: "Ороһулаа",
    text: "хойутаан төрөө (поздно родиться)."
    },
    {
    id: "782",
    title: "Дьэллик",
    text: "мэнээк сылдьар (бродячий)."
    },
    {
    id: "783",
    title: "Быһымах",
    text: "түргэн (быстрый)."
    },
    {
    id: "784",
    title: "Дьаҕа",
    text: "саха музыкальнай инструмена (музыкальный инструмент якутов)."
    },
    {
    id: "785",
    title: "Кырыыс",
    text: "киһиэхэ куһаҕаны баҕарыы (проклятие)."
    },
    {
    id: "786",
    title: "Буом",
    text: "сылдьарга эрэйдээх, мэһэйдэрдээх; кыбычыын (трудный, труднопроходимый; тесный, узкий)."
    },
    {
    id: "787",
    title: "Төргүл = төргүү",
    text: "ыҥыыр кэннигэр таһаҕаһы баайарга аналлаах быа (торока, ремешки для привязывания чего-л.).  "
    },
    {
    id: "788",
    title: "Тумары",
    text: "хойуу  туманнаах (покрытый  густым  туманом,  туманный)."
    },
    {
    id: "789",
    title: "Сандылыкы",
    text: "сандыл-күндүл: сандааран-күндээрэн, күлүмүрдэтэн (так,  чтобы сияло, сверкало)."
    },
    {
    id: "790",
    title: "Дьабадьы",
    text: "киһи, сүөһү айаҕын икки өттүнэн үөһээ, аллараа уостара силбэһэр сирдэрэ (угол рта)."
    },
    {
    id: "791",
    title: "Хайырҕахтаах хара быар =  хайҕахтаах хара быар",
    text: "быары хоһуйар халбаҥнаабат эпитет, суолтата – кыраҕа хамнаабат, ньыгыл (постоянный эпитет печени, значение – крепкий, плотный, постоянный)."
    },
    {
    id: "792",
    title: "Сүүл",
    text: "сүөһү, кыыл, көтөр атыыра  тыһытын  сабарга  көхтөнүүтэ, атыырҕааһына (готовность к соитию у самцов диких, домашних животных, птиц, возбуждение)."
    },
    {
    id: "793",
    title: "Күөһээн = күөһүүр",
    text: "тыһыга  көҕүй (возбуждаться, иметь охоту к случке)."
    },
    {
    id: "794",
    title: "Таллан",
    text: "бэйэтин ханыылаахтарыттан быдан бөдөҥ-садаҥ, улахан (выделяющийся величиной, большим объёмом, размером)."
    },
    {
    id: "795",
    title: "Күннүк",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "796",
    title: "Төгүрүччүлээх",
    text: "быһа  буолбакка,  эргийэ  барар,  эргиир  (суол  туһунан) (окольный, обходный (о дороге)."
    },
    {
    id: "797",
    title: "Дэриэспэ",
    text: "туой булкаастаах кумах биир кэлим буола силимнэспититтэн үөдүйбүт кэбирэх, үксүгэр араҥалардаах дьапталҕа таас (глинистый песчаник; дресва)."
    },
    {
    id: "798",
    title: "Дэбилий",
    text: "өрө үтэн, үллэн таҕыс, бурулуй (бурлить, бурно кипеть, клокотать, переполняться)."
    },
    {
    id: "799",
    title: "Диэлий",
    text: "булкуһан сүппэккэ баһыйан таҕыс, ордук билин (туох эмэ тус-туһунан булкуспутуттан биирэ  баһыйарын  этиллэр (преобладать,  превалировать)."
    },
    {
    id: "800",
    title: "Саадьаҕай",
    text: "сиһин батыһа үрүҥнээх, үрүҥ систээх (ынах сүөһү уонна көтөр дьүһүнүгэр) (С белой полосой  вдоль  хребта,  с  белой  спиной  (о масти крупного рогатого скота или окрасе птиц)."
    },
    {
    id: "801",
    title: "Дьайаан",
    text: "туох эмэ үлүскэнэ, уххана (азартное увлечение, воодушевленное  занятие  чем-л.).  "
    },
    {
    id: "802",
    title: "Өҕүрүмэр = өҕүмэр",
    text: "үс-түөрт саастаах сүөһү (рогатый скот в возрасте 3-4 лет)."
    },
    {
    id: "803",
    title: "Чаачар",
    text: "ох саа (лук)."
    },
    {
    id: "804",
    title: "Кирис",
    text: "чаачары тардар хатыллыбыт тирии быа (тетива)."
    },
    {
    id: "805",
    title: "Тордох",
    text: "туох эмэ умайарыгар  ситэри  күл  буолбакка  буруону кытта тахсыһар хоруо (копоть)."
    },
    {
    id: "806",
    title: "Чарпаана",
    text: "туох  эмэ бытархайа, кыырпаҕа (небольшие части чего-л.).  П.  Аввакумов."
    },
    {
    id: "807",
    title: "Хотоҕой",
    text: "көтөр кыната, дабыдала (крыло птицы)."
    },
    {
    id: "808",
    title: "Өлбүргэлээх = өлбүргэ",
    text: "түүлээх тириитин уорҕатын кэлин диэки өттө (огузок, шкурка с задней части животного)."
    },
    {
    id: "809",
    title: "Чымаадыс",
    text: "киэмсик, үтүөмсүк (жеманный,  манерный).  "
    },
    {
    id: "810",
    title: "Арҕары=арҕар",
    text: "киэҥ сирдэринэн сырыт, сири-дойдуну элбэхтик кэрий, тилэ сүүр (побывать во многих местах, исходить повсюду вдоль и поперек)."
    },
    {
    id: "811",
    title: "Хоҥоруу дуорсун = хоҥоруу дьуорсун",
    text: "үрдүк, маһа суох сир (возвышенная, без деревьев)."
    },
    {
    id: "812",
    title: "Көҥүс",
    text: "суулла турар биэрэктээх дириҥ аппа үрэх (речка с обрывистыми берегами, протекающая по глубоким оврагам)."
    },
    {
    id: "813",
    title: "Кирдьик",
    text: "кырдьык (правда)."
    },
    {
    id: "814",
    title: "Күөрэҥсэ",
    text: "сотору-сотору өрүтэ күөрэйтэлиир, күөрэс гынар (равномерно, регулярно взлетающий вверх)."
    },
    {
    id: "815",
    title: "Баабыр",
    text: "күүстээх, модун, сүҥкэн (сильный, могучий, огромный).  "
    },
    {
    id: "816",
    title: "Хотору",
    text: "өлгөмнүк (в изобилии)."
    },
    {
    id: "817",
    title: "Холлороон",
    text: "сорох кыыл, киһи сылдьарыгар, хорҕойоругар сөптөөх сир аннынан баар көҥдөй, хороон, хаспах (естественное или искусственное полое пространство, проход под землёй, подземелье, подземный ход)."
    },
    {
    id: "818",
    title: "Буолускай",
    text: " үрүҥ көмүс састааптаах иһит-хомуос, сэп-сэбиргэл (посуда и другие предметы, имеющие в своем составе серебро)."
    },
    {
    id: "819",
    title: "Дьоруо",
    text: "түргэн, элэгэлдьигэс, хайбалдьыгас (быстрый, мелькающий, слегка подающийся то в одну, то в другую  сторону)."
    },
    {
    id: "820",
    title: "Аллаах",
    text: "түргэн сырыылаах, эрчимнээх (быстрый, ходкий)."
    },
    {
    id: "821",
    title: "Дьалаана суох",
    text: "дуоспуруна, оттомо суох (тугу да өйдүү- саныы, ырыҥалыы барбакка оҥорор, саҥарар) (развязный  и  бестолковый)."
    },
    {
    id: "822",
    title: "Удьаа",
    text: "кымыс баһар уһун уктаах дириҥ, улахан мас хамыйах (большой деревянный ковш с длинной рукояткой для разливания кумыса, средний по величине между хомуос и хамыйах)."
    },
    {
    id: "823",
    title: "Амыньньыар = амынньыар",
    text: "мас синньигэс, хаппыт лабаата, мутуга (сухие сучья, хворост)."
    },
    {
    id: "824",
    title: "Биллэрик",
    text: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)."
    },
    {
    id: "825",
    title: "Сыҥаһа",
    text: "cаха балаҕаныгар орон сиһин кытыы модьу маһа (баҕанаттан баҕанаҕа кырыытынан саайыллар) (в  якутской  юрте:  возвышенная  закраина нар, сделанная из более массивных брёвен, тянущихся от столба к столбу)."
    },
    {
    id: "826",
    title: "Модьоҕо",
    text: "аан боруога (порог)."
    },
    {
    id: "827",
    title: "Кэтэҕэриин",
    text: "саха балаҕаныгар киирэр аан уонна оһох утары  өттө (передняя  сторона  или часть якутской юрты напротив камина и входа)."
    },
    {
    id: "828",
    title: "Улаан",
    text: "сылгы дьүһүнэ, кубархай сиэллээх, кутуруктаах өлкөкү кэрэ, сырдык көҕөччөр (масть лошади, чалый со светлыми гривой и хвостом). "
    },
    {
    id: "829",
    title: "Суру",
    text: "сылгы өҥүн арааһа: бороҥ, күрэҥ (темно-серый, бурый (о масти лошади))."
    },
    {
    id: "830",
    title: "Бөчүөл = бөчөх-бөчөх",
    text: "хойуутук, мөчөкө-мөчөкө эбэтэр түүтэх-түүтэх (густо,  густыми  комьями,  хлопьями или пучками, охапками)."
    },
    {
    id: "831",
    title: "Уодай = уодан",
    text: "олус киҥнээх, суостаах (гневный, свирепый, грозный)."
    },
    {
    id: "832",
    title: "Көмөхөй = көмөгөй",
    text: "хабарҕа болчуога (кадык, адамово яблоко). "
    },
    {
    id: "833",
    title: "Субан",
    text: "ханыыта, оҕото суох, соҕотох (одинокий, без пары)."
    },
    {
    id: "834",
    title: "Кыппыайка = кыппаайка",
    text: "сып-сырдык, көнө ньуурдаах (светлый, яркий, ровный)."
    },
    {
    id: "835",
    title: "Өллөйдөө",
    text: "өлөр-хаалар суолтан быыһаа, өрүһүй (спасти, спасать от  смертельной  беды,  гибели)."
    },
    {
    id: "836",
    title: "Харыйдаа=харыһый",
    text: "кими, тугу эмэ көмүскээ, араҥаччылаа (защищать, заступиться, покровительствовать)."
    },
    {
    id: "837",
    title: "Көй",
    text: "үгүс ахсааннаах, элбэх, дэлэй (имеющийся  в  большом количестве,  многочисленный,  обильный)."
    },
    {
    id: "838",
    title: "Уорҕа",
    text: "кыыл-сүөл көҕүс, иэн өттө, көхсө (спина, спинной хребет)."
    },
    {
    id: "839",
    title: "Балай",
    text: "хараҥа (темный).."
    },
    {
    id: "840",
    title: "Ала-была = алах-былах",
    text: "онон-манан, онно-манна; хам-түм, хаа-дьаа (местами, кое-где, изредка). "
    },
    {
    id: "841",
    title: "Дапсылҕа",
    text: "охсор, дайбыыр сэп-сэбиргэл (орудие или оружие, которым можно размахнуться, ударить)."
    },
    {
    id: "842",
    title: "Сүүдүй",
    text: "туохха эмэ киирэн умнуллубат гына иҥ, иҥэн хаал (оседать в памяти, в сердце, сохраняться).."
    },
    {
    id: "843",
    title: "Кырыыбалыы",
    text: "туора соҕус, ойоҕолуу кырыытынан (сбоку, боком, вкривь)."
    },
    {
    id: "844",
    title: "Чиэски",
    text: "уһук сиргэ баар, ыраах, туора турар (находящийся вдали от центра, окраинный, глухой)."
    },
    {
    id: "845",
    title: "Чиргэл",
    text: "тирэхтээх, кыахтаах (крепкий, здоровый)."
    },
    {
    id: "846",
    title: "Соболоҥ",
    text: "киһи тугу эмэ оҥорбут эрэйин төлөбүрэ, манньата (плата, вознаграждение за какой -л. труд, за какую - л.  услугу)."
    },
    {
    id: "847",
    title: "Сөксөй",
    text: "көппөччү, үллэччи кыстаммыт, ууруллубут курдук буолан көһүн (казаться большим, пушистым, рыхлым)."
    },
    {
    id: "848",
    title: "Этэттээ",
    text: "ыам кэннэ үүт хаалбатын диэн кулунчукка өссө эмнэр (припускать после удоя жеребенка к кобыле). "
    },
    {
    id: "849",
    title: "Матаарчах",
    text: "үүт аска аналлаах маһы хаһан оҥоһуллубут иһит (деревянный сосуд в виде усеченного конуса для хранения молочных продуктов). "
    },
    {
    id: "850",
    title: "Харылы көмүс",
    text: "тохтоло суох тыастаахтык кутуллар көмүс (непрерывно с громким бульканьем текущее серебро)."
    },
    {
    id: "851",
    title: "Байтаһын",
    text: "сайын устата көҥүл сылдьыбыт, төрөөбөтөх сүөһү (откормленный, нагулявший жир за лето скот)."
    },
    {
    id: "852",
    title: "Хаппахчы",
    text: "саха балаҕаныгар эдэр ыалга, кыыска анаммыт кыракый хос (в якутской юрте место для спанья молодой девушки или молодоженов)."
    },
    {
    id: "853",
    title: "Баҕадьы = баҕайы",
    text: "сөбүлээбэт, абааһы көрөр, кэлэйэр, сэниир сыһыаны көрдөрөр тыл (выражает неодобрение, осуждение, сильное разочарование, пренебрежение, отвращение)."
    },
    {
    id: "854",
    title: "Дьүккэ",
    text: "харах дьэҥкир сарыыта, тас бүрүөтэ (наружная прозрачная оболочка глаза, роговица)."
    },
    {
    id: "855",
    title: "Сурт",
    text: "көс олохтоох дьон ураһаланан олорон ааспыт сирдэрэ (место стоянки, стойбище кочевников)."
    },
    {
    id: "856",
    title: "Төҥүргэс",
    text: "кэрдиллибит, эрбэммит мас төрдө, чөҥөчөк (торчащий остаток срубленного или спиленного дерева, пень, пенёк)."
    },
    {
    id: "857",
    title: "Сэньэлгэ = сэнньэлгэ",
    text: "ыйана сылдьар курдук эбии тутуур, эбиилик, сыһыарыы что-либо в виде дополнения, придатка, довеска в качестве приложения)."
    },
    {
    id: "858",
    title: "Кэбир",
    text: "мэһэй, харгыс (препятствие, преграда)."
    },
    {
    id: "859",
    title: "Буокас = муокас",
    text: "дьикти, дьиибэ (удивительный, странный)."
    },
    {
    id: "860",
    title: "Кэйбэй",
    text: "иэҕилин, өҕүлүн (согнуться, прогнуться)."
    },
    {
    id: "861",
    title: "Күөт = күөрт",
    text: "бөрө курдук дьүһүннээх, араҕастыҥы бороҥ (похожий на волка, желтовато-серый)."
    },
    {
    id: "862",
    title: "Убайбытынан",
    text: "умайбытынан."
    },
    {
    id: "863",
    title: "Баабыр",
    text: "күүстээх, модун, сүҥкэн (сильный, могучий, огромный)."
    },
    {
    id: "864",
    title: "Уччурхай = удьурҕай",
    text: "хатыҥ саамай төрдүн иирчэх курдук эриллэн үүммүт саастаах ордук кытаанах бөҕө өттө (корневое утолщение березы, отличающееся особой прочностью)."
    },
    {
    id: "865",
    title: "Хат таманнан",
    text: "куппут-симмит курдук киппэ, үскэл (полный, тучный, плотный)."
    },
    {
    id: "866",
    title: "Хаһа",
    text: "ис сыата (брюшной жир)."
    },
    {
    id: "867",
    title: "Саал",
    text: "сылгы  моонньун үөһээ кырыытынан үөскүүр кытаанах сыа (жировое отложение на загривке лошади)."
    },
    {
    id: "868",
    title: "Хаппар куҥа",
    text: "өрөҕөтүн кытта тардыһан холбоһор сирин, быттыгын ис куҥа, буут иһэ (ляжка)."
    },
    {
    id: "869",
    title: "Сэгэччи",
    text: "кыратык аһаҕас буоларын курдук, аппаччы (слегка приоткрыв, полураскрыв)."
    },
    {
    id: "870",
    title: "Амыньньыар = амынньыар",
    text: "мас синньигэс, хаппыт лабаата, мутуга (сухие сучья, хворост)."
    },
    {
    id: "871",
    title: "Модьоҕо",
    text: "аан боруога (порог). "
    },
    {
    id: "872",
    title: "Хаппахчы",
    text: "саха балаҕаныгар эдэр ыалга, кыыска анаммыт кыракый хос (в якутской юрте место для спанья молодой девушки или молодоженов)."
    },
    {
    id: "873",
    title: "Быраан",
    text: "өрүс, үрэх хочотун икки өттүнэн кыһалыы, сэлэлии үрдээн турар буор модьоҕо томтордор, хайалар (горы, холмы вдоль берега или долины реки, коренной берег, высокая терраса)."
    },
    {
    id: "874",
    title: "Саамал кымыс",
    text: "саамыламмыт, көөнньүбүтүн кэннэ атын улахан иһиккэ мунньан, сөрүүҥҥэ туруоран, астытан иһэргэ бэлэмнэммит кымыс (уже дошедший до кондиции, постепенно сливаемый в большой сосуд для смешивания и охлаждения, лучшего качества кумыс). "
    },
    {
    id: "875",
    title: "Көйүү кымыс = көйө кымыс",
    text: "өр турбут, көөнньубут уохтаах кымыс (настоявшийся, перебродивший кумыс)."
    },
    {
    id: "876",
    title: "Биллирик = биллэрик",
    text: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)."
    },
    {
    id: "877",
    title: "Чыҥырҕастаах сыттык",
    text: "кырыыларыгар хатан тыаһы таһаарар үрүҥ көмүстэрдээх сыттык (подушка с металлическими погремушками из серебряных пластинок по краям)."
    },
    {
    id: "878",
    title: "Дуобаттаах суорҕан",
    text: "дуобат хараҕын курдук араас өҥнөөх локуйдартан аттарвыллыбыт суорҕан (клетчатое одеяло, сшитое из равных по размеру разноцветных лоскутков, похожее рисунком на шашечную доску). "
    },
    {
    id: "879",
    title: "Баччыгынаа",
    text: "муннугун улаханнык хаһыҥыраччы тыаһат (сильно, шумно сопеть)."
    },
    {
    id: "880",
    title: "Өрөһөлөммүт",
    text: "үрүт-үрдүгэр ууруллубут, бэрээдэгэ суох чөмөхтөммүт. (складывать в кучу, груду, беспорядочно класть предметы друг на друга)."
    },
    {
    id: "881",
    title: "Тигинэй",
    text: "күүскэ, тэтимнээхтик умай (сильно, интенсивно гореть)."
    },
    {
    id: "882",
    title: "Тойонноо",
    text: "туох эмэ кырдьыгын, сөбүн быһаар, толкуйдаан таһаар, сылыктаа, ырыҥалаа (толковать, объяснять что-либо, вникать во что-либо). "
    },
    {
    id: "883",
    title: "Таһыдьдьа",
    text: "таһырдьа."
    },
    {
    id: "884",
    title: "Чулуу",
    text: "бастыҥтан бастыҥ (лучший из лучших)."
    },
    {
    id: "885",
    title: "Аньньынан",
    text: "анньынан."
    },
    {
    id: "886",
    title: "Эргэнэ хара тыа",
    text: "бөдөҥ мастаах халыҥ ойуур, сис тыа (густой лес с крупными деревьями)."
    },
    {
    id: "887",
    title: "Таныы",
    text: "мурун үүтэ, көҥдөйө, аллараа кырыыта (ноздря, ноздри)."
    },
    {
    id: "888",
    title: "Талахачыччы",
    text: "харса суох мөҕүһүннэрэн (заставить беспорядочно двигаться, биться)."
    },
    {
    id: "889",
    title: "Буур",
    text: "улахан тайах, таба атыыра (матерый самец лося или оленя)."
    },
    {
    id: "890",
    title: "Бууса = бууһа",
    text: "уруккутунааҕар өссө күүстээхтик, өссө сытайан (еще сильнее, пуще прежнего)."
    },
    {
    id: "891",
    title: "Сыаналаа",
    text: "тугу эмэ суоттаан быһаар (определять, оценивать)."
    },
    {
    id: "892",
    title: "Көрдөр хараҕым дьүккэтэ, көтүрдэр тииһим миилэтэ",
    text: "саамай харыстыыр, таптыыр оҕом (мой любимый, единственный ребенок)."
    },
    {
    id: "893",
    title: "Сүрэҕим ытарҕата",
    text: "күндүттэн күндү, туохха да тэҥэ суох күндү (самый дорогой, несравненный, ненаглядный)."
    },
    {
    id: "894",
    title: "Быарым тулаайаҕа",
    text: "күүтүүлээх-кэтэһиилээх, күндүттэн күндү (любимый, желанный, единственный)."
    },
    {
    id: "895",
    title: "Холобурдаах",
    text: "туохха эмэ тэҥнээх, туох эмэ кэриҥнээх (сравнимый с кем-чем-либо, похожий на кого-что-либо)."
    },
    {
    id: "896",
    title: "Холоонноох",
    text: "тэҥнээх, сөптөөх (равный, достойный)."
    },
    {
    id: "897",
    title: "Уот кыымнаах, сурт кэриэстээх, өтөх төҥүргэстээх",
    text: "кэннибэр хаалар ыччаттаахпын (огонь имеет искру, старая усадьба имеет пни)."
    },
    {
    id: "898",
    title: "Чаастыыбын",
    text: "өлүүлүүбүн."
    },
    {
    id: "899",
    title: "Ураҕас",
    text: "уһун синньигэс мас (длинная палка, шест)."
    },
    {
    id: "900",
    title: "Үүрбэ",
    text: "сиртэн сиргэ күһэлэҥ үүрүү, көһөрүү (принудительное переселение с места на место)."
    },
    {
    id: "901",
    title: "Сэньньэлгэ = сэнньэлгэ ",
    text: "ыйана сылдьар курдук эбии тутуур, эбилик, сыһыарыы (что-либо в виде дополнения, придатка, довеска в качестве приложения). "
    },
    {
    id: "902",
    title: "Ирээт",
    text: "тиксэр өлүү, туох эмэ ананара (доля, часть)."
    },
    {
    id: "903",
    title: "Кэмчиэрий",
    text: "кыбыстан, симиттэн дубук-дабык тутун (смущатся, стеснятся, чувствовать себя неловко, скованно)."
    },
    {
    id: "904",
    title: "Самыы",
    text: "сүөһүгэ, кыылга уорҕатын кэлин өттө (у животных задняя часть спины от поясницы до ягодиц)."
    },
    {
    id: "905",
    title: "Чанчык",
    text: "харах уонна кулгаах икки арда, чэчэгэй эбэтэр онно үүнэр баттах (висок, волосы на висках)."
    },
    {
    id: "906",
    title: "Кылан",
    text: "туохтан эмэ күүркэйэн хатаннык күүскэ хаһыытаа (пронзительно кричать, издавать вопль)."
    },
    {
    id: "907",
    title: "Былас",
    text: " уста кээмэйэ: туора уунуллубут илиилэр тарбахтарын төбөтүттэн нөҥүө тарбахтар төбөлөрүгэр диэри (маховая сажень, размах равный 1,76 м.)."
    },
    {
    id: "908",
    title: "Суһуох",
    text: "кыыс, дьахтар өрүллүбүт уһун баттаҕа (девичья, женская коса)."
    },
    {
    id: "909",
    title: "Үҥкүрүй",
    text: "сиргэ сытан баран, эргичиҥнээн, төкүнүҥнээн сыҕарый (кататься, перекатываться, валяться на чем-либо)."
    },
    {
    id: "910",
    title: "Күөлэһий",
    text: "көхсүгүнэн сиргэ үҥкүрүй (лежа на спине перекатыватся с боку на бок)."
    },
    {
    id: "911",
    title: "Күүгэс",
    text: "килэбэчигэс күөх харахтаах, эбирдээх кынаттаах, күлүмэнтэн кыра үөн (златоглазик – вид слепня)."
    },
    {
    id: "912",
    title: "Өһүө",
    text: "дьиэ үрдүн сүгэн турар сис мас (потолочная балка, матица)."
    },
    {
    id: "913",
    title: "Кылалын",
    text: "ыраахтан, эбэтэр туох эмэ иһиттэн мөлтөхтүк чаҕылыйан көһүн (светиться ярким пятном издали или просвечивать сквозь что-либо, сверкать).."
    },
    {
    id: "914",
    title: "Харылы көмүс",
    text: "тохтоло суох тыастаахтык кутуллар көмүс (непрерывно с громким бульканьем текущее серебро)."
    },
    {
    id: "915",
    title: "Ирдээ-тордоо",
    text: "сорунан, кыһаллан, кичэйэн көрдөө (выискивать, выслеживать, неотступно преследовать)."
    },
    {
    id: "916",
    title: "Нэмэлис = нэмилис",
    text: "үөһэттэн аллараа намылыйан түс (свешиваться, свисать, спадать)."
    },
    {
    id: "917",
    title: "Ньуур",
    text: "сирэй, сэбэрэ (лицо). "
    },
    {
    id: "918",
    title: "Өрүөллээх",
    text: "хотой ойуулаах (с изображением орла)."
    },
    {
    id: "919",
    title: "Үрэйэ-сарайа",
    text: "үрүө-тараа, арҕам-тарҕам (врассыпную, в разные стороны)."
    },
    {
    id: "920",
    title: "Улаан",
    text: "сылгы дьүһүнэ, кубархай сиэллээх, кутуруктаах өлкөкү кэрэ, сырдык көҕөччөр (масть лошади, чалый со светлыми гривой и хвостом)."
    },
    {
    id: "921",
    title: "Убаһа",
    text: "күһүн бастакы хаарыгар үктэммит биирин туола илик ыччат сылгы (жеребенок с первой осени до года)."
    },
    {
    id: "922",
    title: "Унаарыччы",
    text: "бытаанык, наҕыллык (медленно, плавно)."
    },
    {
    id: "923",
    title: "Ыньыстыбыта",
    text: "ыйыстыбыта."
    },
    {
    id: "924",
    title: "Хабарҕа",
    text: "киһи моонньун иннинэн тыҥатыгар тиийэр көҥкөлөй тыынар уорган (дыхательное горло, трахея)."
    },
    {
    id: "925",
    title: "Күөдэйбитинэн",
    text: "сааһыламмакка мэнээк үрүт-үрдүгэр ыһыллан, биир сиргэ өрөһөлөнөн (разбросанно, беспорядочной кучей)."
    },
    {
    id: "926",
    title: "Дьаккый = дьалкый",
    text: "долгуйа, түллэн хамсаа (волнуется, колыхается)."
    },
    {
    id: "927",
    title: "Айбалдьый",
    text: "киэҥник, хотоойутук хамнанан тугу эрэ оҥорор, үлэлиир (делает что-либо широкими, уверенными движениями)."
    },
    {
    id: "928",
    title: "Күөгэлдьий",
    text: "аа-дьуо нуоҕайа хамсаа (плавно, мягко склоняться)."
    },
    {
    id: "929",
    title: "Дурдалан",
    text: "дурда оҥоһун, хахха сир бул (найди укромное место)."
    },
    {
    id: "930",
    title: "Тутум",
    text: "уста кээмэйэ, киһи сутуруктуу туппут ытыһын кэтитэ (мера длины: расстояние, равное высоте кулака)."
    },
    {
    id: "931",
    title: "Нохто",
    text: "сүрэх хайырҕаһа, сүрэхтэн тахсар хаан сүүрэр үөс тымыр-дара (вена, аорта)."
    },
    {
    id: "932",
    title: "Толугураччы",
    text: "толугуруур тыастаахтык, чаастатык (шумно, громко биться, стучать)."
    },
    {
    id: "933",
    title: "Бакыр",
    text: "токур (немного согнутый, скрюченный)."
    },
    {
    id: "934",
    title: "Хайҕахтаах хара быар",
    text: "быары хоһуйар халбаҥнаабат эпитет, суолтата – кыраҕа хамнаабат, ньыгыл (постоянный эпитет печени, значение – крепкий, плотный, постоянный)."
    },
    {
    id: "935",
    title: "Халыгыраччы",
    text: "халыгырыыр тыастаахтык, халыгырыыр курдук (громко звякая, брякая, бренча)."
    },
    {
    id: "936",
    title: "Тойон ыҥырыа",
    text: "сибэкки сүмэтин хомуйан мүөт оҥорон таһаарар тигээйитээҕэр улахан кынаттаах көтөр үөн (жалящее летающее перепончатокрылатое насекомое, собирающее цветочную пыльцу и перерабатывающее ее в мед, пчела)."
    },
    {
    id: "937",
    title: "Лиһигирэһии",
    text: "улаханнык ньиргийэн субуллук тыаһаан (грохотать, громыхать). "
    },
    {
    id: "938",
    title: "Кэдэрги",
    text: "буолуммакка өсөһөн, төттөрү анньар (не соглашаясь упрямиться, противиться)."
    },
    {
    id: "939",
    title: "Тэлэкэчий",
    text: "түргэнник, сытыытык-хотуутук хамсан (двигаться быстро, энергично, крутиться-вертеться)."
    },
    {
    id: "940",
    title: "Илигирэт",
    text: "түргэн-түргэнник, тэтимнээхтик төттөрү-таара хамсат (вибрировать, мелко дрожать)."
    },
    {
    id: "941",
    title: "Талагыначчы = талыгыраччы",
    text: "тэтимнээхтик талыгыраан тыаһыы-тыаһыы (сильно стуча)."
    },
    {
    id: "942",
    title: "Баччыгыныы = бачыгыныы",
    text: "эмискэ хабырыта баран тыаһаан ыла-ыла (резко издавая трескучий звук)."
    },
    {
    id: "943",
    title: "Тыҥ",
    text: "сарсыарда күн тахсарын саҕана халлааҥҥа үөскүүр синньигэс сырдык балаһа (рассвет, утренняя заря)."
    },
    {
    id: "944",
    title: "Тыһы бараах",
    text: "уһун синньигэс атахтаах, уһун тумустаах кыра хонуу көтөрүн тыһыта (самка полевого кулика)."
    },
    {
    id: "945",
    title: "Аламай",
    text: "сандаархай, чаҕылхай, сылаас сымнаҕас (сияющий, блистающий, ясный, ласковый, приветливый)."
    },
    {
    id: "946",
    title: "Арҕас",
    text: "үрдүк сир, орой, чыпчаал (высокое место, вершина, верхушка)."
    },
    {
    id: "947",
    title: "Ахталый",
    text: "атахтаргын аччаччы быраҕан дьоһумсуйбуттуу аа-дьуо ыараханнык хаамп (шагать тяжело, медленно на широко раставленных ногах, с претензией на собственную важность)."
    },
    {
    id: "948",
    title: "Толомон",
    text: "ордук бөдөҥ, талыы, дьоһун (крупный, лучший, отборный)."
    },
    {
    id: "949",
    title: "Добун",
    text: "улаҕата биллибэт үрдүк, ытык ыраас (огромное, бескрайнее, священное, чистое)."
    },
    {
    id: "950",
    title: "Туналый",
    text: "маҥан үрүҥ буолан, туртайан көһүн (быть, казаться ослепительно, выделяться ярко-белым цветом)."
    },
    {
    id: "951",
    title: "Көбүөх гына",
    text: "биирдэ өндөх гына, хамсаан ыла (силиться приподняться, шевельнуться)."
    },
    {
    id: "952",
    title: "Тартах гынна",
    text: "кэҥээтэ, улаатта (раздуваться, расширяться)."
    },
    {
    id: "953",
    title: "Санаа тарҕат",
    text: "санааҥ түспүтүн тугунан эмэ аралдьытан аһар (отвлекаться от неприятных мыслей, снимать напряжение)."
    },
    {
    id: "954",
    title: "Көньньүөр = көнньүөр",
    text: "дуоһуй, астын, санаан көтөҕүлүн (быть в приподнятом настроении, утешаться, успокаиваться)."
    },
    {
    id: "955",
    title: "Уобалаа",
    text: "айаҕар төһө киирэринэн, батарынан угар, симэр (набивать себе рот)."
    },
    {
    id: "956",
    title: "Уот татай",
    text: "соһуйууну, сөҕүүнү бэлиэтиир саҥа аллайыы (междометие, выражающее сильное удивление, изумление). "
    },
    {
    id: "957",
    title: "Булас = былас",
    text: "уста кээмэйэ: туора уунуллубут илиилэр тарбахтар төбөлөрүгэр диэри (маховая сажень, размах равный 1,76 м.)"
    },
    {
    id: "958",
    title: "Бодо",
    text: "майгы-сигили (характер, нрав)."
    },
    {
    id: "959",
    title: "Экчи",
    text: "хайаан даҕаны (непременно)."
    },
    {
    id: "960",
    title: "Элийэ-халыйа",
    text: "быһыйдык, чэпчэкитик сүүрдэ, дэгэйдэ (бежать легко ступая, едва касаясь земли)."
    },
    {
    id: "961",
    title: "Хараҕаччы = хараҥаччы",
    text: "кыптыыйдыы уһун кынаттаах, түргэнник көтөр, түөһүгэр маҥаннаах кыра хара чыычаах (маленькая, быстро летающая птица отряда воробьиных с длинными острыми крыль-ями, ласточка, стриж)."
    },
    {
    id: "962",
    title: "Таһадьдьа",
    text: "таһырдьа."
    },
    {
    id: "963",
    title: "Кэтэҕэриин",
    text: "саха балаҕаныгар киирэр аан уонна оһох утары  өттө (передняя  сторона  или часть якутской юрты напротив камина и входа)."
    },
    {
    id: "964",
    title: "Күөгэс гын",
    text: "бэрт намыыннык, уу долгуйбат гына хамсан (двигайся плавно и грациозно)."
    },
    {
    id: "965",
    title: "Тилигирэччи",
    text: "биир тэҥ тэтимнээхтик, тилигирэс тыастаахтык (производя непрерывный дробный стук)."
    },
    {
    id: "966",
    title: "Уҥуоҕа халыр босхо",
    text: "үөрэн, долгуйан илиитэ-атаҕа салыбырыыр, титириир, уҥуоҕа хамсыыр (поджилки трясутся)."
    },
    {
    id: "967",
    title: "Чороон",
    text: "мастан быһан оҥоһуллар, ортотунан култаҕар быһыылаах, араас оһуордаах саха иһитэ (деревянный кубок, украшенный резными узорами, который может иметь разные размеры)."
    },
    {
    id: "968",
    title: "Тоорохойдоо",
    text: "кыракый чаастарга, куһуоччукка арааран, бытарытан (дробить на мелкие кусочки, мельчить)."
    },
    {
    id: "969",
    title: "Чыыкааннаа",
    text: "ииктээ (писать)."
    },
    {
    id: "970",
    title: "Бэлкэй",
    text: "саамай кыра чороон (самый маленький деревянный сосуд)."
    },
    {
    id: "971",
    title: "Суос-соҕотохто",
    text: "эмискэ, соһуччу, көһүппэтэх кэмҥэр (вдруг, внезапно, неожиданно)."
    },
    {
    id: "972",
    title: "Өрүһүй",
    text: "быыһаа (спасать)."
    },
    {
    id: "973",
    title: "Харааччы = хараарчы",
    text: "олох, адьас, букатын (совсем, совершенно)."
    },
    {
    id: "974",
    title: "Эһэ сирэйин сирэйдэннэ, эбэ хараҕын харахтанна",
    text: "суостанна, ынырык быһыыланна (стала грозной, внушающей страх)."
    },
    {
    id: "975",
    title: "Дьэс кыыһан",
    text: "кыһыл алтан өҥүнүү кытарар (краснеть, алеть, багроветь)."
    },
    {
    id: "976",
    title: "Уодай хаан = уодан хаан",
    text: "олус киҥнээх, суостаах (гневный, свирепый, грозный)."
    },
    {
    id: "977",
    title: "Баараҕай",
    text: "бөдөҥ-садаҥ, көрүҥүнэн олус улахан (очень большой, крупный)."
    },
    {
    id: "978",
    title: "Баҕана",
    text: "балаҕан дьиэ холлоҕоһун тутан турар сэбэргэнэлэргэ тирэх буолар остуолба (столб, на котором держится каркас юрты)."
    },
    {
    id: "979",
    title: "Кыпчый",
    text: "атахтарын бэйэ-бэйэлэригэр ыга тутан, тобуктар икки ардыларыгар кыбыт, ыга тут (плотно прижимать, сводить ноги, зажимать между ног, коленями)."
    },
    {
    id: "980",
    title: "Түҥнэри",
    text: "сөп түбэспэттии, утары (не соответствующе, противоположно)."
    },
    {
    id: "981",
    title: "Бэккиһээн = бэркиһээн",
    text: "соһуччуну, дьиктини, сүөргүнү көрөн сөхтө, дьиибэргээтэ (дивиться, удивляться, поражаться увиденному)."
    },
    {
    id: "982",
    title: "Маҕана = баҕана",
    text: "балаҕан дьиэ холлоҕоһун тутан турар сэбэргэнэлэргэ тирэх буолар остуолба (столб, на котором держится каркас юрты)."
    },
    {
    id: "983",
    title: "Соноҕос сылгы",
    text: "үстээх-түөртээх атыыр эбэтэр аттаммыт сылгы (молодой жеребец трех-четырех лет или выхолощенный конь)."
    },
    {
    id: "984",
    title: "Логлорута баттаан",
    text: "кэлимсэттэн көһүҥэнэн ойу быһан ылыы (отколоть большими кусками)."
    },
    {
    id: "985",
    title: "Сыыйа-саайа = сыыйа-баайа",
    text: "ыксала-тиэтэлэ суох, аа-дьуо (не спеша, потихоньку, полегоньку)."
    },
    {
    id: "986",
    title: "Күн отто = күн ортото",
    text: "күн халлаан оройугар тиийиитэ, күнүс 12 чаас буолуута (полдень)."
    },
    {
    id: "987",
    title: "Көньньүнэн туран төгүрүйэ көтөр",
    text: "сүнньүнэн туран эргийэр (вращается вокруг своей оси)."
    },
    {
    id: "988",
    title: "Иэрчэх = иэччэх",
    text: "эргийэн хамсыырга тирэнэр тутулук (центральная часть, опора, стержень)."
    },
    {
    id: "989",
    title: "Көрө сүөргү",
    text: "олус, наһаа (очень весьма)."
    },
    {
    id: "990",
    title: "Мэтириэт",
    text: "портрет."
    },
    {
    id: "991",
    title: "Айылгылаах",
    text: "бары өттүнэн киһини астыннарар, үчүгэй, үтүө (хороший, добрый во всех отношениях)."
    },
    {
    id: "992",
    title: "Тэһиин",
    text: "ыҥыыр акка икки өттүнэн үүнүгэр баайан салайар быа (повод, поводья)."
    },
    {
    id: "993",
    title: "Тоҥонох = тоҕонох",
    text: "киһи окумалын уонна харытын уҥуохтара холбоһор сүһүөҕэ (локоть)."
    },
    {
    id: "994",
    title: "Дайдаралаах",
    text: "байбаралаах."
    },
    {
    id: "995",
    title: "Саҕыньньах = саҕынньах",
    text: "түүлээх, киэҥ ичигэс сон (меховая доха или шуба мехом наружу)"
    },
    {
    id: "996",
    title: "Нэлбэгэйдии",
    text: "санныгар бүрүнэ, саба быраҕа (накинув на плечи)."
    },
    {
    id: "997",
    title: "Үүс",
    text: "бэдэр (рысь)."
    },
    {
    id: "998",
    title: "Кырыыбалыы",
    text: "туора соҕус, ойоҕолуу кырыытынан (сбоку, боком, вкривь)."
    },
    {
    id: "999",
    title: "Ааттаах",
    text: "саамай чулуу, үчүгэй (лучший, превосходный из массы людей)."
    },
    {
    id: "1000",
    title: "Айгыстан",
    text: "тиэтэйбэккэ, түбүгүрбэккэ бытааннык, холкутук хамнанан (двигаясь очень спокойно, без суеты, медленно)."
    },
    {
    id: "1001",
    title: "Томторҕо",
    text: "сэргэ ойуута (утолщение между кольцеобразными зарубками коновязи)."
    },
    {
    id: "1002",
    title: "Туспа сибиир киһитэ",
    text: "атын дойду киһитэ (человек из другой местности)."
    },
    {
    id: "1003",
    title: "Аппалдьыт",
    text: "бэрт кыратык ас, сэгэт (чуть приоткрыть)."
    },
    {
    id: "1004",
    title: "Халҕан",
    text: "аан (дверь)."
    },
    {
    id: "1005",
    title: "Нүрүй",
    text: "төҥкөччү тутун (пригнуться, склониться)."
    },
    {
    id: "1006",
    title: "Өҥөй",
    text: "быган көр (выглядывать)."
    },
    {
    id: "1007",
    title: "Дьаалы",
    text: "сөҕүүнү, дьулайыыны, ытыктабылы көрдөрөр предмет бэлиэтин күүһүрдэн биэрэр эбиискэ (выражает восторженно-почтительное отношение к высказываемому, усиливает признак предмета)."
    },
    {
    id: "1008",
    title: "Тугуттаа",
    text: "тугуту төрөт (телиться)."
    },
    {
    id: "1009",
    title: "Илгэ",
    text: "күүс-уох киллэрэр, уйгу-быйаҥ төрдө буолар таҥара биэрэр аптаах сөлөгөйө (дар богов, дающий силу и богатство)."
    },
    {
    id: "1010",
    title: "Хоҥоруу дуорсун = хоҥоруу дьуорсун",
    text: "үрдүк, маһа суох сир (возвышенная, без деревьев)."
    },
    {
    id: "1011",
    title: "Баараҕай",
    text: "бөдөҥ-садаҥ, көрүҥүнэн олус улахан (очень большой, крупный)."
    },
    {
    id: "1012",
    title: "Иэримэ-дьиэримэ сибиирдээх",
    text: "төрөөбүт-үөскээбит дойдулаах (с родной окраиной, страной)."
    },
    {
    id: "1013",
    title: "Эндэр",
    text: "куһаҕан, аҥхайдаах-куоһахтаах, оллур-боллур, айаннырга эрэйдээх (плохая, с рытвинами, выбоинами, трудная)."
    },
    {
    id: "1014",
    title: "Эккин = эркин",
    text: "ойоҕос истиэнэ (вертикальная часть, стена)."
    },
    {
    id: "1015",
    title: "Күннүк",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "1016",
    title: "Чучугур",
    text: "кылгастык чуучугуруур тыастаах (издающий одинаковые звуки, отделенных друг от друга очень короткими промежутками – звук, происходящий от столкновения нескольких костяных маленьких шариков)."
    },
    {
    id: "1017",
    title: "Чуоҕур",
    text: "эбир курдуктаах дьүһүн (пестрый, чубарый)."
    },
    {
    id: "1018",
    title: "Очур",
    text: "томтор, боллох, төхтүр (бугорок, неровность)."
    },
    {
    id: "1019",
    title: "Күндүл",
    text: "күлүмнүүр, кылабачыйар (блестящая, сверкающая)."
    },
    {
    id: "1020",
    title: "Күөрэҥсэ",
    text: "сотору-сотору өрүтэ күөрэйтэлиир, күөрэс гынар (равномерно, регулярно взлетающий вверх)."
    },
    {
    id: "1021",
    title: "Төһөлөөх-хаччалаах буолуой",
    text: "кэми, кээмэйи, сыананы, быйыыны-майгыны ыйытарга туттуллар тыл (сколько, как)."
    },
    {
    id: "1022",
    title: "Тутай",
    text: "быстар, тиийиммэт-түгэммэт буол (испытывать нужду)."
    },
    {
    id: "1023",
    title: "Салҕаныам",
    text: "кыһалҕабыттан быыһаныам, тыыммын өрөһүйүөм (спастись, остаться в живых)."
    },
    {
    id: "1024",
    title: "Сураа",
    text: "ыйытылас, сурас (распрашивать, разузнавать)."
    },
    {
    id: "1025",
    title: "Сураҕалаан = сураа",
    text: "ыйытылас, сурас (распрашивать, разузнавать)."
    },
    {
    id: "1026",
    title: "Өрөө",
    text: "сынньан, тугу эмэ гынаргын тохтот (отдыхать освобождаясь от дел)."
    },
    {
    id: "1027",
    title: "Кэтэҕэриин истиэнэ",
    text: "саха балаҕаныгар киирэр аан уонна оһох утары өттө (передняя сторона или часть якутской юрты напротив входа).  "
    },
    {
    id: "1028",
    title: "Кыыһыра былаан",
    text: "кыыһыра соҕус (разгневаясь)."
    },
    {
    id: "1029",
    title: "Нөҥүө",
    text: "миэстэ сыһыанын бэлиэтээн, хайааһын туох эмэ уҥуоргу өттүгэр буоларын бэлиэтииргэ туттуллар (выражая пространственные отношения, употребляется при обозначении предмета, за которым находится другой предмет или совершается действие). "
    },
    {
    id: "1030",
    title: "Көр чуор",
    text: "тыаһы үчүгэйдик истэр, сытыы (острый, чуткий)"
    },
    {
    id: "1031",
    title: "Баҕадьы = баҕайы",
    text: "сөбүлээбэт, абааһы көрөр, кэлэйэр, сэниир сыһыаны көрдөрөр тыл (выражает неодобрение, осуждение, сильное разочарование, пренебрежение, отвращение)."
    },
    {
    id: "1032",
    title: "Кэкэ чолбон",
    text: "уоттаах, тобулута көрбүт сытыы (с острым взглядом, горящим взором)."
    },
    {
    id: "1033",
    title: "Үлүһүй",
    text: "тугу эмэ олус кэрэхсээн, умсугуйан, тартаран туран оҥор, гын (делать что-либо увлеченно, азартно с огоньком)."
    },
    {
    id: "1034",
    title: "Буллун",
    text: "булдун."
    },
    {
    id: "1035",
    title: "Өтөҕөлөө",
    text: "биир сиргэ өрөһөлүү мус (скопить в одном месте кучей, бугром). "
    },
    {
    id: "1036",
    title: "Мүччү барар",
    text: "төлө барар (выронить, выпустить из рук)."
    },
    {
    id: "1037",
    title: "Үрүт өттүнэн",
    text: "үөһээ ньуурунан (по поверхности, верхней части)."
    },
    {
    id: "1038",
    title: "Кэрийэ",
    text: "бииртэн биири ааҕа, кэриччи (одного за другим, последовательно, в обход)."
    },
    {
    id: "1039",
    title: "Хаххалат",
    text: "бүөлэт, күлүктэтэн сас (укрыться)."
    },
    {
    id: "1040",
    title: "Эргийиитигэр",
    text: "хайысхатын ылыытыгар (в направление)."
    },
    {
    id: "1041",
    title: "Күөннэринэн",
    text: "иннилэринэн (грудью)."
    },
    {
    id: "1042",
    title: "Уолуйбут-соһуйбут",
    text: "соһуччута бэрдиттэн өмүттэн хаалбыт (растерявшись, оторопевшись от неожиданности)."
    },
    {
    id: "1043",
    title: "Сугуһа = чугуһа",
    text: "төттөрү түһэ, кэннилэринэн бара (пятясь, отступая, отходя назад)."
    },
    {
    id: "1044",
    title: "Одуулас",
    text: "олус сирийэн, сыныйан, өр батыһа көрүс (пристально всматривавшись в друг друга)."
    },
    {
    id: "1045",
    title: "Эрбии биитин курдук",
    text: "тэбис-тэҥ (равные во всех отношениях)."
    },
    {
    id: "1046",
    title: "Ини-бии",
    text: "бииргэ төрөөбүт убайдыы быраат (родные братья)."
    },
    {
    id: "1047",
    title: "Тымтан",
    text: "кыыһыра түһэн, киҥнэнэн (раздражаясь, злясь, гнеываясь)."
    },
    {
    id: "1048",
    title: "Уллуҥах",
    text: "киһи атаҕын алын өттө, үктэнэр, тирэнэр сирэ (стопа ног у человека)."
    },
    {
    id: "1049",
    title: "Тайҕа",
    text: "тайга."
    },
    {
    id: "1050",
    title: "Далай акаары",
    text: "мас акаары (круглый дурак, болван)."
    },
    {
    id: "1051",
    title: "Мэнээк",
    text: "таах мээнэ, туох да сыала-соруга суох (просто так, бесцельно, неизвестно зачем)."
    },
    {
    id: "1052",
    title: "Акаарыны оҥоро сылдьар",
    text: "акаары буола (оказываясь дураком)."
    },
    {
    id: "1053",
    title: "Атыыр",
    text: "сылгы ууһатааччыта (самец).."
    },
    {
    id: "1054",
    title: "Халыым",
    text: "калым"
    },
    {
    id: "1055",
    title: "Халыччы",
    text: "элбэҕи, үгүһү (много)."
    },
    {
    id: "1056",
    title: "Сулуу",
    text: "урут кэргэн ылар киһи кыыс дьонугар сүөһүнэн биэрэр төлөбүрэ (калым в виде скота)."
    },
    {
    id: "1057",
    title: "Субуччу",
    text: "тилэри таппыт курдук (вытянув в длину параллельно земле)."
    },
    {
    id: "1058",
    title: "Кэскил",
    text: "олох инники дьоло, инники туруктаах дьоллоох үтүө олох (будущее счастье, благополучие; будущее развитие, расцвет)."
    },
    {
    id: "1059",
    title: "Төлкө",
    text: "инники анал, дьылҕа, кэскил (судьба, участь, предназначение)."
    },
    {
    id: "1060",
    title: "Дөксө",
    text: "өссө (еще)."
    },
    {
    id: "1061",
    title: "Өллөйдөөн",
    text: "өлүүлээн, чаастаан, анаан биэрэн (оставлять, выделять долю, часть)."
    },
    {
    id: "1062",
    title: "Сыдьаайдаан",
    text: "сырдатан, сандаардан (быть озаренным, осиянным)."
    },
    {
    id: "1063",
    title: "Өрүһүй",
    text: "быыһаа (спасать)."
    },
    {
    id: "1064",
    title: "Кидьдьик",
    text: "кырдьык (правда)."
    },
    {
    id: "1065",
    title: "Хары",
    text: "илиитин бэгэччэтиттэн тоҕоноҕор диэритэ (предплечье, часть руки от логтя до запястья)."
    },
    {
    id: "1066",
    title: "Аҥаабыллаа",
    text: "айа кирсин аппаччы тарт. (тетиву широко натягивать)."
    },
    {
    id: "1067",
    title: "Сомоҕо",
    text: "биир ньыгыл, биир кэлимсэ (цельный, нераздельный)."
    },
    {
    id: "1068",
    title: "Сутурҕалаабытынан",
    text: "сутуругунан охсубутунан, күүскэ охсубутунан (сильно ударяя, толкая кулаком)."
    },
    {
    id: "1069",
    title: "Томтойо туолуор дылы",
    text: "толору ситиэр, туолуор дылы (ровно по истечении полного одного месяца). "
    },
    {
    id: "1070",
    title: "Ыһыылаах",
    text: "хаһыытааһыннаах, үөгүлээһиннээх (с громкими протяжными криками)."
    },
    {
    id: "1071",
    title: "Биилээх",
    text: "быһарга туттуллар сытыы өрүттээх сэп-сэбиргэл (имеющий острое лезвие)."
    },
    {
    id: "1072",
    title: "Уһуктаах",
    text: "анньарга туттуллар сытыы төбөлөөх сэп-сэбиргэл (имеющий острый конец)."
    },
    {
    id: "1073",
    title: "Утассан",
    text: "сөбүлэспэккэ утары эппиэттэһэн (не соглашаясь противодействовать)."
    },
    {
    id: "1074",
    title: "Кырыылаах",
    text: "ханнык эмэ өттүнэн биилээх, сытыы муннуктардаах (граненый, с острыми краями, углами)."
    },
    {
    id: "1075",
    title: "Иэн иҥиирин курдук эрийсэ",
    text: "араа-бараа тардыалаһа, киирсэ (состязаться, будучи почти наравне с соперником, оказывая равное по силе сопротивление)."
    },
    {
    id: "1076",
    title: "Кыппыайка = кыппаайка",
    text: "сып-сырдык, көнө ньуурдаах (светлый, яркий, ровный)."
    },
    {
    id: "1077",
    title: "Быһыттан",
    text: "быһыта баран, үрэллэн (разделяться, разрываться на части)."
    },
    {
    id: "1078",
    title: "Долгулдьуй",
    text: "аргыый өрүтэ түллүтэлээн долгуннуран хамсаа (слегка волноваться, рябить)."
    },
    {
    id: "1079",
    title: "Далай муора",
    text: "дириҥ уулаах киэҥ муора (широкое и глубокое море)."
    },
    {
    id: "1080",
    title: "Дьалкый",
    text: "долгуйан түллэн хамсаа, чалымнаа (волноваться, колыхаться, плескаться)."
    },
    {
    id: "1081",
    title: "Аччайа туолла",
    text: "толору туолла, ситтэ (полностью завершились)."
    },
    {
    id: "1082",
    title: "Чэгиэн",
    text: "сайдыылаах, доруобай, кытаанах (физически крепкий, здоровый)."
    },
    {
    id: "1083",
    title: "Сэймэктээ",
    text: "быһыта-хайыта, тырыта тыыт, үлтү кырбаа (терзать, разрывать на части)."
    },
    {
    id: "1084",
    title: "Үөрэҕэстэнэн",
    text: "кэрчик-кэрчиктэргэ туора быһыллан (кусками нарезанными поперек тела)."
    },
    {
    id: "1085",
    title: "Кырбастан",
    text: "кэрчик-кэрчик гына быһыта охсулун (рубить, резать)."
    },
    {
    id: "1086",
    title: "Үөһээ курдуута",
    text: "аан ийэ дойду ураһа быһыытыгар ураһа үөһээҥҥи хайаҕаһын бүүрүгэ, чампарыга, ураһа ураҕастарын үөһээ уһуктарын холбуу туттарыыта (верхняя опаяска деревянного остова якутской берестяной юрты)."
    },
    {
    id: "1087",
    title: "Күдэн",
    text: "тунааран көстүү, туманнырыы; буор-сыыс, буруо хойуутук көтүүтэ (легкий туман, мгла, марево)."
    },
    {
    id: "1088",
    title: "Өрүкүт",
    text: "өрө бурҕатан таһаар, холоруктуу ытый (взвихривать, поднимать клубами)."
    },
    {
    id: "1089",
    title: "Сыа дьоннор",
    text: "киһи этин таһыгар эбэтэр иһигэр үөскүүр дьапталҕалаах дьоннор (с жировым отложением в теле)."
    },
    {
    id: "1090",
    title: "Уйадый",
    text: "эллииргэ бэринимтиэ буол, мөлтөө (ослабевать, истощаться)."
    },
    {
    id: "1091",
    title: "Элэй",
    text: "кэбирээ, сылаарҕаа, сылай, илиһин (выбиваться из сил, утомляться, уставать)."
    },
    {
    id: "1092",
    title: "Өҥүргэс",
    text: "уҥуохха маарынныыр эрээри, имигэс уонна чиҥ эттик (хрящ)."
    },
    {
    id: "1093",
    title: "Хабарҕа",
    text: "киһи моонньун иннинэн тыҥатыгар тиийэр көҥкөлөй тыынар уорган (дыхательное горло, трахея)."
    },
    {
    id: "1094",
    title: "Тирэх",
    text: "тирэнэр бигэ күүс (твердыня, опора, оплот)."
    },
    {
    id: "1095",
    title: "Тэмтээкэйдэһэн",
    text: "икки өттүнэн байааттаҥнаан, уйуттубакка охтон, сууллан хаалыах курдук хааман (передвигаясь, раскачиваясь, шатаясь)."
    },
    {
    id: "1096",
    title: "Чаллырҕаччы",
    text: "чаллыргыыр тыастаахтык (с хлюпающими, чавкающими звуками)."
    },
    {
    id: "1097",
    title: "Үрүт уйалаах",
    text: "үөһээ уйалаах (буквально успевший раньше тебя, выше тебя завить гнездо)."
    },
    {
    id: "1098",
    title: "Кэбиһэ барбат",
    text: "анаан биэрбэт (выражает отказ, несогласие)."
    },
    {
    id: "1099",
    title: "Ордук мутуктаннаргын",
    text: "лаппа чорбойор, үрдүк да буолларгын (хотя ты на голову выше, хотя значительно превосходишь)."
    },
    {
    id: "1100",
    title: "Сыыйыы тимир",
    text: "сыыйа тардыбыт курдук көнөтүк бара турар (прямой, вытянутый в длину)."
    },
    {
    id: "1101",
    title: "Сындааһын",
    text: "сэниэ-күүс, ыарахаттары тулуйар кыах (стойкость, способность вынести трудности, выносливость)."
    },
    {
    id: "1102",
    title: "Сыыйылла",
    text: "иһиттэн субуйа тардыллан ороно илигинэ (пока не выдернул, не вытянул)."
    },
    {
    id: "1103",
    title: "Эрийии тимир",
    text: "токуруйбут сирдэрдээх, иэҕиилээх тимир (железный, с изгибами)."
    },
    {
    id: "1104",
    title: "Ыйаах бөҕө ытыспытыгар, сокуон бөҕө сутурукпутугар, эбээһинэс бөҕө илиибитигэр буоллаҕа",
    text: "кырыктаах, бардам дьон буоллахпыт (злобные, грозные, свирепые, дерзкие)."
    },
    {
    id: "1105",
    title: "Сэрэтиспэккэ",
    text: "эрдэттэн өйдөтөн этиспэккэ (заранее не предупредив друг друга). "
    },
    {
    id: "1106",
    title: "Сиэһин",
    text: "өлөрсүн, өлөрдүү оһоллонун (убивать или смертельно ранить друг друга)."
    },
    {
    id: "1107",
    title: "Ыйаах",
    text: "эрдэттэн төлкөлөммүт, айыллыбыт, халбарыйбат, мүччүрүйбэт анал, дьылҕа, оҥоһуу (предопределенный рок, судьба). "
    },
    {
    id: "1108",
    title: "Дьүүл",
    text: " буруйдааҕы суут көрөн, ырыҥалааһына (cудебное разбирательство)."
    },
    {
    id: "1109",
    title: "Үүс-аас",
    text: "сырдык,  ыраас (светлый, чистый)."
    },
    {
    id: "1110",
    title: "Өтөҕөлөөх",
    text: "ураһа быһыылаах бэргэһэлээх (с остроконечной шапкой)."
    },
    {
    id: "1111",
    title: "Сэмэ-суҥха",
    text: "сөрсөөбөттүк мөҕүү-этии,  буруйдааһын,  элбэх  саҥалаах-иҥэлээх  хомуруйуу (осуждение, обвинение, порицание со многими упреками,  бранными  нападками)."
    },
    {
    id: "1112",
    title: "Бас",
    text: "төбө (голова)."
    },
    {
    id: "1113",
    title: "Ылгын",
    text: "ылгын сөмүйэ (мизинец)."
    },
    {
    id: "1114",
    title: "Араҥа туос",
    text: "саас-сааһынан арахсар  туос (cлоистая  береста)."
    },
    {
    id: "1115",
    title: "Эр-биир",
    text: "тус-туспа, биир-биир, биирдиилээн, утуу-субуу (по-одному, поодиночке, один за другим)."
    },
    {
    id: "1116",
    title: "Хармаан",
    text: "карман."
    },
    {
    id: "1117",
    title: "Бастаа",
    text: "инникилээ, инники буол (идти вперед)."
    },
    {
    id: "1118",
    title: "Ырай",
    text: "рай."
    },
    {
    id: "1119",
    title: "Буоллар буоллун",
    text: "чэ буоллун (ну пусть так будет)."
    },
    {
    id: "1120",
    title: "Илин киһи",
    text: "илинтэн сылдьар киһи (человек с востока)."
    },
    {
    id: "1121",
    title: "Быраан",
    text: "өрүс, үрэх хочотун икки өттүнэн кыһалыы, сэлэлии үрдээн турар буор модьоҕо томтордор, хайалар (горы, холмы вдоль берега или долины реки, коренной берег, высокая терраса)."
    },
    {
    id: "1122",
    title: "Арҕаа киһи",
    text: "арҕааттан сылдьар киһи (человек с запада)."
    },
    {
    id: "1123",
    title: "Киил",
    text: "олус кытаанах (очень крепкий)."
    },
    {
    id: "1124",
    title: "Үөгүлээ",
    text: " улаханнык, тоҕо баран хаһыытаа (громко кричать, вопить)."
    },
    {
    id: "1125",
    title: "Өксөкү кыыл",
    text: "икки эбэтэр үс төбөлөөх хотойдуҥу көтөр (двуглавая или трехглавая мифическая птица, похожая на орла)."
    },
    {
    id: "1126",
    title: "Үөс",
    text: "араҕастыҥы от күөҕэ дьүһүннээх ас буһарарга көмөлөөх хабархай симэһин (желто-зеленая горькая жидкость, выделяемая печенью, жельч)."
    },
    {
    id: "1127",
    title: "Силимнээх",
    text: "килиэйдээх (с клеем)."
    },
    {
    id: "1128",
    title: "Дьэрибинэ = дьирибинэ",
    text: "эриэн, дьиримнэс өҥнөөх (пестрый, рябой переливающийся разными цветами радуги)."
    },
    {
    id: "1129",
    title: "Иэн иҥиирэ",
    text: "сис тоноҕоһун икки өттүнэн барар быччыҥнары тутар кытаанах утахтар (сухожилия, расположенные вдоль продольной середины спины)."
    },
    {
    id: "1130",
    title: "Иҥэрчэ",
    text: "ох сааны эрийбит иҥиир (сухильная обмотка лука и стрелы)."
    },
    {
    id: "1131",
    title: "Уорҕатын тириитэ",
    text: "көхсүн тириитэ (шкура вдоль хребта)."
    },
    {
    id: "1132",
    title: "Бүрэдэһиннээх = бүрүдэһиннээх",
    text: "үрдүнэнн бүрүйүүлээх, сабыылаах (с покрытием)."
    },
    {
    id: "1133",
    title: "Чиркэйэр = чиккэйэр",
    text: "тыҥыыр курдук көбүс-көнөтүк тардыллыбыт (туго натянутый)."
    },
    {
    id: "1134",
    title: "Сис үөһэ",
    text: "үөс тымыр, сис тоноҕоһун батыһа барар хаан сүүрэр сүрүн тымыр (аорта)."
    },
    {
    id: "1135",
    title: "Кирис",
    text: "чаачары тардар хатыллыбыт тирии быа (тетива)."
    },
    {
    id: "1136",
    title: "Тоҕойдуу",
    text: "токуруйан, өҕүллэн (подобно изгибу, излучине)."
    },
    {
    id: "1137",
    title: "Сүөдүйэн ылан",
    text: "олус долгуйан, санааҕа ылларан (сильно волнуясь, приходя в тревожно-беспокойное состояние)."
    },
    {
    id: "1138",
    title: "Өһөхтөөх",
    text: "өһүөннээх (cвирепый, злобный)."
    },
    {
    id: "1139",
    title: "Кулан-дьорҕоон",
    text: "модун, дорҕоонноох (мощный, громогласный)."
    },
    {
    id: "1140",
    title: "Оноҕос",
    text: "былыр сүнньүнэн булка туттуллар ох (в старину: стрела, применяемая в основном на охоте)."
    },
    {
    id: "1141",
    title: "Кулгаах тааһа",
    text: "кулгаах ис-тас оҥоһуута (наружное и внутреннее устройство уха)."
    },
    {
    id: "1142",
    title: "Иҥнэри тардан",
    text: "кыҥнары, хайа эмэ өттүгэр тардан (наклонно, набок)."
    },
    {
    id: "1143",
    title: "Туруук",
    text: "наһаа үрдүк, олус туруору (очень крутой, отвесный)."
    },
    {
    id: "1144",
    title: "Хайҕахтаах хара быар",
    text: "быары хоһуйар халбаҥнаабат эпитет, суолтата – кыраҕа хамнаабат, ньыгыл (постоянный эпитет печени, значение – крепкий, плотный, постоянный). "
    },
    {
    id: "1145",
    title: "Аҥаабыллаа",
    text: "айа кирсин аппаччы тарт. (тетиву широко натягивать)."
    },
    {
    id: "1146",
    title: "Нохто",
    text: "сүрэх хайырҕаһа, сүрэхтэн тахсар хаан сүүрэр үөс тымыр-дара (вена, аорта)."
    },
    {
    id: "1147",
    title: "Туһаайан",
    text: "туохха эмэ салайан, тирээн, туһулаан (направлять, наставлять)."
    },
    {
    id: "1148",
    title: "Баһа көтүттэрбин",
    text: "ханна да халыйбакка, туораабакка көнөтүк таптарбын (попасть напрямик)."
    },
    {
    id: "1149",
    title: "Эрбэх",
    text: "илии улахан тарбаҕа (большой палец руки)."
    },
    {
    id: "1150",
    title: "Сүүл этиҥэ = сүллэр этиҥ",
    text: "олус күүстээх дуорааннаах этиҥ (очень сильный раскатистый гром)."
    },
    {
    id: "1151",
    title: "Ньиргий",
    text: "улахан охсууттан биллэ-биллибэттик бүтэйдии доргуйа иһилин (сотрясаться, содрагаться)."
    },
    {
    id: "1152",
    title: "Саһаан",
    text: "урукку уста кээмэйэ, 2,134 миэтэрэҕэ тэҥ (старая русская мера длины, равная 2,134 м., сажень)."
    },
    {
    id: "1153",
    title: "Үөрбэ",
    text: "уһуктаах синньигэс мас эбэтэр тимир (заостренный кол, шест, рожон)."
    },
    {
    id: "1154",
    title: "Күннүк сир",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "1155",
    title: "Сулбу сириэдийэн = сулбу сирэлийэн",
    text: "курдары, кытара умайан кэлэ-кэлэ, күөдьүйэ-күөдьүйэ (насквозь, загораясь, разгораясь, вспыхивая)."
    },
    {
    id: "1156",
    title: "Хоруоҥка",
    text: "кыра ыбтархай оҕуруо (мелкие цветные стеклянные бусинки, бисер, карелька)."
    },
    {
    id: "1157",
    title: "Үнтү тэптэрэн",
    text: "үлтү тэптэрэн (взорваться)."
    },
    {
    id: "1158",
    title: "Хомуһуннаах",
    text: "ап күүстээх (с волшебством, колдовскими чарами)."
    },
    {
    id: "1159",
    title: "Кураахтаах саа",
    text: "саха чаачар саата, ох саа (лук)."
    },
    {
    id: "1160",
    title: "Иэмэх",
    text: "туох эмэ иэҕиитэ, өҕүлүннэриитэ (искривление чего-л., изгиб)."
    },
    {
    id: "1161",
    title: "Тииҥньит",
    text: "тииҥи бултааччы (охотник на белку)."
    },
    {
    id: "1162",
    title: "Тиэритэ = тиэрэ",
    text: "алын өттүн үөһэ эргитэн (нижней стороной вверх)."
    },
    {
    id: "1163",
    title: "Туорайдыы ууран",
    text: "мэһэйдии туора ууран (поперек)."
    },
    {
    id: "1164",
    title: "Хайҕахтаах хара быар",
    text: "быары хоһуйар халбаҥнаабат эпитет, суолтата – кыраҕа хамнаабат, ньыгыл (постоянный эпитет печени, значение – крепкий, плотный, постоянный)."
    },
    {
    id: "1165",
    title: "Хабарҕа",
    text: "киһи моонньун иннинэн тыҥатыгар тиийэр көҥкөлөй тыынар уорган (дыхательное горло, трахея)."
    },
    {
    id: "1166",
    title: "Эрбэх",
    text: "илии улахан тарбаҕа (большой палец руки)."
    },
    {
    id: "1167",
    title: "Ньиргий",
    text: "улахан охсууттан биллэ-биллибэттик бүтэйдии доргуйа иһилин (сотрясаться, содрагаться)."
    },
    {
    id: "1168",
    title: "Чаҕылҕан уота",
    text: "этиҥ этиэн иннинэ халлааҥҥа сурааһын курдук буолан көстөр уот чаҕыла, күлүмэ (мнговенный разряд скопившегося атмосферного электричества в вохдухе, молния)."
    },
    {
    id: "1169",
    title: "Өрө харбас",
    text: "үөһэ диэки таҕыс (вверх)."
    },
    {
    id: "1170",
    title: "Эндэр",
    text: "куһаҕан, аҥхайдаах-куоһахтаах, оллур-боллур, айаннырга эрэйдээх (плохая, с рытвинами, выбоинами, трудная)."
    },
    {
    id: "1171",
    title: "Күүгэс",
    text: "килэбэчигэс күөх харахтаах, эбирдээх кынаттаах, күлүмэнтэн кыра үөн (златоглазик – вид слепня)."
    },
    {
    id: "1172",
    title: "Үнтү = үлтү",
    text: "дэлби (вдребезги)."
    },
    {
    id: "1173",
    title: "Тордохтоох = тордохтуҥу",
    text: "тордоххо, ураһаҕа маарынныыр быһыылаах (похожий на форму урасы)."
    },
    {
    id: "1174",
    title: "Хоҥоруу = хоҥуруу",
    text: "мурун  кырыыта, сиһэ (переносица)."
    },
    {
    id: "1175",
    title: "Кутуругар хоболоох",
    text: "кутуругун төрдүгэр үрүҥ түүлэрдээх (белая кисточка на конце хвоста)."
    },
    {
    id: "1176",
    title: "Мооньньугар мойбордоох",
    text: "моонньун эргийэ үрүҥ моойторуга (белая шерсть вокруг шеи наподобие ошейника)."
    },
    {
    id: "1177",
    title: "Киҥкиниир",
    text: "түгэҕэ көстүбэт, бардар бара турар бараммат киэҥ (бескрайняя, бесконечно расширяющаяся)."
    },
    {
    id: "1178",
    title: "Аҥаарыйар атыыр",
    text: "атыыр чулуута, саамай үчүгэйэ (лучший из самцов)."
    },
    {
    id: "1179",
    title: "Күннүк сир",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "1180",
    title: "Иэмэх",
    text: "туох эмэ иэҕиитэ, өҕүлүннэриитэ (искривление чего-л., изгиб)."
    },
    {
    id: "1181",
    title: "Сириэдий",
    text: "силистэнэн-мутуктанан олохтоохтук үүн, үөскээ, тэний; үүнэн-сайдан таҕыс, туругур (вырастать,  цвести,  укоренившись;  здравствовать, процветать)."
    },
    {
    id: "1182",
    title: "Биэрэстэ",
    text: "биир килэмиэтиртэн арыый ордук урукку уста кээмэйэ (верста (старая русская мера длины,равная 1,06 км))."
    },
    {
    id: "1183",
    title: "Үөрбэ",
    text: "уһуктаах синньигэс мас эбэтэр тимир (заостренный кол, шест, рожон)."
    },
    {
    id: "1184",
    title: "Нохто",
    text: "  сүрэх хайырҕаһа, сүрэхтэн тахсар хаан сүүрэр үөс тымыр-дара (вена, аорта)."
    },
    {
    id: "1185",
    title: "Хайҕахтаах хара быар",
    text: "быары хоһуйар халбаҥнаабат эпитет, суолтата – кыраҕа хамнаабат, ньыгыл (постоянный эпитет печени, значение – крепкий, плотный, постоянный)."
    },
    {
    id: "1186",
    title: "Чиккэй",
    text: "көбүс-көнөтүк тардыллыбыт,  тыҥаабыт  курдук  көнө буол (быть туго натянутым, не свисать)."
    },
    {
    id: "1187",
    title: "Үөкэйдээ",
    text: "көнө  уонна үрдүк буол (быть прямым и высоким)."
    },
    {
    id: "1188",
    title: "Туруук",
    text: "наһаа үрдүк, олус туруору (очень крутой, отвесный)."
    },
    {
    id: "1189",
    title: "Эҥэр",
    text: "туох эмэ ойоҕос, кытыы өттө (край, сторона чего-л)."
    },
    {
    id: "1190",
    title: "Кыргыһыы",
    text: " утарыта көрсөн сэриилэһии, кыдыйсыы (битва, сражение)."
    },
    {
    id: "1191",
    title: "Кыырык",
    text: "суос,  уор,  дьулаан (ярость,  злость,  гнев)."
    },
    {
    id: "1192",
    title: "Оноҕос",
    text: "былыр сүнньүнэн булка туттуллар ох (в старину: стрела, применяемая в основном на охоте)."
    },
    {
    id: "1193",
    title: "Хомуһун",
    text: "ап күүһэ, ойуун-удаҕан аба (волшебство, колдовство, чары)."
    },
    {
    id: "1194",
    title: "Холоҥсо",
    text: "киһи хонноҕун аннын көлөһүнүн сыта (запах пота из подмышек)."
    },
    {
    id: "1195",
    title: "Обургу",
    text: "олох кыра буолбатах, син улахан (довольно большой, значительный (по величине))."
    },
    {
    id: "1196",
    title: "Өксөкү",
    text: "икки эбэтэр үс төбөлөөх хотойдуҥу көтөр (двуглавая или трехглавая мифическая птица, похожая на орла)."
    },
    {
    id: "1197",
    title: "Кэтэрги",
    text: "илиилэриҥ кэнниҥ диэки буолар гына, кэннигинэн;  кэннигинэн,  көхсүгүнэн (руки  назад,  за  спину (отвести, вывернуть, опереться на них, выгнув одновременно спину); выгнувшись)."
    },
    {
    id: "1198",
    title: "Иэччэх",
    text: "тугу-эмэ туохха-эмэ иҥиннэрэн сабарга, аһарга аналлаах оҥоһук; туох эмэ туохха эмэ эргийэн хамсыыр курдук олоруута (шарнир, петля)."
    },
    {
    id: "1199",
    title: "Тобулу",
    text: "курдары, дьөлө (насквозь)."
    },
    {
    id: "1200",
    title: "Туоһахта",
    text: "сүөһү сүүһүгэр баар маҥан бээтинэ (святлое пятно на лбу)."
    },
    {
    id: "1201",
    title: "Өрөҕө",
    text: "хамсыыр харамай иһин тириитэ (брюшка, брюшина).	"
    },
    {
    id: "1202",
    title: "Уйул",
    text: "туох эмэ көнөтө суоҕа, токура (кривизна)."
    },
    {
    id: "1203",
    title: "Куочай кугас",
    text: "ханан да атын булкааһа суох бүтүннүү кугас, бүтэй кугас (красновато-рыжий, полностью рыжий (о масти животных))."
    },
    {
    id: "1204",
    title: "Кыыда",
    text: "ханан да атын  өҥү  кытта  булкуспатах  бүтүннүү үрүҥ өҥ (белый как снег)."
    },
    {
    id: "1205",
    title: "Ураанньык",
    text: "сырдык сурааһын (светлая полоска)."
    },
    {
    id: "1206",
    title: "Хоҥоруу = хоҥуруу",
    text: "мурун  кырыыта, сиһэ (переносица)."
    },
    {
    id: "1207",
    title: "Хаччаҕай",
    text: "кэтит, ньылаҕар (сүүс) (широкий, покатый (лоб))."
    },
    {
    id: "1208",
    title: "Уйгу",
    text: "дэлэй ас-үөл,  олох  баайа-талыма (достаток, благополучие, благосостояние (материальное), изобилие)."
    },
    {
    id: "1209",
    title: "Куйбаҥ",
    text: "төттөрү-таары  хамныыр,  биэрэҥниир, имиллэҥниир (извивающийся, виляющий, вертлявый)."
    },
    {
    id: "1210",
    title: "Хоҥкуй",
    text: "төбөҕүн төҥкөт (склонять голову)."
    },
    {
    id: "1211",
    title: "Бөтөс",
    text: "күүһүн-уоҕун эрээрэнэр харса-хабыра суох эбэтэр дохсунэдэр киһи (молодой человек, полагающийся в своих поступках большей частьюна свою физическую силу и энергию, молодчик)."
    },
    {
    id: "1212",
    title: "Сыыдам",
    text: "түргэн туттунуулаах, суһаллык ону маны гынар, оҥорор, кэлэр-барар (быстрый, скорый, спорый, расторопный)."
    },
    {
    id: "1213",
    title: "Кулан",
    text: "кэлиилээх-барыылаах, дьалхааннаах, дохсун (резвый, бойкий, буйный, бурный)."
    },
    {
    id: "1214",
    title: "Дьорҕоот",
    text: "туохтан, кимтэн да чаҕыйан турбат (никого, ничего  не  боящийся, смелый, отважный, храбрый)."
    },
    {
    id: "1215",
    title: "Субай",
    text: "сылгы хаанын иһиккэ  туруордахха  үөһэ  өттүгэр  ырааһыран  тахсар  өһөҕө  суох  өттө (отстоявшаяся в посуде алая жидкая конская кровь без сгустков)."
    },
    {
    id: "1216",
    title: "Бөлүөх",
    text: "хойдон, туохха эмэ сыстан олорон хаал (образовывать сгусток (сгустки), запекаться)."
    },
    {
    id: "1217",
    title: "Сөгөлөөн",
    text: "сиргэ эбэтэр тордоххо утуйарга халыҥ гына тэлгэтиллибит мас мутукчата; манна «тэллэхтээх, олбохтоох» диэн суолтаҕа туттуллубут (многослойный настил из хвои, используемый в качестве подстилки для сна)."
    },
    {
    id: "1218",
    title: "Дьугдьуур",
    text: "таас хайа харталаспыт төбөлөрө; уһун субурҕа сис хайа (вершины каменных гор; горный хребет)."
    },
    {
    id: "1219",
    title: "Дьулай",
    text: "туох эмэ үрдээн  көстөөччү саамай  төбөтө,  оройо (верхушка,  макушка  чего-л.)."
    },
    {
    id: "1220",
    title: "Кыталык элэмэс",
    text: "атаҕа сүһүөҕэр диэри маҥан кугас элэмэс (лошадь пегой масти с белыми до колен ногами)."
    },
    {
    id: "1221",
    title: "Чоккуруос",
    text: "cырдык, туртаҕай (сылгы хараҕын туһунан) (светлый, беловатый (о глазах лошади))."
    },
    {
    id: "1222",
    title: "Ардайдаах сиэл",
    text: "биир кэлим маҥан сиэллээх буолбакка арыта хара (тянуться не сплошным белыми волосками, а с промежутками имеет черные волосы)."
    },
    {
    id: "1223",
    title: "Чоҥкуруун",
    text: " олус  тоҥон чоҥкуначчы тыаһаан тосто сылдьар буолбут (мёрзлый до звонкости при ломке)."
    },
    {
    id: "1224",
    title: "Томторук",
    text: "ньирэй уонна ыт муннугар кэтэрдиллэр туос, мас мэһэй оҥоһук (намордник из берёсты, дерева  для  собаки,  телёнка)."
    },
    {
    id: "1225",
    title: "Күннүк",
    text: "биир күнү быһа айанныыр сир (расстояние, которое можно преодолеть за один день)."
    },
    {
    id: "1226",
    title: "Чуоҕур",
    text: "эбир курдуктаах дьүһүн (пестрый, чубарый)."
    },
    {
    id: "1227",
    title: "Кырыыс",
    text: "киһиэхэ куһаҕаны баҕарыы (проклятие)."
    },
    {
    id: "1228",
    title: "Чаачар",
    text: "ох саа (лук)."
    },
    {
    id: "1229",
    title: "Өндөл",
    text: "үрдүк (высокий)."
    },
    {
    id: "1230",
    title: "Уһаты",
    text: "устатынан, усталыы барар (протяжённый, расположенный в длину)."
    },
    {
    id: "1231",
    title: "Хараҕа",
    text: "тугу эмэ арахсыбат гына холбуур киин, сүрүн (cтержень для соединения или удержания на нём каких-л. деталей механизма, чека).   "
    },
    {
    id: "1232",
    title: "Сохсо",
    text: "булду баттатан өлөрөргө аналлаах маһынан оҥоһуллубут булт сэбэ (ловушка, пасть (на зверя))."
    },
    {
    id: "1233",
    title: "Таалыйа = таала",
    text: "кытаанах сирдээх кураанах дэхси киэҥ хонуу (равнина с твердой сухой поверхностью)."
    },
    {
    id: "1234",
    title: "Хараҕаччы = хараҥаччы",
    text: "кыптыыйдыы уһун кынаттаах, түргэнник көтөр, түөһүгэр маҥаннаах кыра хара чыычаах (маленькая, быстро летающая птица отряда воробьиных с длинными острыми крыль-ями, ласточка, стриж)."
    },
    {
    id: "1235",
    title: "Кураҕаччы",
    text: "уһун атахтаах, элбэх саҥалаах чөкчөҥө бииһэ, көтөр (большой веретенник)."
    },
    {
    id: "1236",
    title: "Дьөһүөл",
    text: "аргыс (спутник)."
    },
    {
    id: "1237",
    title: "Сиэр",
    text: "бэйэтэ кугастыҥы дьүһүннээх гынан баран сиэлэ, кутуруга хара  ардайдаах  (сылгыны  этэргэ) (саврасый  (о  масти  лошадей))."
    },
    {
    id: "1238",
    title: "Күрдьүгэс",
    text: "туора хараҥа дьураалардаах кугас (рыжий с темными полосами)."
    },
    {
    id: "1239",
    title: "Силэй",
    text: "иннигин мэһэйдиир тугу эмэ туора анньан халбарыт эбэтэр икки аҥыы тутан арый (раздвигать в стороны что-л., рассекать)."
    },
    {
    id: "1240",
    title: "Саньньылый",
    text: "туохха эмэ ыйанан намылыйан тур; лаппа аллара түһэн намылый (висеть, свисать; тянуться вниз)."
    },
    {
    id: "1241",
    title: "Хотоҕос",
    text: "илим, муҥха үөһээ ситимигэр  баайыллар дагдатар  түүрүллүбүт  туос  эбэтэр  атын  чэпчэки  оҥоһук (поплавок  из  берёсты  или  другого легковесного материала)."
    },
    {
    id: "1242",
    title: "Кырбый",
    text: "мохсоҕоллооҕор кыра,  араас  бөдөҥ  үөн-көйүүр,  кутуйах аһылыктаах,  мас  көҥдөйүгэр  уйаланар тыҥырахтаах көтөр (кобчик)."
    },
    {
    id: "1243",
    title: "Хараҥаччы",
    text: "кыптыыйдыы уһун кынаттаах, түргэнник көтөр, түөһүгэр маҥаннаах кыра хара чыычаах (маленькая, быстро летающая птица отряда воробьиных с длинными острыми крыльями, ласточка, стриж)."
    },
    {
    id: "1244",
    title: "Дьаарбаҥ",
    text: "дьиэ сүөһүтэ мэччийэр, аһыыр сирэ (место, где пасется скот, кормятся животные, пастбище)."
    },
    {
    id: "1245",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "1246",
    title: "Дьүүл",
    text: "буруйдааҕы суут көрөн, ырыҥалааһына (cудебное разбирательство)."
    },
    {
    id: "1247",
    title: "Үүс-аас",
    text: "сырдык,  ыраас (светлый, чистый)."
    },
    {
    id: "1248",
    title: "Көй",
    text: "үгүс ахсааннаах, элбэх, дэлэй (имеющийся в  большом количестве,  многочисленный,  обильный)."
    },
    {
    id: "1249",
    title: "Дьаргыл",
    text: "ньиргиэрдээх, дуорааннаах (звонкий,  гулкий)."
    },
    {
    id: "1250",
    title: "Араҥа туос",
    text: "саас-сааһынан арах-сар  туос (cлоистая  береста)."
    },
    {
    id: "1251",
    title: "Аркыыба",
    text: "үйэлээх өйдөбүнньүк, ытык сурук, бочуоттаах мэҥэ сурук (cвященное памятное письмо)."
    },
    {
    id: "1252",
    title: "Оччугуй",
    text: "ахсаанынан  эбэтэр кээмэйинэн  кыра,  аччыгый,  бытархай, улахана суох (малый, маленький, небольшой).  "
    },
    {
    id: "1253",
    title: "Күөкэримэ",
    text: "уһун (длинный)."
    },
    {
    id: "1254",
    title: "Бочугурас",
    text: "мас көтөрө (рябчик)."
    },
    {
    id: "1255",
    title: "Ымыйа",
    text: "убаҕас аска туттуллар чабычахтыҥы быһыылаах мас иһит (большая деревянная чаша, большая посуда для жидкой пищи)."
    },
    {
    id: "1256",
    title: "Көбүө",
    text: "чороон кырыыта, кытыыта (край, окраинная часть чорона)."
    },
    {
    id: "1257",
    title: "Мараччы",
    text: "туох эмэ ыараханы,  улаханы  лаппыйа  тутан,  түөскэр өйөөн (көтөх, илт) (с большим усилием,  напряжением  (поднимать  что-л. тяжёлое  и  нести  его  на  груди))."
    },
    {
    id: "1258",
    title: "Тараһа",
    text: "ис-үөс быччыҥнардаах тас бүрүөһүнэ (брюшина)."
    },
    {
    id: "1259",
    title: "Сибиир",
    text: "сир-дойду, хайа эмэ туспа дойду, аан дойду (отдельное место обитания, страна, земной шар)."
    },
    {
    id: "1260",
    title: "Айыы",
    text: "дьылҕа, оҥоруу, анал (cудьба, рок, участь)."
    },
    {
    id: "1261",
    title: "Эскэл",
    text: "этиргэн, толору эттээх-сииннээх, модьу-таҕа көрүҥнээх (тучный, толстый, жирный)."
    },
    {
    id: "1262",
    title: "Баараҕай",
    text: "бөдөҥ-садаҥ, көрүҥүнэн олус улахан (очень большой, крупный)."
    },
    {
    id: "1263",
    title: "Ньилбэк",
    text: " киһи буутун илин өттө;  сүөһү  илин  атахтарын  тобугуттан үөһээ  өттө (cередняя  часть  бедра  (у человека); верхняя часть передней конечности (у животных)). "
    },
    {
    id: "1264",
    title: "Дьаҕыл",
    text: "санныгар эбэтэр моонньугар сүрүн өҥүттэн туспа дьүһүннээх улахан ойуулаах (имеющий большое пятно на лопатках или на шее)."
    },
    {
    id: "1265",
    title: "Сүмэһин",
    text: "үүнээйи ордук амтаннаах, иҥэмтэлээх симэһинэ (жидкость, сок, содержащийся в клетках, такнях растений)."
    },
    {
    id: "1266",
    title: "Биэбийдээ",
    text: " таптаан, эйэргээн иит."
    },
    {
    id: "1267",
    title: "Арҕах",
    text: "дьонтон-сэргэттэн күрэнэн, түҥ тыаҕа сири хаһан оҥоһуллубут балаҕан (землянка в глухом лесу, где люди скрываются от посторонних глаз)."
    },
    {
    id: "1268",
    title: "Суккуй",
    text: "барамматы сүөкүүр  курдук  өлгөмнүк,  элбэхтик  кут, сүөкээ (лить нескончаемым потоком; литься, течь нескончаемым потоком)."
    },
    {
    id: "1269",
    title: "Кукаам = тукаам",
    text: "оҕоҕо эбэтэр бэйэҕиттэн эдэр киһиэхэ эйэҕэстик туһулаан этэр тыл (ласковое обращение к ребенку или человеку более молодого возраста: дидятко)."
    },
    {
    id: "1270",
    title: "Эндэл",
    text: "куттал (опасность)."
    },
    {
    id: "1271",
    title: "Кэрискэ",
    text: "кэккэлии эбэтэр субуруччу туруу; бииртэн-биир субурҕа, кэккэ буолан көстүү (выстраиваться в ряд, рядами, шеренгами; тянуться ровными  рядами)."
    },
    {
    id: "1272",
    title: "Эбир",
    text: "төгүрүк (круглый)."
    },
    {
    id: "1273",
    title: "Былас",
    text: " уста кээмэйэ: туора уунуллубут илиилэр тарбахтарын төбөтүттэн нөҥүө тарбахтар төбөлөрүгэр диэри (маховая сажень, размах равный 1,76 м.)."
    },
    {
    id: "1274",
    title: "Сэрэбиэй",
    text: "туох эрэ биллибэти,  киһиэхэ  туох  эмэ  төһө  табыллыаҕын хаартынан таайан көрүү (жребий,  гадание  (на  картах))."
    },
    {
    id: "1275",
    title: "Оччугуй",
    text: "ахсаанынан  эбэтэр кээмэйинэн  кыра,  аччыгый,  бытархай, улахана суох (малый, маленький, небольшой).  "
    },
    {
    id: "1276",
    title: "Нуоҕай",
    text: "бэргэһэ оройуттан намылыйан дугалыы түспүт куорсун эбэтэр түү (перо, висящее дугой на верхушке, макушке шапки)."
    },
    {
    id: "1277",
    title: "Бэлэньньик",
    text: "сон, ырбаахы сиэҕин алларааҥҥы бүүрүгэ эбэтэр тиэриитэ (обшлаг, манжет)."
    },
    {
    id: "1278",
    title: "Илбиргэс",
    text: "туохха эмэ ыйанан эйэҥэлии сылдьар киэргэл (небольшое подвесное украшение, подвеска)."
    },
    {
    id: "1279",
    title: "Былаайах",
    text: "ойуун дүҥүрүн охсор түүлээх тыс бүрүөһүннээх кэдэгэр мас лаппаакыта (колотушка от шаманского бубна, покрытая мехом оленьих ног (или собачьих лап))."
    },
    {
    id: "1280",
    title: "Дүҥүр",
    text: "ойуун кыырарыгар былаайаҕынан охсон тыаһатар тэрилэ (шаманский бубен)."
    },
    {
    id: "1281",
    title: "Ситимэх",
    text: "Саха  мифологиятыгар  тугу баҕарар бэйэтигэр сыһыары тардан сөрөөн кэбиһэр аптаах илим (в якутской мифологии: волшебная паутина, притягивающая в свои сети и опутывающая всё что)."
    },
    {
    id: "1282",
    title: "Нүрүс",
    text: "төҥкөччү  тутун, төҥ көйөн  аллара  түс (пригнуться)."
    },
    {
    id: "1283",
    title: "Анды",
    text: "хара дьүһүннээх, умсаах-тааҕар быдан улахан, тумсугар хохуора-лаах, кыһыл атахтаах үөл кус бииһэ (турпан)."
    },
    {
    id: "1284",
    title: "Күүгүнээ",
    text: "дьону мэһэйдиир гына айдааран элбэхтик саҥарар, улаханнык күлэр (вести себя шумно, шуметь, галдеть)."
    },
    {
    id: "1285",
    title: "Сиибиктэ",
    text: "ойуур саҕатыгар күлүк сиргэ үүнэр, хойуу соҕус лабаалардаах, сүөһү сөбүлээн сиир намчы боруута (ветвистый нежный вид хвоща, растущий по опуш-кам леса в тени и отличающийся питательностью для скота, хвощ пёстрый)."
    },
    {
    id: "1286",
    title: "Далай",
    text: "түгэҕэ  биллибэт, наһаа  дириҥ,  улахан,  муҥура  суох (чрезвычайно глубокий, широкий, безграничный)."
    },
    {
    id: "1287",
    title: "Дьүһүттэриилээх",
    text: "аналлаах, ыйаахтаах (предназначенный)."
    },
    {
    id: "1288",
    title: "Тэримдьи",
    text: "ыйаахтаах (приказанный)."
    },
    {
    id: "1289",
    title: "Сүргүй",
    text: "улахан сиэрэ-туома суох кими, тугу эмэ алҕаа (благословлять кого-что-л. без особых церемоний, обрядов)."
    },
    {
    id: "1290",
    title: "Дьаҥсах",
    text: "фольк.  күүстээх,иччилээх (тыл, саҥа);  ыарахан, нүһэр(тыас) (веский,  внушительный  (оречи, словах); тяжелый, грохочущий (ошуме))."
    },
    {
    id: "1291",
    title: "Дьаҥсах",
    text: "күүстээх, иччилээх (тыл, саҥа);  ыарахан, нүһэр (тыас) (веский,  внушительный  (оречи, словах); тяжелый, грохочущий (о шуме))."
    },
    {
    id: "1292",
    title: "Буурай",
    text: "бороҥнуҥу күрэҥ (бурый)."
    },
    {
    id: "1293",
    title: "Домнаа",
    text: "ойуун эдэр ойууну  үөрэтэн,  уһуйан  бүтэн  бэлэскэсиллээн баран этэр тыла (слово, которое  произносит  шаман-учитель  послеплевка в зев молодому шаману, что означает завершение обучения шаманскому искусству)."
    },
    {
    id: "1294",
    title: "Сах",
    text: "куһаҕан саҥнаах күүс, тыын (недобрая сила, недобрый дух)."
    },
    {
    id: "1295",
    title: "Уйгу",
    text: "дэлэй ас-үөл, олох  баайа-талыма (достаток, благополучие, благосостояние (материальное), изобилие)."
    },
    {
    id: "1296",
    title: "Кэччэрий",
    text: "киэр хайыс, халбарый (oтворачиваться, отвращаться)."
    },
    {
    id: "1297",
    title: "Кэскил",
    text: "олох инники дьоло, инники туруктаах дьоллоох үтүө олох (будущее счастье, благополучие; будущее развитие, расцвет)."
    },
    {
    id: "1298",
    title: "Кэнчээри",
    text: "үүнэн  иһэр  көлүөнэ,  ыччат (подрастающее  поколение,  молодежь)."
    },
    {
    id: "1299",
    title: "Дьүөрэ",
    text: "иһиллиитинэн, тас көрүҥүнэн, быһыытынан-майгытынан сөп түбэсиһэр, маарыннаһар (схожий,похожий (по звучанию, внешнему виду, характеру и т. д.); одинаковый)."
    },
    {
    id: "1300",
    title: "Эркин",
    text: "туох эмэ эркинин оҥоруу, истиэнэлээһин (делать, ставить стену)."
    },
    {
    id: "1301",
    title: "Сөрөө",
    text: "эрийэ тут (обвить, обмотать)."
    },
    {
    id: "1302",
    title: "Саппах",
    text: "күн,  халлаан сырдыгын сабан күлүгүрдэр былыт, туман эбэтэр атын туох эмэ (облака, туман или что-л. другое, застилающее небо и затеняющее солнце)."
    },
    {
    id: "1303",
    title: "Бүлүүсэ",
    text: "тэриэлкэҕэ маарын-ныыр үрдүк соҕус кытыылаах кыра нэлэккэй чэй иһитэ (блюдце)."
    },
    {
    id: "1304",
    title: "Хотоҕой",
    text: "көтөр кыната, дабыдала (крыло птицы)."
    },
    {
    id: "1305",
    title: "Куоссун = куорсун",
    text: " көтөр кынатын саамай бөдөҥ  түүлэрэ (маховое  перо, маховые  перья  птицы)."
    },
    {
    id: "1306",
    title: "Бии",
    text: "этиллэр предмети эбэтэр санааны кини урут ахтыллыбытын, биллэрин туһунан саҥаран, ыйан чопчулууру көрдөрөр (употребляется для выделения в высказывании предмета или мысли путем напоминания о том, что об этом говорилось ранее)."
    },
    {
    id: "1307",
    title: "Былас",
    text: " уста кээмэйэ: туора уунуллубут илиилэр тарбахтарын төбөтүттэн нөҥүө тарбахтар төбөлөрүгэр диэри (маховая сажень, размах равный 1,76 м.)."
    },
    {
    id: "1308",
    title: "Үрэй",
    text: "туох  эмэ  бүтүнү ыһан-тоҕон  кэбис,  онно-манна  быраҕаттаа (разрушать, разорять что-л.)."
    },
    {
    id: "1309",
    title: "Сыаналаа",
    text: "тугу эмэ суоттаан быһаар (определять, оценивать)."
    },
    {
    id: "1310",
    title: "Дьөл",
    text: "эттиккэ тобулу эбэтэр курдаттыы хайаҕас оҥор (насквозь  (просверлить,  пробурить,  про-дырявить  что-л.))."
    },
    {
    id: "1311",
    title: "Дабыдал",
    text: "көтөр кынатын икки  бастакы  (бүлгүнүттэн)  сүһүөҕэ (верхняя часть крыла птицы)."
    },
    {
    id: "1312",
    title: "Уот татай",
    text: "соһуйууну, сөҕүүнү бэлиэтиир саҥа аллайыы (междометие, выражающее сильное удивление, изумление)."
    },
    {
    id: "1313",
    title: "Дьуоҕа",
    text: "түгэҕэ биллибэт оборчо бадараан (глубокое топкое болото)."
    },
    {
    id: "1314",
    title: "Бырах",
    text: "мээнэ барбыт (случайный, шальной)."
    },
    {
    id: "1315",
    title: "Дьабыыл = дьабыл",
    text: "төрөөбөтөх, оҕоломмотох (не  рожавшая)."
    },
    {
    id: "1316",
    title: "Кый",
    text: "олус ыраах, кыраман (очень далекий, дальний)."
    },
    {
    id: "1317",
    title: "Сөрүөстүгэс",
    text: "киһи тылыгар киириммэт үгэстээх,  өһөс,  хадаар (упрямый,  несговорчивый,  неподатливый,  неуступчивый)."
    },
    {
    id: "1318",
    title: "Өкөр",
    text: " иҥнэри  түспүт,  иҥнэйбит (накренившийся,  наклонившийся,  наклонно  стоящий)."
    },
    {
    id: "1319",
    title: "Буурай",
    text: "бороҥнуҥу күрэҥ (бурый)."
    },
    {
    id: "1320",
    title: "Харыс",
    text: "өһөс, дьорҕоот (упрямый, строптивый, злой). "
    },
    {
    id: "1321",
    title: "Дьайаан",
    text: "улахан аймалҕан, араллаан (волнение, беспорядки)."
    },
    {
    id: "1322",
    title: "Сибиир",
    text: "сир-дойду, хайа эмэ туспа дойду, аан дойду (отдельное место обитания, страна, земной шар). "
    },
    {
    id: "1323",
    title: "Барылыкы = барылы",
    text: " олус баай (чрезмерно богатый)."
    },
    {
    id: "1324",
    title: "Байхал = байҕал",
    text: "киэҥ сиринэн тайаан сытар туустаах дириҥ уу (море, океан)."
    },
    {
    id: "1325",
    title: "Хатан",
    text: "тыйыс, кытаанах (суровый, твёрдый, жёсткий)."
    },
    {
    id: "1326",
    title: "Олбох",
    text: "олорор сиргэ уурар, тэлгиир  сымнаҕас  тэллэх  (подстилка для сиденья)."
    },
    {
    id: "1327",
    title: "Онолҕонноох",
    text: "киэҥ, дэлэгэй, холку (широкий, непринуждённый, свободный )."
    },
    {
    id: "1328",
    title: "Дуксуй = дуксуур",
    text: "өтөрү-батары киирэр гына чочуйуллубут, сытыы синньигэс уһуктаах (острый, отточенный)."
    },
    {
    id: "1329",
    title: "Куйбуур",
    text: "уһун уот кымньыы, кутурук (извивающийся огненный кнут, хвост)."
    },
    {
    id: "1330",
    title: "Дьоһун",
    text: "дьоҥҥо туһалаах, суолтатынан  да,  кэриҥинэн  да  улахан, боччумнаах (полезный, имеющий большое значение, важный)."
    },
    {
    id: "1331",
    title: "Тобул",
    text: "тугу эмэ хаһан, дьөлөн үүттээ, курдары таһаар (прорубать, пробивать)."
    },
    {
    id: "1332",
    title: "Тэлэй",
    text: "туох эмэ  аанын киэҥник ас, арый (широко раскрыть, распахнуть двери или окна)."
    },
    {
    id: "1333",
    title: "Амнах",
    text: "өллөххө кэтэр таҥас, өлүнньүк таҥас (посмертная одежда).  "
    },
    {
    id: "1334",
    title: "Көмнөх",
    text: "маска олорон хаалбыт хаар (снег, осевший на ветвях деревьев и на кустах)."
    },
    {
    id: "1335",
    title: "Аанай",
    text: "улаханнык абарыыны, кыйаханыыны көрдөрөр (междометие,  выражающее  сильную  досаду,смешанную с раздражением, возмущением)."
    },
    {
    id: "1336",
    title: "Мындаа",
    text: "туох эмэ саамай үрдэ, арҕаһа (самая возвышенная, высокая часть чего-л.)."
    },
    {
    id: "1337",
    title: "Хаҥырҕас",
    text: "халыгырас-кылыгырас тыастаах тиэрбэс киэргэл, аарык (предмет украшения в виде металлических колечек, побрякивающий, позвякивающий при встряхивании)."
    },
    {
    id: "1338",
    title: "Тиэрбэс",
    text: "туох эмэ кытаанах синньигэс матырыйаалтан оҥоһуллубут төгүрүк (предмет из твердого материала в форме окружности, обода, кольцо)."
    },
    {
    id: "1339",
    title: "Сандырыыс = сындырыыс",
    text: "сытыы, эриллэҥнии сылдьар (хлесткий, извивающийся)."
    },
    {
    id: "1340",
    title: "Сапсылҕан",
    text: "өрө-таҥнары хамсаан чыпчылыйбахтыыр (моргающий, подвижный)."
    },
    {
    id: "1341",
    title: "Айыы далбарҕа кымньыы = Айыы (куо) далбар кымньыы",
    text: "аптаах кымньыы (волшебный кнут)."
    },
    {
    id: "1342",
    title: "Көҥүтэ = көҥү",
    text: "тоҕо-хоро (в большом количестве, обильно, много раз)."
    },
    {
    id: "1343",
    title: "Дэриэтинньик",
    text: "илэ сылдьар абааһы, киһини сиэччи (зомби, нечисть, чудовище)."
    },
    {
    id: "1344",
    title: "Оппуос",
    text: "хайаҕа, сыырга тахсар аартык, дабаан (дорога вверх по склону)."
    },
    {
    id: "1345",
    title: "Самыыр",
    text: "былыт  уута  хойдон  аллара  таммалаан  түһүүтэ,  ардах (дождь)."
    },
    {
    id: "1346",
    title: "Кырыа",
    text: "туохха эмэ олорбут сиик  тымныыга  тоҥон  хаар  буолбута (иней)."
    },
    {
    id: "1347",
    title: "Өксүөн",
    text: "күһүҥҥү  хаар  былаастаах  тыаллаах-куустаах  самыыр;  күһүҥҥү хаар-самыыр (осенний дождь вперемешку со снегом; осеннее ненастье)."
    },
    {
    id: "1348",
    title: "Хахсаат",
    text: "сааскы, күһүҥҥү  былыттаах,  тыаллаах  тымныы  күн; сааскы, күһүҥҥү тымныы тыал (неясные морозные дни весной, осенью; холодный сильный ветер обычно ранней весной, поздней осенью)."
    },
    {
    id: "1349",
    title: "Куоһар",
    text: "урут ситиһиллибит эбэтэр ситиһиллиэхтээх  кирбиини аһара түс (превзойти ранее достигнутый  или  намеченный  результат)."
    },
    {
    id: "1350",
    title: "Туорайдаа",
    text: "туохха эмэ туорайы оҥор, уур; тугу эмэ туорай гына  түһэр,  туохха  эмэ  туора  түс (приделывать  поперечину  к  чему-л.; быть расположенным по ширине, поперёк чего-л.)."
    },
    {
    id: "1351",
    title: "Сургуй",
    text: "тугу эмэ быыһынан-ардынан сүргэйэн көстүбэт-биллибэт курдук сырыт, киир (захаживать (подлежать) снизу, пролазить (пролезать), входить под что-либо ползком)."
    },
    {
    id: "1352",
    title: "Буом-боһол",
    text: "туох эмэ буом, бохсуу; бохсуу буолар эрэй, кыһалҕа (какая-л. преграда в пути, трудности, сковывающие чьи-л. возможности, илилишения, муки, которые нужно преодолеть)."
    },
    {
    id: "1353",
    title: "Кулан",
    text: "кэлиилээх-барыылаах, дьалхааннаах, дохсун (резвый, бойкий, буйный, бурный)."
    },
    {
    id: "1354",
    title: "Боһойдоо",
    text: "туохха эмэ буом-харгыс буол; буомнаа, мэһэйдээ (быть преградой, стоять поперекдороги кому-чему-л.)."
    },
    {
    id: "1355",
    title: "Сүүмэх",
    text: "туох эмэ утах курдук  уһун,  синньигэс,  бэйэ-бэйэтин кытта  холбоспута,  холбуу  тутуллубута (пучок)."
    },
    {
    id: "1356",
    title: "Уох кылын",
    text: "күүс, кыах (сила, крепость)."
    },
    {
    id: "1357",
    title: "Күртүөннээх = күттүөннээх",
    text: "киһи ылынарын курдук ыллыктаах, көдьүүстээх (полезный, путный, достойный)."
    },
    {
    id: "1358",
    title: "Маҥаас",
    text: "бэйэтин дьүһүнүттэн тутулуга суох сирэйэ олоччу эбэтэр муннуттан сүүһүгэр диэри маҥаннаах (с белой от-метиной  на морде независимо от  масти)."
    },
    {
    id: "1359",
    title: "Күлүбүрэччи",
    text: "тыастаахтык-уустаахтык, өрө саласпыттыы омуннаахтык (ярко, весело, гудящим пламенем)."
    },
    {
    id: "1360",
    title: "Буукса",
    text: "өссө күүскэ, эбии (сильнее)."
    },
    {
    id: "1361",
    title: "Харгыйа",
    text: "суор (ворон)."
    },
    {
    id: "1362",
    title: "Дьаҥсах",
    text: "күүстээх, иччилээх (тыл, саҥа);  ыарахан, нүһэр (тыас) (веский,  внушительный  (оречи, словах); тяжелый, грохочущий (о шуме))."
    },
    {
    id: "1363",
    title: "Сымара",
    text: "улахан,  көһөҥө (большой, глыбистый)."
    },
    {
    id: "1364",
    title: "Намылыт",
    text: "уһун  субурҕа  тугу  эмэ  үөһэттэн  аллара  түһэр, ыйаан  субурут (свесить,  опустить что-л.  вниз,  распустить)."
    },
    {
    id: "1365",
    title: "Чөмчөкө",
    text: " бас уҥуоҕа (череп)."
    },
    {
    id: "1366",
    title: "Билир",
    text: "киһи саамай тиһэх үүнэр кэлин балтата (зуб мудрости)."
    },
    {
    id: "1367",
    title: "Одулуун = одуруун",
    text: "оллур-боллур, бөлтөҕөр (неровность, бугристость)."
    },
    {
    id: "1368",
    title: "Уурумдьу = уурумньу",
    text: "уурулла  сытар баай, харчы, ас-үөл (хранящиеся про запас деньги, продукты, другие ценности, сбережения)."
    },
    {
    id: "1369",
    title: "Бардьыгыначчы",
    text: "хабах буола үллэн таҕыс (вздуватьсяот пузырей, пузыриться).  "
    },
    {
    id: "1370",
    title: "Хабырын",
    text: "аалсан «кыычыр-хаачыр» диэн эрэр курдук ыраахха диэри эҥсиллэн тыаһаа, оннук  дуораһый  (скрипеть,  трещать,  громыхать)."
    },
    {
    id: "1371",
    title: "Чугуруй = чугуй",
    text: "инниҥ диэки баран  иһэн  төттөрү  түс,  кэннигинэн  бар (кятиться, отступать, отходить назад)."
    },
    {
    id: "1372",
    title: "Үөгүлээ",
    text: "улаханнык, тоҕо баран хаһыытаа (громко кричать, вопить)."
    },
    {
    id: "1373",
    title: "Үлүскэннээх",
    text: "күүрээннээх,  күүстээх,  эрчимнээх  (вдохновенный, упорный, напряжённый)."
    },
    {
    id: "1374",
    title: "Үүн",
    text: "ат баһыгар кэтэрдиллэр  уостуганнаах,  тэһииннээх,  үксүгэр куртан  оҥоһуллубут ат тэрилин  көрүҥэ (часть конской сбруи – ремни с удилами и поводьями, надеваемые на голову лошади, узда)."
    },
    {
    id: "1375",
    title: "Кымньыы",
    text: "сүөһүнү үүрэргэ, былыр  киһини  таһыйарга  аналлаах  мас укка олордуллубут быа (веревка  или  ремень,  привязанные  к палке и служащие для понукания животного, в старину — для телесных наказаний,  кнут,  плеть,  нагайка)"
    },
    {
    id: "1376",
    title: "Төлүтэ = төлө",
    text: "соһуччу уонна эрчимнээхтик буолар дьайыыны көрдөрөр (означает резкость, силу и завершённость действия)."
    },
    {
    id: "1377",
    title: "Суоруна",
    text: "сиэмэ бурдугу айаҕынан кутан эргитэн мэлийэр оҥоһуулаах таас (жёрнов, ручная мельница)."
    },
    {
    id: "1378",
    title: "Киспэ",
    text: "ис,  куртах (живот, желудок)."
    },
    {
    id: "1379",
    title: "Кэриҥ",
    text: "туох эмэ көрүҥэ, формата, көстөр дьүһүнэ (внешний вид, форма чего-л.)."
    },
    {
    id: "1380",
    title: "Өөҕүргээ",
    text: "«өөх-өөх» диэн саҥар (кряхтеть, по-кряхтывать  (при  сильном  напряжении)."
    },
    {
    id: "1381",
    title: "Кулгуй",
    text: "аһаабыт ас сорҕотун  айаххынан  төттөрү  таһаар (срыгивать обратно часть съеденного)."
    },
    {
    id: "1382",
    title: "Түрдэс гын",
    text: "күүрэн  эмискэ  түүрэ  тарт,  түүрүлүн  (сжаться, съёжиться)."
    },
    {
    id: "1383",
    title: "Үн",
    text: "түөрт атах буолан эбэтэр  олорон  эрэ  сыылан  инниҥ  диэки сыҕарый (ползать на четвереньках, ползать)."
    },
    {
    id: "1384",
    title: "Болгуо",
    text: "былыргы саха уустара уруудаттан уһааран ылар тимирдэрин сомоҕото (железные болванки, получаемые путем сплава руды древними якутскими кузнецами)."
    },
    {
    id: "1385",
    title: "Чээрэлээ",
    text: "туох эмэ ордугуттан, тобоҕуттан хомуй (собрать из остатков чего-л.)."
    },
    {
    id: "1386",
    title: "Кыын",
    text: "биилээх, уһуктаах сэп тимир өттө угуллар хаата (ножны)."
    },
    {
    id: "1387",
    title: "Сүүдүй",
    text: "күүскэ умсугуй, баҕар (чувствовать сильное влечение)."
    },
    {
    id: "1388",
    title: "Чиккэй",
    text: "көбүс-көнөтүк тардыллыбыт,  тыҥаабыт  курдук  көнө буол (быть туго натянутым, не свисать)."
    },
    {
    id: "1389",
    title: "Эчикээйиэм",
    text: "соһуйууну, курутуйууну, куттаныыны, сэнээһини көрдөрөр (выражает удивление, горе, испуг, презрение говорящего к содержанию высказывания)."
    },
    {
    id: "1390",
    title: "Эйиэн = эдьэн",
    text: "улуу-хаан,  улуу, саамай  үрдүкү (высокочтимый,  почтеннейший)."
    },
    {
    id: "1391",
    title: "Арҕах",
    text: "дьонтон-сэргэттэн күрэнэн, түҥ тыаҕа сири хаһан оҥоһуллубут балаҕан (землянка в глухом лесу, где люди скрываются от посторонних глаз)."
    },
    {
    id: "1392",
    title: "Суккуй",
    text: "барамматы сүөкүүр  курдук  өлгөмнүк,  элбэхтик  кут, сүөкээ (лить нескончаемым потоком; литься, течь нескончаемым потоком)."
    },
    {
    id: "1393",
    title: "Сүлдьүү",
    text: "сүрэх быата (дуга аорты)."
    },
    {
    id: "1394",
    title: "Ньалҕарыт",
    text: "тарҕанар, халыйар гына илит (сделать так, что-бы что-л. расплылось, растеклось; растопить,  разморозить  что-л)."
    },
    {
    id: "1395",
    title: "Сириэдий",
    text: "силистэнэн-мутуктанан олохтоохтук үүн, үөскээ, тэний; үүнэн-сайдан таҕыс, туругур (вырастать,  цвести,  укоренившись;  здравствовать, процветать)."
    },
    {
    id: "1396",
    title: "Оҥочо",
    text: "өрүскэ  мииниллэр улахан тыы (лодка, ладья)."
    },
    {
    id: "1397",
    title: "Дуксуур",
    text: "өтөрү-батары  киирэр  гына чочуйуллубут, сытыы синньигэс уһуктаах (острый, отточенный)."
    },
    {
    id: "1398",
    title: "Сугсурҕа = суксурҕа",
    text: "хас да көлө субуһуннары көлүйүллүбүтэ (гуж лошадиный, бычий). "
    },
    {
    id: "1399",
    title: "Күкүр таас",
    text: "улахан кэлим таас, сымара  таас (большой  массивный  камень, каменная глыба)."
    },
    {
    id: "1400",
    title: "Кубулҕат",
    text: "дьүһүн кубулуйан хаалыы (чудесное превращение, перевоплощение)."
    },
    {
    id: "1401",
    title: "Субай",
    text: "сылгы хаанын иһиккэ  туруордахха  үөһэ  өттүгэр  ырааһыран  тахсар  өһөҕө  суох  өттө (отстоявшаяся в посуде алая жидкая конская кровь без сгустков)."
    },
    {
    id: "1402",
    title: "Куудьуй",
    text: "көҕүт, абылаа, санаатын абылаа (манить, привлекать, обворожить)."
    },
    {
    id: "1403",
    title: "Тэгэл = тэгил",
    text: "ыраах,  тэйиччи (далёкий, отдалённый). "
    },
    {
    id: "1404",
    title: "Хармаан",
    text: "карман. "
    },
    {
    id: "1405",
    title: "Соноҕос сылгы",
    text: "үстээх-түөртээх атыыр эбэтэр аттаммыт сылгы (молодой жеребец трех-четырех лет или выхолощенный конь)."
    },
    {
    id: "1406",
    title: "Аҕыс иилээх-саҕалаах",
    text: "чопчу быһыылаах-таһаалаах, бэрээдэктээх (имеющий контуры, очертания, четкую  форму,  определенный  порядок)."
    },
    {
    id: "1407",
    title: "Атааннаах-мөҥүөннээх",
    text: "охсуһуулаах, түрбүөннээх, иирээннээх, аймалҕаннаах (беспокойный, тревожный, полный раздоров, борьбы)."
    },
    {
    id: "1408",
    title: "Амын-намыл",
    text: "нарын-намчы (приятный)."
    },
    {
    id: "1409",
    title: "Айгыр силик",
    text: "сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)."
    },
    {
    id: "1410",
    title: "Алаһа",
    text: "төрөөбүт-үөскээбит дьиэ-уот (родной дом, родная обитель, родной очаг)."
    },
    {
    id: "1411",
    title: "Ханыылас",
    text: "өрүнэн сырыт,  үөргэ  холбос (сбиваться  в стаю, собираться в стадо, табун). "
    },
    {
    id: "1412",
    title: "Таман",
    text: "сүөһү,  кыыл  ойоҕоһун  чараас  тас  бүрүө  этэ  уонна  ол иһинэн үөскүүр сыата (тонкий наружный слой мяса на рёбрах, а также жир под ним у скота и зверя)."
    },
    {
    id: "1413",
    title: "Саал",
    text: "сылгы  моонньун үөһээ кырыытынан үөскүүр кытаанах сыа (жировое отложение на загривке лошади)."
    },
    {
    id: "1414",
    title: "Халааньньы = халаанньа",
    text: "туох  да  сыала-соруга  суох төттөрү-таары  хаамар,  мээнэ  сылдьар (ходит взад и вперёд бесцельно, без большой  надобности,  бродит  без  дела).  "
    },
    {
    id: "1415",
    title: "Күллүргээ",
    text: "тохтоло суох күллүргэс тыаһы таһаар (производить  прерывистый  и  глухой  шум,  накатывая  и ударяясь о  берег,  плескаться)."
    },
    {
    id: "1416",
    title: "Эрдии",
    text: "ууга эрдинэн тыыны, оҥочону уһуннарар, төбө өттө салбахтаах ураҕас (шест с лопастью для гребли, весло)."
    },
    {
    id: "1417",
    title: "Тиҥиргэс",
    text: "биир  кэм бүтэҥитик  ньиргийэр  (гулко стучащий, гремящий)."
    },
    {
    id: "1418",
    title: "Лиэһэй",
    text: "леший. "
    },
    {
    id: "1419",
    title: "Килэрий",
    text: "ньалҕархай килэгир  ньуурданан  көһүн (блестеть, лосниться, иметь глянцевую поверхность)."
    },
    {
    id: "1420",
    title: "Куорай далаан",
    text: "харбааһыннаах, иҥсэлээх ытыс (загребистая  ладонь  (рука)."
    },
    {
    id: "1421",
    title: "Тиҥийээ-таҥыйаа = тигинээ-таҥынаа",
    text: "ньиргиэрдээх, улахан тыаһы-ууһу таһаар (производить гулкий стук, сильный  шум)."
    },
    {
    id: "1422",
    title: "Идэмэр",
    text: "иҥсэ, обот (жадность, алчность)."
    },
    {
    id: "1423",
    title: "Баҕадьыкаан = баҕайы",
    text: "сөбүлээбэт, абааһы көрөр, кэлэйэр, сэниир сыһыаны көрдөрөр (выражает неодобрение, осуждение, сильное разочарование, пренебрежение, отвращение)."
    },
    {
    id: "1424",
    title: "Баллырҕаа",
    text: "айаҕын иһигэр тылыҥ баппакка мэһэйдии сылдьарын курдук олуттаҕастык саҥар (говорить невнятно)."
    },
    {
    id: "1425",
    title: "Һой-буйака",
    text: "норуот ырыатыгар-хоһоонугар саҥарааччы туох эмэ кыһалҕатын, туохтан эмэ ыксаабытын биллэрэр тылын курдук туттуллар (в народных песнях употребляется как слово, выражающее сильное беспокойство говорящего о чем-л.)."
    },
    {
    id: "1426",
    title: "Кулуба",
    text: "өрөбөлүүссүйэ иннинэ Саха сиригэр улуус быыбардаммыт баһылыга (до революции в Якутии улусный голова)."
    },
    {
    id: "1427",
    title: "Аркыыба",
    text: "үйэлээх өйдөбүнньүк, ытык сурук, бочуоттаах мэҥэ сурук (cвященное памятное письмо)."
    },
    {
    id: "1428",
    title: "Чиэски",
    text: "уһук сиргэ баар, ыраах, туора турар (находящийся вдали от центра, окраинный, глухой)."
    },
    {
    id: "1429",
    title: "Дьулурҕан",
    text: " киһи дьулайыан курдук  наһаа  дохсун,  күүрээннээх (весьма быстрый, бурный, стремительный,активный)."
    },
    {
    id: "1430",
    title: "Дьулурҕа",
    text: "тохтоло суох иннин диэки дьулуһар; түргэн, сыыдам (рвущийся вперед; стремительный, быстрый)."
    },
    {
    id: "1431",
    title: "Сүнньү = сүрүн",
    text: "киһи моонньун кэтэх, көхсүн диэки өттө (затылочная сторона шеи)."
    },
    {
    id: "1432",
    title: "Күөгэй",
    text: "аа-дьуо нуоҕайа хамсаа (плавно,  мягко  клониться,  склоняться)."
    },
    {
    id: "1433",
    title: "Үп",
    text: "харчы,  харчынан  баай (средства,  деньги,  финансы)."
    },
    {
    id: "1434",
    title: "Сүргүөх",
    text: "сис  тоноҕоһун биир сүһүөх уҥуоҕа, кэрчигэ (отдельная кость позвоночника, позвонок спинного хребта)."
    },
    {
    id: "1435",
    title: "Сөмүйэ",
    text: " киһиэхэ илиитин эрбэҕиттэн иккис тарбаҕа (указательный палец)."
    },
    {
    id: "1436",
    title: "Сарбай",
    text: "тугу эмэ тутаары,  харбаан  ылаары  илиигин  эбэтэр тыҥырахтаргын  саратан чугаһат (вытягивать руку или лапу с растопыренными когтями к кому-чему-л. с намерением схватить)."
    },
    {
    id: "1437",
    title: "Боҕуй",
    text: "төҥкөҥнөө, сүгүрүй (нагибаться, кланяться)."
    },
    {
    id: "1438",
    title: "Маадьай",
    text: "маадьаччы үктээн хаамп; атахтаргын аччаччы үктэнэн күүскэ тирэн (идти, ходить на кривых ногах; искривиться при подъёме тяжести)."
    },
    {
    id: "1439",
    title: "Мөтөй",
    text: " түөскүн иннин диэки мөтөччү тутун (выпячивать грудь)."
    },
    {
    id: "1440",
    title: "Түөрэх",
    text: "Таҥхалыырга, билгэ-лииргэ туттуллар тээбирин (атрибут для гадания)."
    },
    {
    id: "1441",
    title: "Кэлтэгэй",
    text: " аҥаара  суох  буолбут, аҥаар эрэ өттүлээх (ущербный (месяц), имеющий только одну сторону, один  бок)."
    },
    {
    id: "1442",
    title: "Хаппар",
    text: "курга иилинэр кыра суумка (сумка, которую носят сбоку не ремне).  "
    },
    {
    id: "1443",
    title: "Кыл",
    text: "сылгы сиэлин уонна кутуругун биир утаһына (конский волос)."
    },
    {
    id: "1444",
    title: "Элэй-балай",
    text: "туора-маары, тэлиэс-былаас (нескладно, неуклюже)."
    },
    {
    id: "1445",
    title: "Иэччэх",
    text: "тугу-эмэ туохха-эмэ иҥиннэрэн сабарга, аһарга аналлаах оҥоһук; туох эмэ туохха эмэ эргийэн хамсыыр курдук олоруута (шарнир, петля)."
    },
    {
    id: "1446",
    title: "Түллэҥнээ",
    text: "күүрэн өрө-таҥнары түллүтэлээ (сильно волноваться; вздыматься)."
    },
    {
    id: "1447",
    title: "Дьалкылдьый",
    text: "долгуйан, түллэн  хамсаа,  чалымнаа  (волноваться, колыхаться, плескаться)."
    },
    {
    id: "1448",
    title: "Барыдас",
    text: "биир күдьүстүк, улаханнык харылыы тыаһыыр (производящий беспрерывный шум, рокот)."
    },
    {
    id: "1449",
    title: "Содуом",
    text: "туохтан эмэ сылтаан дьону  уонна  атын  малы  даҕаны  харса суох  кырбаан,  үлтү  сынньан  барыы (дебош,  погром)."
    },
    {
    id: "1450",
    title: "Талаан",
    text: "дьол-соргу  тос-хойуута, туохха эмэ табыллыы, сатаныы (счастье, удача, везение, желательный исход дела)."
    },
    {
    id: "1451",
    title: "Сэмэ-суҥха",
    text: "сөрсөөбөттүк мөҕүү-этии,  буруйдааһын,  элбэх  саҥалаах-иҥэлээх  хомуруйуу (осуждение, обвинение, порицание со многими упреками,  бранными  нападками)."
    },
    {
    id: "1452",
    title: "Күөмчүлээ",
    text: "ким,  туох эмэ көҥүлүн кыһарый, баттаа, тууй-хаай (притеснять,  угнетать  кого-л.,  огра-ничивать  чью-л.  свободу)."
    },
    {
    id: "1453",
    title: "Дьулай",
    text: "туох эмэ үрдээн  көстөөччү саамай  төбөтө,  оройо (верхушка,  макушка  чего-л.)."
    },
    {
    id: "1454",
    title: "Кэҥсэ",
    text: "кыра аһылыкка сөп буолбат, элбэҕи сиир-аһыыр (ненасытный, прорва, обжора)."
    },
    {
    id: "1455",
    title: "Таллан таас",
    text: "норуот айымньытыгар улахан, кытаанах, ньыгыл оройу ойуулаан этии (отборно крепкая макушка (в устном народном творчестве:  постоянный  эпитет  большой крепкой головы)."
    },
    {
    id: "1456",
    title: "Төлөн",
    text: "туох  эмэ умайыыта, умайан уот буолан көстүүтэ (огонь,  пламя)."
    },
    {
    id: "1457",
    title: "Күдээрий",
    text: "салгыҥҥа өрө көтөн өрүкүйэн таҕыс, бургучуй (подниматься, клубиться).  "
    },
    {
    id: "1458",
    title: "Уорук",
    text: "улахан,  киэҥ-куоҥ, үчүгэй тэриллээх олорор дьиэ (большой,  просторный,  хорошо  обставленный дом)."
    },
    {
    id: "1459",
    title: "Өксөкү кыыл",
    text: "икки эбэтэр үс төбөлөөх хотойдуҥу көтөр (двуглавая или трехглавая мифическая птица, похожая на орла). "
    },
    {
    id: "1460",
    title: "Дьирибинээ",
    text: " түргэн-түргэнник  тэлибирии-илибирии  хамсаа (трепетать, мелко дрожать, биться)."
    },
    {
    id: "1461",
    title: "Күдэн",
    text: "тунааран көстүү, туманнырыы; буор-сыыс, буруо хойуутук көтүүтэ (легкий туман, мгла, марево).  "
    },
    {
    id: "1462",
    title: "Үөлэс",
    text: "саха көмүлүөк оһоҕун буруо, төлөн тахсар турбата (дымовая труба камелька – якутской печи)."
    },
    {
    id: "1463",
    title: "Үүт",
    text: "тугу  эмэ  курдаттыы тахсар  эбэтэр  анаан  хаһан  оҥоһуллубут хайаҕас, дьөлөҕөс (дыра, проём или специально сделанное в чём-л. отверстие)."
    },
    {
    id: "1464",
    title: "Сурулаа",
    text: "быстыбакка сытыытык биир кэм “сурр” гынан тыаһаа (производить непрерывный шум при быстром скольжении, стремительном падении с высоты)."
    },
    {
    id: "1465",
    title: "Килэҥсэ",
    text: "ньалҕаархай сырдаан көстөр ньуурдаах (блестящий, гладкий)."
    },
    {
    id: "1466",
    title: "Халбарый",
    text: "оннугуттан хамсаа, сыҕарый, тэйэн биэр (отодвинуться, посторониться,  переместиться)."
    },
    {
    id: "1467",
    title: "Үөл",
    text: "хата-иинэ  илик,  сүмэһинин, сиигин ыһыктыбакка дьиҥ бэйэтинэн сылдьар (не потерявший  свежести,  сырой,  влажный)."
    },
    {
    id: "1468",
    title: "Ньаассын = ньаарсын",
    text: "сыыйыллаҕас сымнаҕас, чараас, намчы (мягкий, пушистый, тонкий и нежный)."
    },
    {
    id: "1469",
    title: "Курбуҥ = кургум",
    text: "киһи курданара, биилэ (талия, поясница)."
    },
    {
    id: "1470",
    title: "Хорҕолдьун",
    text: "үрүҥ  көмүстүҥү  дьүһүннээх  дьэбиннирбэт,  тапталлымтыа  сымнаҕас  чэпчэки  ыйааһыннаах металл (олово).  "
    },
    {
    id: "1471",
    title: "Татыйык",
    text: "барабыайдар этэрээттэригэр киирсэр эриэн дьүһүннээх кыра ырыаһыт чыычаах (синица)."
    },
    {
    id: "1472",
    title: "Симэһин",
    text: "киһи-сүөһү  сорох уорганнарын  быччархайдара  таһаарар ньолҕорхой ураты бэссэстибэлэрэ эбэтэр киһи-сүөһү, үүнээйи килиэккэлэрин быыстарынааҕы убаҕас бэссэстибэ (вещество,  вырабатываемое  клетками  различных желёз организма, или жидкость, содержащаяся в клетках растений и животных, сок)."
    },
    {
    id: "1473",
    title: "Үөрбэ",
    text: "уһуктаах синньигэс мас эбэтэр тимир (заостренный кол, шест, рожон)."
    },
    {
    id: "1474",
    title: "Үҥкүрүс-күөлэһис",
    text: "сиргэ  сытан баран, эргичиҥнээн, төкүнүҥнээн сыҕарый (кататься, перекатываться, валяться на чём-л.)."
    },
    {
    id: "1475",
    title: "Ини-бии",
    text: "бииргэ төрөөбүт убайдыы быраат (родные братья)."
    },
    {
    id: "1476",
    title: "Өлүүнньүк = өлүнньүк",
    text: "өлбүт киһиэхэ кэтэрдэр таҥас (посмертный, погребальный наряд)."
    },
    {
    id: "1477",
    title: "Балталаа",
    text: "балтанан оҕус; эллээ (бить большим молотком; ковать)."
    },
    {
    id: "1478",
    title: "Кылбардаа",
    text: "сырдыктык, чаҕылыччы тык (светиться ярко)."
    },
    {
    id: "1479",
    title: "Таныы",
    text: "мурун үүтэ, көҥдөйө, аллараа кырыыта (ноздря, ноздри)."
    },
    {
    id: "1480",
    title: "Уллуҥах",
    text: "киһи атаҕын алын өттө, үктэнэр, тирэнэр сирэ (стопа ног у человека)."
    },
    {
    id: "1481",
    title: "Үөлэс",
    text: "саха көмүлүөк оһоҕун буруо, төлөн тахсар турбата (дымовая труба камелька – якутской печи)."
    },
    {
    id: "1482",
    title: "Үөрбэ",
    text: "уһуктаах синньигэс мас эбэтэр тимир (заостренный кол, шест, рожон)."
    },
    {
    id: "1483",
    title: "Сөксөй",
    text: "көппөччү, үллэччи кыстаммыт, ууруллубут курдук буолан көһүн (казаться большим, пушистым, рыхлым)"
    },
    {
    id: "1484",
    title: "Үлүһүй",
    text: "тугу эмэ олус кэрэхсээн, умсугуйан, тартаран туран оҥор, гын (делать что-либо увлеченно, азартно с огоньком)."
    },
    {
    id: "1485",
    title: "Суодаҕыс=суодай",
    text: "үрдүк, күлүктээх көрүҥнээх буол (быть, казаться крупным, большим, иметь внушительный рост)."
    },
    {
    id: "1486",
    title: "Киҥкиниир",
    text: "түгэҕэ көстүбэт, бардар бара турар бараммат киэҥ (бескрайняя, бесконечно расширяющаяся)."
    },
    {
    id: "1487",
    title: "Дьалын=дьалыҥ",
    text: "туох эмэ киһи өйүн-санаатын абылыыр, өрүкүтэр күүһэ, омуна (сильный порыв, страсть, охватывающие человека без остатка, полностью)."
    },
    {
    id: "1488",
    title: "Холумтан",
    text: "саха оһоҕун иннигэр уот отторго, ас буһарарга анаан буорунан симэн оҥоһуллубут үрдэтии (место для разведения огня, очаг, шесток (у камелька, печи))."
    },
    {
    id: "1489",
    title: "Торҕо сиигин сииктээ",
    text: "төрдүгэр-төбөтүгэр тиийэ ымпыктаан-чымпыктаан быһааран бил (уяснить что-либо основательно, до конца)."
    },
    {
    id: "1490",
    title: "Салахай = чалахай",
    text: "айахтан, мурунтан тахсар сынньылхай, хойуу убаҕас, салыҥ (тягучая слизь)."
    },
    {
    id: "1491",
    title: "Куорма",
    text: "оҥочо кутурук салайар эрдиитэ (кормовое весло)."
    },
    {
    id: "1492",
    title: "Сүрдьүү = сүрдьүгэс",
    text: "баҕанаттан баҕана үүтүгэр анньан, бутэй аанын сабар уһун сиэрдийэ мас (длинная жердь, которая вставляется в прорубленные отверстия на столбах изгороди и используется в качестве входных ворот)."
    },
    {
    id: "1493",
    title: "Өлбүргэ",
    text: "түүлээх тириитин уорҕатын кэлин диэки өттө (огузок, шкурка с задней части животного)."
    },
    {
    id: "1494",
    title: "Тордох",
    text: "туох эмэ умайарыгар  ситэри  күл  буолбакка  буруону кытта тахсыһар хоруо (копоть). "
    },
    {
    id: "1495",
    title: "Хоҥоруу = хоҥуруу",
    text: "мурун  кырыыта, сиһэ (переносица)."
    },
    {
    id: "1496",
    title: "Чымыдаал",
    text: "чымадаан (чемодан)."
    },
    {
    id: "1497",
    title: "Күдэрик",
    text: "халлаан, ыраах көстөр саҕах туманнаах, буруолаах буолан көстүүтэ (легкий дым, туман)."
    },
    {
    id: "1498",
    title: "Туона",
    text: "туох эмэ киэҥ нэлэмэн ньуура, дуол (обширное пространство, простор)."
    },
    {
    id: "1499",
    title: "Мэҥий",
    text: "күүскэ эппэҥнээн тыын, аҕылаа эбэтэр үөскүн тартарар курдук тыын (хватать ртом воздух, задыхаться)."
    },
    {
    id: "1500",
    title: "Арҕары=арҕар",
    text: "киэҥ сирдэринэн сырыт, сири-дойдуну элбэхтик кэрий, тилэ сүүр (побывать во многих местах, исходить повсюду вдоль и поперек)."
    },
    {
    id: "1501",
    title: "Саппах",
    text: "күн,  халлаан сырдыгын сабан күлүгүрдэр былыт, туман эбэтэр атын туох эмэ (облака, туман или что-л. другое, застилающее небо и затеняющее солнце)."
    },
    {
    id: "1502",
    title: "Тоһуу",
    text: "туох эмэ арыллыбыт, сырдаабыт быыһа (освещенная чем-либо часть чего-либо)."
    },
    {
    id: "1503",
    title: "Туналый",
    text: "маҥан үрүҥ буолан, туртайан көһүн (быть, казаться ослепительно, выделяться ярко-белым цветом)."
    },
    {
    id: "1504",
    title: "Дьулагыр=дьулаакыр",
    text: "адьас туга да суох (оставшийся совсем без ничего, лишенный всего)."
    },
    {
    id: "1505",
    title: "Иэримэ",
    text: "төрөөбүт-үөскээбит (родной)."
    },
    {
    id: "1506",
    title: "Сурулаа",
    text: "быстыбакка сытыытык биир кэм “сурр” гынан тыаһаа (производить непрерывный шум при быстром скольжении, стремительном падении с высоты)."
    },
    {
    id: "1507",
    title: "Сыппай сиэллээх=сыспай сиэллээх",
    text: "сылгы сүөһү, сылгы сыыйыллаҕас уһун сиэллээҕин хоһуйан этии (лошадь, табун лошадей, букв. животное с длинной, ниспадающей густой гривой)"
    },
    {
    id: "1508",
    title: "Сүүмэх",
    text: "туох эмэ утах курдук  уһун,  синньигэс,  бэйэ-бэйэтин кытта  холбоспута,  холбуу  тутуллубута (пучок)."
    },
    {
    id: "1509",
    title: "Айгыр силик",
    text: "сиппит хоппут, муҥутаабыт, күөҕүнэн симэммит (покрытая густой зеленью, разукрашенная роскошным зеленым ковром)."
    },
    {
    id: "1510",
    title: "Дьаҕадый=дьаҕыдый",
    text: "үөрэтэр өйдөтөр курдук саҥар (говорить нарицательно)."
    },
    {
    id: "1511",
    title: "Ситии",
    text: "сылгы сиэлинэн хатыллыбыт синньигэс быа (тонкая веревка, витая из конского грива).                        "
    },
    {
    id: "1512",
    title: "Хорҕот",
    text: " туохтан эмэ хаххалатан саһыар, бүччүм сири булан тохтот (дать укрыться, прятаться; искать укромное место).                                      "
    },
    {
    id: "1513",
    title: "Хоодьдьук = хоолдьук",
    text: "моой (шея в области первого позвонка)."
    },
    {
    id: "1514",
    title: "Эбир-дьаҕыл",
    text: "биир күрүс баһыйар өҥтөн уратыланар элбэх чуоҕурдаах, бээтинэлээх (имеющий множество пятен, крапин другого цвета по отношению к основной окраске, пестрый, крапчатый)."
    },
    {
    id: "1515",
    title: "Дэлбиргэ",
    text: "маҥан сылгы сиэлиттэн оҥоһуллубут быа (веревка из белой конской гривы). "
    },
    {
    id: "1516",
    title: "Дьаралык",
    text: "туох эмэ сыдьаана, кэрэтэ, өрөгөйө (блеск, ореол, прелесть кого-чего-либо)."
    },
    {
    id: "1517",
    title: "Кэриэн",
    text: "кэрэмэн, кэрэ (прекрасный, отменный)."
    },
    {
    id: "1518",
    title: "Саалыр",
    text: "харатыҥы сиэллээх, кутуруктаах, сиһэ туртаҕар, кытархайдыҥы саһархай бороҥ (светло-рыжий с черным хвостом и гривой, буланый)."
    },
    {
    id: "1519",
    title: "Күрэҥ",
    text: "кытарымтыйан көстөр бороҥ (бурый, красноватый; мышастый)."
    },
    {
    id: "1520",
    title: "Дьанысханнаах",
    text: "ордук күүскэ дьаныйан туран (особенно упорствовать, усердствовать в чем-либо)."
    },
    {
    id: "1521",
    title: "Модьоҕо",
    text: "аан боруога (порог)."
    },
    {
    id: "1522",
    title: "Эскэл",
    text: "этиргэн, толору эттээх-сииннээх, модьу-таҕа көрүҥнээх (тучный, толстый, жирный)."
    },
    {
    id: "1523",
    title: "Көмөр",
    text: "мас умуллубут чоҕо (почерневший остывший древесный уголь).."
    },
    {
    id: "1524",
    title: "Күдэн",
    text: "тунааран көстүү, туманнырыы; буор-сыыс, буруо хойуутук көтүүтэ (легкий туман, мгла, марево)."
    },
    {
    id: "1525",
    title: "Үтүмэх",
    text: "муҥханы муус аннынан соһон ойбонтон ойбоҥҥо тиэрдэргэ туттуллар уһун ураҕас (прогонная жердь, к которой привязывается конец длинного ремня, прикрепленного другим концом к крылу невода, и которую норилом проводят из проруби в прорубь, при подледном рыболовстве)."
    },
    {
    id: "1526",
    title: "Куруҥ",
    text: "өрт уотугар умайбыт тыа (выжженный лес)."
    },
    {
    id: "1527",
    title: "Сарбынньахтаах",
    text: "кытыыта биир тэҥник кэрдиистэнэ бысталанан киэргэтиллибитэ (украшенный зубчатой резьбой, зубчатым украшением)."
    },
    {
    id: "1528",
    title: "Илбиргэс",
    text: "туохха эмэ ыйанан эйэҥэлии сылдьар киэргэл (небольшое подвесное украшение, подвеска). "
    },
    {
    id: "1529",
    title: "Туоһахта",
    text: "сүөһү сүүһүгэр баар маҥан бээтинэ (святлое пятно на лбу)."
    },
    {
    id: "1530",
    title: "Осхордьут = осхор",
    text: "икки салаалаах тимир уһуктаах айа оноҕоһо, ырба (стрела с железным вилообразным наконечником для охотничьего самострела)."
    },
    {
    id: "1531",
    title: "Тыҥкырайдьыт=тыҥкырай",
    text: "кыра тырыыҥка (мелкая лучина)."
    },
    {
    id: "1532",
    title: "Саамал кымыс",
    text: "саамыламмыт, көөнньүбүтүн кэннэ атын улахан иһиккэ мунньан, сөрүүҥҥэ туруоран, астытан иһэргэ бэлэмнэммит кымыс (уже дошедший до кондиции, постепенно сливаемый в большой сосуд для смешивания и охлаждения, лучшего качества кумыс)."
    },
    {
    id: "1533",
    title: "Көйүү = көйөргө",
    text: "кымыс аһытыыта (кумысная закваска)."
    },
    {
    id: "1534",
    title: "Суомас",
    text: "дуобат."
    },
    {
    id: "1535",
    title: "Мохсуо",
    text: "анал бэрээдэгинэн ууруллубут кэрчик мастары таба быраҕаттаан, сурааһын таһыгар таһаарар күрэх оонньуу (спортивная игра «городки»)."
    },
    {
    id: "1536",
    title: "Үлүскэннээх",
    text: "күүрээннээх, күүстээх эрчимнээх (вдохновенный, упорный, напряженный)."
    },
    {
    id: "1537",
    title: "Адарай",
    text: "синньигэс (тонкий)."
    },
    {
    id: "1538",
    title: "Одун",
    text: "улуу, модун, дьолуо (величественный, мощный)."
    },
    {
    id: "1539",
    title: "Биллэрик",
    text: "саха балаҕаныгар киирэр ааны утары эркиҥҥэ сыста турар наара орон (лавка, расположенная вдоль противоположной стены от входа в якутскую юрту)."
    },
    {
    id: "1540",
    title: "Дьэрэксээн=дьэрэкээн",
    text: "эҥин араас өҥнөөх, дьүһүннээх, ала-эриэн ойуулаах (ярко-пестрый, цветастый, со всевозможными узорами, узорчатый)."
    },
    {
    id: "1541",
    title: "Чыҥырҕастаах сыттык",
    text: "кырыыларыгар хатан тыаһы таһаарар үрүҥ көмүстэрдээх сыттык (подушка с металлическими погремушками из серебряных пластинок по краям)."
    },
    {
    id: "1542",
    title: "Оҕорҕоо",
    text: "олус сөбүлээ, атыттартан ордор (особо привязаться, испытывать особую любовь)."
    },
    {
    id: "1543",
    title: "Куомньалык=куонньалык",
    text: "ох саа хаата, саадах (налучник, чехол для лука)."
    },
    {
    id: "1544",
    title: "Адарай",
    text: "арыттаах гына хаптаһынан, маһынан тэлгэтиллибит (застланный жердями, неровными досками, дощатый)."
    },
    {
    id: "1545",
    title: "Иҥнэстэн=иҥнэй",
    text: "ойоҕоһун диэки намтаан бар (крениться, давать крен)."
    },
    {
    id: "1546",
    title: "Тамыйах",
    text: "торбос (теленок)."
    },
    {
    id: "1547",
    title: "Тиҥэһэ",
    text: "үһүгэр сылдьар, үс саастаах дьиэ сүөһүтэ (молодняк крупного рогатого и конского скота на третьем году жизни)."
    },
    {
    id: "1548",
    title: "Холлоҕос",
    text: "балаҕан эбэтэр хотон эркинин биир маһа – өһүөҕэ сыһыары иҥнэри ууруллубут мас, бэрэбинэ (одно из бревен в срубе хлева, юрты, которое одним концом вбивается в землю, а другим, верхним упирается наклонно в матицу)."
    },
    {
    id: "1549",
    title: "Таныы",
    text: "мурун үүтэ, көҥдөйө, аллараа кырыыта (ноздря, ноздри)."
    },
    {
    id: "1550",
    title: "Үтүгэн",
    text: "дьон олорбот түҥкүтэх ыраах сирэ, сис дойду (неизвестная даль). "
    },
    {
    id: "1551",
    title: "Өрөһө",
    text: "киһи, сүөһү түөһүн-иһин көҥдөйдөрүн араарар чараас быччыҥ быыс (диафрагма)."
    },
    {
    id: "1552",
    title: "Арыҥах",
    text: "силиһэ түөрүллэн иҥнэри түспүт мас (вывороченное с корнем дерево)."
    },
    {
    id: "1553",
    title: "Сыһыы",
    text: "от үүнэр сииктээх киэҥ хонуу сир (широкая равнина, луг, долина)."
    },
    {
    id: "1554",
    title: "Сыһаҕастаа",
    text: "туох эмэ улаханы, ыараханы соһуолаан сыҕарыт (тащит, волочить что-либо тяжелое)."
    },
    {
    id: "1555",
    title: "Өрөҕө",
    text: "хамсыыр харамай иһин тириитэ (брюшка, брюшина).."
    },
    {
    id: "1556",
    title: "Төһүү",
    text: "туох эмэ ыараханы олуйан өрө көтөҕөргө туттуллар туох эмэ, олуур (приспособление для поднятия тяжести при помощи меньшей силы, рычаг)"
    },
    {
    id: "1557",
    title: "Үҥкүрүй",
    text: "сиргэ сытан баран, эргичиҥнээн, төкүнүҥнээн сыҕарый (кататься, перекатываться, валяться на чем-либо)."
    },
    {
    id: "1558",
    title: "Сэлиэнэй",
    text: "чэй иһэр иһит, чааскы (чашка (фарфоровая))."
    }
]